import { gql } from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An RFC-3339 compliant DateTime Scalar */
  DateTime: any;
  /** Geodata in JSON format */
  GeoJSON: any;
  /** GraphQL JSON */
  GraphQLJSON: any;
  /** JSON-LD is a lightweight Linked Data format. */
  JSONLD: any;
  /** JSON Schema is a powerful type for validating the structure of JSON data */
  JSONSchema: any;
  /** A 64-bit signed integer */
  Long: any;
  Map: any;
  /** A Url scalar */
  Url: any;
};











export type ApiKey = {
  __typename?: 'APIKey';
  apiKey?: Maybe<Scalars['String']>;
  keyName?: Maybe<Scalars['String']>;
  passedAs?: Maybe<Scalars['String']>;
};

export type ApiKeyInput = {
  apiKey?: Maybe<Scalars['String']>;
  keyName?: Maybe<Scalars['String']>;
  passedAs?: Maybe<Scalars['String']>;
};

export type AccessCredential = GraphNode & {
  __typename?: 'AccessCredential';
  connectedDataSourceId?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  exactType?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  identities?: Maybe<Array<Maybe<AccessCredentialIdentityUnion>>>;
  mappingKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AccessCredentialFilter = {
  and?: Maybe<Array<Maybe<AccessCredentialFilter>>>;
  connectedDataSourceId?: Maybe<StringFilterExpressionInput>;
  dateCreated?: Maybe<TimestampFilterExpressionInput>;
  dateUpdated?: Maybe<TimestampFilterExpressionInput>;
  exactType?: Maybe<StringFilterExpressionInput>;
  id?: Maybe<IdFilterExpressionInput>;
  mappingKey?: Maybe<StringFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  not?: Maybe<AccessCredentialFilter>;
  or?: Maybe<Array<Maybe<AccessCredentialFilter>>>;
  type?: Maybe<StringArrayFilterExpressionInput>;
};

export type AccessCredentialIdentity = AccessCredentialIdentityModel & Identity & {
  __typename?: 'AccessCredentialIdentity';
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<ScopeKey>;
  scopeId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type AccessCredentialIdentityModel = {
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<ScopeKey>;
  scopeId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type AccessCredentialIdentityUnion = AccessCredentialIdentity;

export type Account = GraphNode & {
  __typename?: 'Account';
  connectedDataSourceId?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  exactType?: Maybe<Scalars['String']>;
  hasBill?: Maybe<Array<Maybe<Point>>>;
  hasBillEdges?: Maybe<Array<Maybe<HasBillEdge>>>;
  hasProvider?: Maybe<Array<Maybe<Organization>>>;
  hasProviderEdges?: Maybe<Array<Maybe<HasProviderEdge>>>;
  id: Scalars['String'];
  identities?: Maybe<Array<Maybe<AccountIdentityUnion>>>;
  mappingKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type AccountHasBillArgs = {
  filter?: Maybe<PointFilter>;
};


export type AccountHasProviderArgs = {
  filter?: Maybe<OrganizationFilter>;
};

export type AccountFilter = {
  and?: Maybe<Array<Maybe<AccountFilter>>>;
  connectedDataSourceId?: Maybe<StringFilterExpressionInput>;
  dateCreated?: Maybe<TimestampFilterExpressionInput>;
  dateUpdated?: Maybe<TimestampFilterExpressionInput>;
  exactType?: Maybe<StringFilterExpressionInput>;
  id?: Maybe<IdFilterExpressionInput>;
  mappingKey?: Maybe<StringFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  not?: Maybe<AccountFilter>;
  or?: Maybe<Array<Maybe<AccountFilter>>>;
  type?: Maybe<StringArrayFilterExpressionInput>;
};

export type AccountIdentityUnion = AccessCredentialIdentity | BaCnetObjectId | BaCnetVendorId | EmailAddressIdentity | EmailIdentity | ExternalIdentity | FloorLevelIdentity | GenericIdentity | NameIdentity | PostalAddressIdentity | SpaceCode | SubBuildingCode;

export type Address = {
  __typename?: 'Address';
  countryName?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  locality?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
};

export type AddressFilter = {
  and?: Maybe<Array<Maybe<AddressFilter>>>;
  not?: Maybe<AddressFilter>;
  or?: Maybe<Array<Maybe<AddressFilter>>>;
};

export type AddressMutation = {
  __typename?: 'AddressMutation';
  countryName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  locality?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
  validate?: Maybe<Scalars['Boolean']>;
};

export type AddressMutationInput = {
  countryName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  locality?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
  validate?: Maybe<Scalars['Boolean']>;
};

export type Agent = GraphNode & {
  __typename?: 'Agent';
  connectedDataSourceId?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  exactType?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  identities?: Maybe<Array<Maybe<AgentIdentityUnion>>>;
  mappingKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AgentFilter = {
  and?: Maybe<Array<Maybe<AgentFilter>>>;
  connectedDataSourceId?: Maybe<StringFilterExpressionInput>;
  dateCreated?: Maybe<TimestampFilterExpressionInput>;
  dateUpdated?: Maybe<TimestampFilterExpressionInput>;
  exactType?: Maybe<StringFilterExpressionInput>;
  id?: Maybe<IdFilterExpressionInput>;
  mappingKey?: Maybe<StringFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  not?: Maybe<AgentFilter>;
  or?: Maybe<Array<Maybe<AgentFilter>>>;
  type?: Maybe<StringArrayFilterExpressionInput>;
};

export type AgentIdentityUnion = AccessCredentialIdentity | BaCnetObjectId | BaCnetVendorId | EmailAddressIdentity | EmailIdentity | ExternalIdentity | FloorLevelIdentity | GenericIdentity | NameIdentity | PostalAddressIdentity | SpaceCode | SubBuildingCode;

export type AreaQuantity = {
  __typename?: 'AreaQuantity';
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  quantity?: Maybe<Scalars['Float']>;
  unit?: Maybe<Unit>;
};

export type AreaQuantityFilter = {
  and?: Maybe<Array<Maybe<AreaQuantityFilter>>>;
  not?: Maybe<AreaQuantityFilter>;
  or?: Maybe<Array<Maybe<AreaQuantityFilter>>>;
};

export type Auth = {
  __typename?: 'Auth';
  and?: Maybe<Array<Maybe<Auth>>>;
  matches?: Maybe<Array<Maybe<Match>>>;
  not?: Maybe<Array<Maybe<Auth>>>;
  or?: Maybe<Array<Maybe<Auth>>>;
};

export type AuthInput = {
  and?: Maybe<Array<Maybe<AuthInput>>>;
  matches?: Maybe<Array<Maybe<MatchInput>>>;
  not?: Maybe<Array<Maybe<AuthInput>>>;
  or?: Maybe<Array<Maybe<AuthInput>>>;
};

/** The list of available authorization modes */
export enum AuthMode {
  Pat = 'PAT'
}

export type BaCnetObjectId = BaCnetObjectIdModel & Identity & {
  __typename?: 'BACnetObjectId';
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<ScopeKey>;
  scopeId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type BaCnetObjectIdModel = {
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<ScopeKey>;
  scopeId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type BaCnetVendorId = BaCnetVendorIdModel & Identity & {
  __typename?: 'BACnetVendorId';
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<ScopeKey>;
  scopeId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type BaCnetVendorIdModel = {
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<ScopeKey>;
  scopeId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type BasicAuth = {
  __typename?: 'BasicAuth';
  password?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type BasicAuthInput = {
  password?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type BillingCalculatedProductBundleResponse = {
  __typename?: 'BillingCalculatedProductBundleResponse';
  calculation?: Maybe<BillingCalculationResponse>;
  code?: Maybe<Scalars['Long']>;
  productBundle?: Maybe<ProductBundleResponse>;
  productSlug?: Maybe<Scalars['String']>;
  statusMessage?: Maybe<Scalars['String']>;
};

export type BillingCalculationResponse = {
  __typename?: 'BillingCalculationResponse';
  fixedPrice?: Maybe<Scalars['Long']>;
  itemSlug?: Maybe<Scalars['String']>;
  overagePrice?: Maybe<Scalars['Long']>;
  productPriceItem?: Maybe<ProductPriceItemResponse>;
  quantity?: Maybe<Scalars['Long']>;
  unitPrice?: Maybe<Scalars['Long']>;
};

export type BillingProductBundleSubscriptionResponse = {
  __typename?: 'BillingProductBundleSubscriptionResponse';
  productBundle?: Maybe<BillingCalculatedProductBundleResponse>;
  subscriptionId?: Maybe<Scalars['String']>;
};

export type BodyValueLocation = {
  __typename?: 'BodyValueLocation';
  bodySource?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
};

export type BodyValueLocationInput = {
  bodySource?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
};

export type BoolFilterExpressionInput = {
  eq?: Maybe<Scalars['Boolean']>;
  isDefined?: Maybe<Scalars['Boolean']>;
};

/** Contains all the details of a building. */
export type Building = GraphNode & Place & ThingContainer & {
  __typename?: 'Building';
  /** The address of a building, contains fields that support international addresses. */
  address?: Maybe<Address>;
  calendarEvents?: Maybe<Array<Maybe<CalendarEvent>>>;
  collections?: Maybe<Array<Maybe<Collection>>>;
  connectedDataSourceId?: Maybe<Scalars['String']>;
  /** Any connectors configured for a building will be listed here. */
  connectors?: Maybe<Array<Maybe<Connector>>>;
  /** This timestamp represents the date the building was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** This timestamp represents that date the building was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The description of a building; often left blank, especially if the building name is already descriptive. */
  description?: Maybe<Scalars['String']>;
  /** The exactType is the most granular Brick Schema Location type defined for this building. */
  exactType?: Maybe<Scalars['String']>;
  /** All the floors present in a building will be listed here. */
  floors?: Maybe<Array<Maybe<Floor>>>;
  geolocation?: Maybe<GeoPointQuantity>;
  geolocationEdges?: Maybe<Array<Maybe<GeolocationEdge>>>;
  grossArea?: Maybe<AreaQuantity>;
  grossAreaEdges?: Maybe<Array<Maybe<GrossAreaEdge>>>;
  hasPart?: Maybe<Array<Maybe<Place>>>;
  hasPartEdges?: Maybe<Array<Maybe<HasPartEdge>>>;
  /** In some limited scenarios, a point may be associated with a building as opposed to a thing, like a building electrical meter. Those details will be provided here. */
  hasPoint?: Maybe<Array<Maybe<Point>>>;
  hasPointEdges?: Maybe<Array<Maybe<HasPointEdge>>>;
  /** The unique ID of a building. */
  id: Scalars['String'];
  identities?: Maybe<Array<Maybe<BuildingIdentityUnion>>>;
  isAdjacentTo?: Maybe<Array<Maybe<Place>>>;
  isAdjacentToEdges?: Maybe<Array<Maybe<IsAdjacentToEdge>>>;
  isFedBy?: Maybe<Array<Maybe<Thing>>>;
  isFedByEdges?: Maybe<Array<Maybe<IsFedByEdge>>>;
  /** Superset of anything that could be in a building - a thing, a person, a meeting (people and meetings currently in development). */
  isLocationOf?: Maybe<Array<Maybe<IsLocationOfUnion>>>;
  isLocationOfEdges?: Maybe<Array<Maybe<IsLocationOfEdge>>>;
  /** This contains the next level up in the place hierarchy; for a building, this will contain site information. */
  isPartOf?: Maybe<Array<Maybe<Place>>>;
  isPartOfEdges?: Maybe<Array<Maybe<IsPartOfEdge>>>;
  isServedBy?: Maybe<Array<Maybe<Thing>>>;
  isServedByEdges?: Maybe<Array<Maybe<IsServedByEdge>>>;
  mappingKey?: Maybe<Scalars['String']>;
  /** The name of a building; often just the street address. */
  name?: Maybe<Scalars['String']>;
  /** Any of the points available inside a building will be listed here. */
  points?: Maybe<Array<Maybe<Point>>>;
  rentableArea?: Maybe<AreaQuantity>;
  rentableAreaEdges?: Maybe<Array<Maybe<RentableAreaEdge>>>;
  /** The site associated with a building. */
  sites?: Maybe<Array<Maybe<Site>>>;
  spaces?: Maybe<Array<Maybe<Space>>>;
  subBuildings?: Maybe<Array<Maybe<SubBuilding>>>;
  /** All the things associated with a building, or any floor or space in the building, will show here. */
  things?: Maybe<Array<Maybe<Thing>>>;
  timeZone?: Maybe<Scalars['String']>;
  /** Type includes all possible hierarchal types for the building, such as "Place" and "Building". */
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
  usableArea?: Maybe<AreaQuantity>;
  usableAreaEdges?: Maybe<Array<Maybe<UsableAreaEdge>>>;
  zones?: Maybe<Array<Maybe<Zone>>>;
};


/** Contains all the details of a building. */
export type BuildingCalendarEventsArgs = {
  filter?: Maybe<CalendarEventFilter>;
};


/** Contains all the details of a building. */
export type BuildingCollectionsArgs = {
  filter?: Maybe<CollectionFilter>;
};


/** Contains all the details of a building. */
export type BuildingConnectorsArgs = {
  filter?: Maybe<ConnectorFilterInput>;
};


/** Contains all the details of a building. */
export type BuildingFloorsArgs = {
  filter?: Maybe<FloorFilter>;
};


/** Contains all the details of a building. */
export type BuildingGeolocationArgs = {
  filter?: Maybe<GeoPointQuantityFilter>;
};


/** Contains all the details of a building. */
export type BuildingGrossAreaArgs = {
  filter?: Maybe<AreaQuantityFilter>;
};


/** Contains all the details of a building. */
export type BuildingHasPartArgs = {
  filter?: Maybe<PlaceFilter>;
};


/** Contains all the details of a building. */
export type BuildingHasPointArgs = {
  filter?: Maybe<PointFilter>;
};


/** Contains all the details of a building. */
export type BuildingIsAdjacentToArgs = {
  filter?: Maybe<PlaceFilter>;
};


/** Contains all the details of a building. */
export type BuildingIsFedByArgs = {
  filter?: Maybe<ThingFilter>;
};


/** Contains all the details of a building. */
export type BuildingIsLocationOfArgs = {
  filter?: Maybe<EntityFilter>;
};


/** Contains all the details of a building. */
export type BuildingIsPartOfArgs = {
  filter?: Maybe<PlaceFilter>;
};


/** Contains all the details of a building. */
export type BuildingIsServedByArgs = {
  filter?: Maybe<ThingFilter>;
};


/** Contains all the details of a building. */
export type BuildingPointsArgs = {
  filter?: Maybe<PointFilter>;
};


/** Contains all the details of a building. */
export type BuildingRentableAreaArgs = {
  filter?: Maybe<AreaQuantityFilter>;
};


/** Contains all the details of a building. */
export type BuildingSitesArgs = {
  filter?: Maybe<SiteFilter>;
};


/** Contains all the details of a building. */
export type BuildingSpacesArgs = {
  childDepth?: Maybe<Scalars['Int']>;
  filter?: Maybe<SpaceFilter>;
};


/** Contains all the details of a building. */
export type BuildingSubBuildingsArgs = {
  filter?: Maybe<SubBuildingFilter>;
};


/** Contains all the details of a building. */
export type BuildingThingsArgs = {
  filter?: Maybe<ThingFilter>;
};


/** Contains all the details of a building. */
export type BuildingUsableAreaArgs = {
  filter?: Maybe<AreaQuantityFilter>;
};


/** Contains all the details of a building. */
export type BuildingZonesArgs = {
  filter?: Maybe<ZoneFilter>;
};

export type BuildingCreateRequestInput = {
  building?: Maybe<BuildingMutationInput>;
};

export type BuildingCreateResponse = {
  __typename?: 'BuildingCreateResponse';
  building?: Maybe<BuildingMutation>;
};

export type BuildingDeleteRequestInput = {
  id?: Maybe<Scalars['String']>;
};

export type BuildingDeleteResponse = {
  __typename?: 'BuildingDeleteResponse';
  _?: Maybe<Scalars['String']>;
};

/** Contains the input values needed to filter building queries. */
export type BuildingFilter = {
  /** Used to combine multiple filter criteria. */
  and?: Maybe<Array<Maybe<BuildingFilter>>>;
  connectedDataSourceId?: Maybe<StringFilterExpressionInput>;
  dateCreated?: Maybe<TimestampFilterExpressionInput>;
  dateUpdated?: Maybe<TimestampFilterExpressionInput>;
  exactType?: Maybe<StringFilterExpressionInput>;
  /** Used to filter for a specific ID or IDs (refer to IDFilterExpressionInput for input options). */
  id?: Maybe<IdFilterExpressionInput>;
  mappingKey?: Maybe<StringFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  /** Used to omit a specific result or results from the response. */
  not?: Maybe<BuildingFilter>;
  /** Used to return results that match at least one of the defined criteria. */
  or?: Maybe<Array<Maybe<BuildingFilter>>>;
  type?: Maybe<StringArrayFilterExpressionInput>;
};

export type BuildingIdentityUnion = AccessCredentialIdentity | BaCnetObjectId | BaCnetVendorId | EmailAddressIdentity | EmailIdentity | ExternalIdentity | FloorLevelIdentity | GenericIdentity | NameIdentity | PostalAddressIdentity | SpaceCode | SubBuildingCode;

export type BuildingMutation = {
  __typename?: 'BuildingMutation';
  address?: Maybe<AddressMutation>;
  /** @deprecated Field no longer supported */
  geoshape?: Maybe<Scalars['GeoJSON']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
};

export type BuildingMutationInput = {
  address?: Maybe<AddressMutationInput>;
  geoshape?: Maybe<Scalars['GeoJSON']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
};

export type BuildingUpdateRequestInput = {
  building?: Maybe<BuildingMutationInput>;
};

export type BuildingUpdateResponse = {
  __typename?: 'BuildingUpdateResponse';
  building?: Maybe<BuildingMutation>;
};

export enum BundleState {
  BundleStateActive = 'BUNDLE_STATE_ACTIVE',
  BundleStateArchived = 'BUNDLE_STATE_ARCHIVED',
  BundleStateUnspecified = 'BUNDLE_STATE_UNSPECIFIED'
}

export type CalendarEvent = Event & GraphNode & {
  __typename?: 'CalendarEvent';
  connectedDataSourceId?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['DateTime']>;
  exactType?: Maybe<Scalars['String']>;
  hasInvitations?: Maybe<Array<Maybe<CalendarInvitation>>>;
  hasInvitees?: Maybe<Array<Maybe<CalendarInvitee>>>;
  hasLocation?: Maybe<Place>;
  hasLocationEdges?: Maybe<Array<Maybe<HasLocationEdge>>>;
  id: Scalars['String'];
  identities?: Maybe<Array<Maybe<CalendarEventIdentityUnion>>>;
  mappingKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['DateTime']>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CalendarEventHasLocationArgs = {
  filter?: Maybe<PlaceFilter>;
};

export type CalendarEventFilter = {
  and?: Maybe<Array<Maybe<CalendarEventFilter>>>;
  connectedDataSourceId?: Maybe<StringFilterExpressionInput>;
  dateCreated?: Maybe<TimestampFilterExpressionInput>;
  dateUpdated?: Maybe<TimestampFilterExpressionInput>;
  endTime?: Maybe<TimestampFilterExpressionInput>;
  exactType?: Maybe<StringFilterExpressionInput>;
  hasInviteeEmail?: Maybe<StringFilterExpressionInput>;
  id?: Maybe<IdFilterExpressionInput>;
  mappingKey?: Maybe<StringFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  not?: Maybe<CalendarEventFilter>;
  or?: Maybe<Array<Maybe<CalendarEventFilter>>>;
  startTime?: Maybe<TimestampFilterExpressionInput>;
  type?: Maybe<StringArrayFilterExpressionInput>;
};

export type CalendarEventIdentityUnion = AccessCredentialIdentity | BaCnetObjectId | BaCnetVendorId | EmailAddressIdentity | EmailIdentity | ExternalIdentity | FloorLevelIdentity | GenericIdentity | NameIdentity | PostalAddressIdentity | SpaceCode | SubBuildingCode;

export type CalendarInvitation = GraphNode & {
  __typename?: 'CalendarInvitation';
  connectedDataSourceId?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  email: EmailAddress;
  event?: Maybe<CalendarEvent>;
  exactType?: Maybe<Scalars['String']>;
  hasInvitee?: Maybe<CalendarInvitee>;
  hasLocation?: Maybe<Place>;
  hasLocationEdges?: Maybe<Array<Maybe<HasLocationEdge>>>;
  id: Scalars['String'];
  identities?: Maybe<Array<Maybe<CalendarInvitationIdentityUnion>>>;
  mappingKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  response?: Maybe<CalendarInvitationResponse>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CalendarInvitationHasLocationArgs = {
  filter?: Maybe<PlaceFilter>;
};

export type CalendarInvitationFilter = {
  and?: Maybe<Array<Maybe<CalendarInvitationFilter>>>;
  dateCreated?: Maybe<DateTimeFilterExpressionInput>;
  dateUpdated?: Maybe<DateTimeFilterExpressionInput>;
  exactType?: Maybe<StringFilterExpressionInput>;
  id?: Maybe<StringFilterExpressionInput>;
  mappingKey?: Maybe<StringFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  not?: Maybe<CalendarInvitationFilter>;
  or?: Maybe<Array<Maybe<CalendarInvitationFilter>>>;
  response?: Maybe<CalendarInvitationResponseFilterExpressionInput>;
  type?: Maybe<StringArrayFilterExpressionInput>;
};

export type CalendarInvitationIdentityUnion = AccessCredentialIdentity | BaCnetObjectId | BaCnetVendorId | EmailAddressIdentity | EmailIdentity | ExternalIdentity | FloorLevelIdentity | GenericIdentity | NameIdentity | PostalAddressIdentity | SpaceCode | SubBuildingCode;

export enum CalendarInvitationResponse {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  None = 'NONE',
  Tentative = 'TENTATIVE'
}

export type CalendarInvitationResponseFilterExpressionInput = {
  eq?: Maybe<CalendarInvitationResponse>;
  in?: Maybe<Array<Maybe<CalendarInvitationResponse>>>;
};

export type CalendarInvitee = Person | Space;

export type CertMatch = {
  __typename?: 'CertMatch';
  caCerts?: Maybe<CertificateAuthorityBundle>;
  dnsName?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
};

export type CertMatchInput = {
  caCerts?: Maybe<CertificateAuthorityBundleInput>;
  dnsName?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
};

export type Certificate = {
  __typename?: 'Certificate';
  certificate?: Maybe<Scalars['String']>;
  type?: Maybe<CertificateType>;
};

export type CertificateAuthorityBundle = {
  __typename?: 'CertificateAuthorityBundle';
  caCertificates?: Maybe<Array<Maybe<Certificate>>>;
};

export type CertificateAuthorityBundleInput = {
  caCertificates?: Maybe<Array<Maybe<CertificateInput>>>;
};

export type CertificateInput = {
  certificate?: Maybe<Scalars['String']>;
  type?: Maybe<CertificateTypeInput>;
};

export enum CertificateType {
  CertificatetypeUnspecified = 'CERTIFICATETYPE_UNSPECIFIED',
  X509Cert = 'X509_CERT',
  X509Pkix = 'X509_PKIX'
}

export enum CertificateTypeInput {
  CertificatetypeUnspecified = 'CERTIFICATETYPE_UNSPECIFIED',
  X509Cert = 'X509_CERT',
  X509Pkix = 'X509_PKIX'
}

export enum CloudEventSourceType {
  CloudeventsourcetypeUnspecified = 'CLOUDEVENTSOURCETYPE_UNSPECIFIED',
  TimeseriesPoint = 'TIMESERIES_POINT'
}

export enum CloudEventSourceTypeInput {
  CloudeventsourcetypeUnspecified = 'CLOUDEVENTSOURCETYPE_UNSPECIFIED',
  TimeseriesPoint = 'TIMESERIES_POINT'
}

export type Collection = GraphNode & {
  __typename?: 'Collection';
  connectedDataSourceId?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  exactType?: Maybe<Scalars['String']>;
  feeds?: Maybe<Array<Maybe<FeedsUnion>>>;
  feedsEdges?: Maybe<Array<Maybe<FeedsEdge>>>;
  hasLocation?: Maybe<Array<Maybe<Place>>>;
  hasLocationEdges?: Maybe<Array<Maybe<HasLocationEdge>>>;
  hasPart?: Maybe<Array<Maybe<HasPartUnion>>>;
  hasPartEdges?: Maybe<Array<Maybe<HasPartEdge>>>;
  hasPoint?: Maybe<Array<Maybe<Point>>>;
  hasPointEdges?: Maybe<Array<Maybe<HasPointEdge>>>;
  id: Scalars['String'];
  identities?: Maybe<Array<Maybe<CollectionIdentityUnion>>>;
  isFedBy?: Maybe<Array<Maybe<IsFedByUnion>>>;
  isFedByEdges?: Maybe<Array<Maybe<IsFedByEdge>>>;
  mappingKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  points?: Maybe<Array<Maybe<Point>>>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CollectionFeedsArgs = {
  filter?: Maybe<EntityFilter>;
};


export type CollectionHasLocationArgs = {
  filter?: Maybe<PlaceFilter>;
};


export type CollectionHasPartArgs = {
  filter?: Maybe<EntityFilter>;
};


export type CollectionHasPointArgs = {
  filter?: Maybe<PointFilter>;
};


export type CollectionIsFedByArgs = {
  filter?: Maybe<EntityFilter>;
};


export type CollectionPointsArgs = {
  filter?: Maybe<PointFilter>;
};

export type CollectionFilter = {
  and?: Maybe<Array<Maybe<CollectionFilter>>>;
  connectedDataSourceId?: Maybe<StringFilterExpressionInput>;
  dateCreated?: Maybe<TimestampFilterExpressionInput>;
  dateUpdated?: Maybe<TimestampFilterExpressionInput>;
  exactType?: Maybe<StringFilterExpressionInput>;
  id?: Maybe<IdFilterExpressionInput>;
  mappingKey?: Maybe<StringFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  not?: Maybe<CollectionFilter>;
  or?: Maybe<Array<Maybe<CollectionFilter>>>;
  type?: Maybe<StringArrayFilterExpressionInput>;
};

export type CollectionIdentityUnion = AccessCredentialIdentity | BaCnetObjectId | BaCnetVendorId | EmailAddressIdentity | EmailIdentity | ExternalIdentity | FloorLevelIdentity | GenericIdentity | NameIdentity | PostalAddressIdentity | SpaceCode | SubBuildingCode;

/** Contains the details about a Connector. */
export type Connector = {
  __typename?: 'Connector';
  baseUrl?: Maybe<Scalars['String']>;
  buildings?: Maybe<Array<Maybe<Building>>>;
  /** Any settings required in order to create a Connector will be provided here. */
  config?: Maybe<Scalars['JSONSchema']>;
  /** Random string that identifies the current Connector configuration; if you need to update the configuration, you will need to include the current configHash value in the mutation request. */
  configHash?: Maybe<Scalars['String']>;
  /** The type/category/vendor of a Connector, such as "Weather" or "Butlr". */
  connectorType?: Maybe<ConnectorType>;
  /** The unique id of the connector type. */
  connectorTypeId?: Maybe<Scalars['String']>;
  contributions?: Maybe<Array<Maybe<ConnectorContribution>>>;
  /** Timestamp for the Connector's creation. */
  created?: Maybe<Scalars['DateTime']>;
  direction?: Maybe<ConnectorTypeConnectorDirection>;
  floors?: Maybe<Array<Maybe<Floor>>>;
  /** The unique id of a Connector. */
  id?: Maybe<Scalars['String']>;
  lastSeen?: Maybe<Scalars['DateTime']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  logs?: Maybe<Array<Maybe<ConnectorLog>>>;
  /** The name of a Connector you provided when setting it up for your org. */
  name?: Maybe<Scalars['String']>;
  /** Contains the details about the organization associated with this Connector. */
  organization?: Maybe<Org>;
  /** Lists all the points returned by the Connector. */
  points?: Maybe<Array<Maybe<Point>>>;
  runtimeVersion?: Maybe<ConnectorTypeRuntimeVersion>;
  sites?: Maybe<Array<Maybe<Site>>>;
  spaces?: Maybe<Array<Maybe<Space>>>;
  /** Lists the state of a Connector, such as ACTIVE or STOPPED. */
  state?: Maybe<ConnectorState>;
  /** Currently provides additional information about a Connector in an ERROR_GENERAL state. */
  stateDetails?: Maybe<Scalars['String']>;
  /** Lists all the things returned by the Connector. */
  things?: Maybe<Array<Maybe<Thing>>>;
  /** Timestamp when a connector was last updated. */
  updated?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
  /** This is an internal-only field; the value(s) included in this field may be requested by support for troubleshooting purposes, but otherwise holds no value for external developers. */
  workflowId?: Maybe<Scalars['String']>;
  zones?: Maybe<Array<Maybe<Zone>>>;
};


/** Contains the details about a Connector. */
export type ConnectorBuildingsArgs = {
  filter?: Maybe<BuildingFilter>;
};


/** Contains the details about a Connector. */
export type ConnectorFloorsArgs = {
  filter?: Maybe<FloorFilter>;
};


/** Contains the details about a Connector. */
export type ConnectorLogsArgs = {
  filter?: Maybe<ConnectorLogFilterInput>;
};


/** Contains the details about a Connector. */
export type ConnectorPointsArgs = {
  filter?: Maybe<PointFilter>;
};


/** Contains the details about a Connector. */
export type ConnectorSitesArgs = {
  filter?: Maybe<SiteFilter>;
};


/** Contains the details about a Connector. */
export type ConnectorSpacesArgs = {
  filter?: Maybe<SpaceFilter>;
};


/** Contains the details about a Connector. */
export type ConnectorThingsArgs = {
  filter?: Maybe<ThingFilter>;
};


/** Contains the details about a Connector. */
export type ConnectorZonesArgs = {
  filter?: Maybe<ZoneFilter>;
};

export type ConnectorAuth = {
  __typename?: 'ConnectorAuth';
  created?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastAccessed?: Maybe<Scalars['DateTime']>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type ConnectorAuthAccessRequestInput = {
  id?: Maybe<Scalars['String']>;
};

/** Contains the input values needed to create an Connector auth. */
export type ConnectorAuthCreateRequestInput = {
  secret?: Maybe<ConnectorAuthRequestSecretInput>;
};

export type ConnectorAuthCreateResponse = {
  __typename?: 'ConnectorAuthCreateResponse';
  connectorAuth?: Maybe<ConnectorAuth>;
};

/** Contains the input values needed to delete Connector auth. */
export type ConnectorAuthDeleteRequestInput = {
  id?: Maybe<Scalars['String']>;
};

export type ConnectorAuthDeleteResponse = {
  __typename?: 'ConnectorAuthDeleteResponse';
  _?: Maybe<Scalars['String']>;
};

export type ConnectorAuthInput = {
  created?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastAccessed?: Maybe<Scalars['DateTime']>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type ConnectorAuthRequestSecretInput = {
  staticToken?: Maybe<ConnectorAuthStaticTokenInput>;
  usernamePassword?: Maybe<ConnectorAuthUsernamePasswordInput>;
};

export type ConnectorAuthResponseSecret = {
  __typename?: 'ConnectorAuthResponseSecret';
  staticToken?: Maybe<ConnectorAuthStaticToken>;
  usernamePassword?: Maybe<ConnectorAuthUsernamePassword>;
};

export type ConnectorAuthStaticToken = {
  __typename?: 'ConnectorAuthStaticToken';
  token?: Maybe<Scalars['String']>;
};

export type ConnectorAuthStaticTokenInput = {
  token?: Maybe<Scalars['String']>;
};

/** Contains the input values needed to update Connector auth. */
export type ConnectorAuthUpdateRequestInput = {
  connectorAuth?: Maybe<ConnectorAuthInput>;
  secret?: Maybe<ConnectorAuthRequestSecretInput>;
};

export type ConnectorAuthUpdateResponse = {
  __typename?: 'ConnectorAuthUpdateResponse';
  connectorAuth?: Maybe<ConnectorAuth>;
};

export type ConnectorAuthUsernamePassword = {
  __typename?: 'ConnectorAuthUsernamePassword';
  password?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type ConnectorAuthUsernamePasswordInput = {
  password?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type ConnectorContribution = {
  __typename?: 'ConnectorContribution';
  count?: Maybe<Scalars['Long']>;
  systemType?: Maybe<Scalars['String']>;
};

/** Contains the input values needed to create a Connector. */
export type ConnectorCreateRequestInput = {
  connector?: Maybe<ConnectorInput>;
};

export type ConnectorCreateResponse = {
  __typename?: 'ConnectorCreateResponse';
  connector?: Maybe<Connector>;
};

/** Contains the input values needed to delete a Connector. */
export type ConnectorDeleteRequestInput = {
  id?: Maybe<Scalars['String']>;
  purgeData?: Maybe<ConnectorPurgeDataInput>;
};

export type ConnectorDeleteResponse = {
  __typename?: 'ConnectorDeleteResponse';
  _?: Maybe<Scalars['String']>;
};

/** Contains the input values needed to filter Connector queries. */
export type ConnectorFilterInput = {
  and?: Maybe<Array<Maybe<ConnectorFilterInput>>>;
  /** Used if you want to filter by a connectorType instead of a specific Connector installation. */
  connectorTypeId?: Maybe<IdFilterExpressionInput>;
  direction?: Maybe<ConnectorTypeConnectorDirectionFilterExpressionInput>;
  /** Used to filter for a specific ID or IDs (refer to IDFilterExpressionInput for input options). */
  id?: Maybe<IdFilterExpressionInput>;
  not?: Maybe<Array<Maybe<ConnectorFilterInput>>>;
  or?: Maybe<Array<Maybe<ConnectorFilterInput>>>;
};

/** Contains the details about a Connector. */
export type ConnectorInput = {
  baseUrl?: Maybe<Scalars['String']>;
  /** Any settings required in order to create a Connector will be provided here. */
  config?: Maybe<Scalars['JSONSchema']>;
  /** Random string that identifies the current Connector configuration; if you need to update the configuration, you will need to include the current configHash value in the mutation request. */
  configHash?: Maybe<Scalars['String']>;
  /** The unique id of the connector type. */
  connectorTypeId?: Maybe<Scalars['String']>;
  /** Timestamp for the Connector's creation. */
  created?: Maybe<Scalars['DateTime']>;
  direction?: Maybe<ConnectorTypeConnectorDirectionInput>;
  /** The unique id of a Connector. */
  id?: Maybe<Scalars['String']>;
  lastSeen?: Maybe<Scalars['DateTime']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  /** The name of a Connector you provided when setting it up for your org. */
  name?: Maybe<Scalars['String']>;
  runtimeVersion?: Maybe<ConnectorTypeRuntimeVersionInput>;
  /** Lists the state of a Connector, such as ACTIVE or STOPPED. */
  state?: Maybe<ConnectorStateInput>;
  /** Currently provides additional information about a Connector in an ERROR_GENERAL state. */
  stateDetails?: Maybe<Scalars['String']>;
  /** Timestamp when a connector was last updated. */
  updated?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
  /** This is an internal-only field; the value(s) included in this field may be requested by support for troubleshooting purposes, but otherwise holds no value for external developers. */
  workflowId?: Maybe<Scalars['String']>;
};

export type ConnectorLog = {
  __typename?: 'ConnectorLog';
  level?: Maybe<ConnectorLogLevel>;
  message?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type ConnectorLogFilterInput = {
  connectorId?: Maybe<IdFilterExpressionInput>;
  timestamp?: Maybe<TimestampRangeFilterExpressionInput>;
};

export enum ConnectorLogLevel {
  Debug = 'DEBUG',
  Error = 'ERROR',
  Fatal = 'FATAL',
  Info = 'INFO',
  LevelUnspecified = 'LEVEL_UNSPECIFIED',
  Trace = 'TRACE',
  Warn = 'WARN'
}

export enum ConnectorPurgeDataInput {
  DoNotPurgeData = 'DO_NOT_PURGE_DATA',
  PurgeData = 'PURGE_DATA',
  PurgeDataUnspecified = 'PURGE_DATA_UNSPECIFIED'
}

export type ConnectorRequest = {
  __typename?: 'ConnectorRequest';
  connectorTypeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type ConnectorRequestCreateRequestInput = {
  connectorTypeId?: Maybe<Scalars['String']>;
};

export type ConnectorRequestCreateResponse = {
  __typename?: 'ConnectorRequestCreateResponse';
  request?: Maybe<ConnectorRequest>;
};

export type ConnectorRestartRequestInput = {
  id?: Maybe<Scalars['String']>;
};

export type ConnectorRestartResponse = {
  __typename?: 'ConnectorRestartResponse';
  _?: Maybe<Scalars['String']>;
};

export type ConnectorStartRequestInput = {
  id?: Maybe<Scalars['String']>;
};

export type ConnectorStartResponse = {
  __typename?: 'ConnectorStartResponse';
  _?: Maybe<Scalars['String']>;
};

/** Current state of the Connector. */
export enum ConnectorState {
  /** Connector is up and running, retrieving data from the device vendor. */
  Active = 'ACTIVE',
  Configuring = 'CONFIGURING',
  Connecting = 'CONNECTING',
  /** Connector state cannot be identified, contact support@mapped.com for help. */
  ConnectorStateUnspecified = 'CONNECTOR_STATE_UNSPECIFIED',
  /** Connector was deleted, displays for audit purposes. */
  Deleted = 'DELETED',
  /** Transient state, displayed while Connector is in process of deletion. */
  Deleting = 'DELETING',
  /** Connector is in an error state, contact support@mapped.com for help. */
  ErrorGeneral = 'ERROR_GENERAL',
  /** Connector is stopped, no longer retrieving data from the device vendor, but still exists and can be restarted. */
  Stopped = 'STOPPED',
  /** Transient state, displayed while Connector is in process of stopping. */
  Stopping = 'STOPPING'
}

/** Current state of the Connector. */
export enum ConnectorStateInput {
  /** Connector is up and running, retrieving data from the device vendor. */
  Active = 'ACTIVE',
  Configuring = 'CONFIGURING',
  Connecting = 'CONNECTING',
  /** Connector state cannot be identified, contact support@mapped.com for help. */
  ConnectorStateUnspecified = 'CONNECTOR_STATE_UNSPECIFIED',
  /** Connector was deleted, displays for audit purposes. */
  Deleted = 'DELETED',
  /** Transient state, displayed while Connector is in process of deletion. */
  Deleting = 'DELETING',
  /** Connector is in an error state, contact support@mapped.com for help. */
  ErrorGeneral = 'ERROR_GENERAL',
  /** Connector is stopped, no longer retrieving data from the device vendor, but still exists and can be restarted. */
  Stopped = 'STOPPED',
  /** Transient state, displayed while Connector is in process of stopping. */
  Stopping = 'STOPPING'
}

export type ConnectorStopRequestInput = {
  id?: Maybe<Scalars['String']>;
};

export type ConnectorStopResponse = {
  __typename?: 'ConnectorStopResponse';
  _?: Maybe<Scalars['String']>;
};

/** Contains Connector type details. */
export type ConnectorType = {
  __typename?: 'ConnectorType';
  /** This is the JSON schema used to define how the config for a Connector needs to look. */
  configSchema?: Maybe<Scalars['JSONSchema']>;
  /** The description of the Connector type. */
  description?: Maybe<Scalars['String']>;
  /** Reflects whether the Connector is SOURCE (ingress, data from the vendor to your org) or DESTINATION (egress, data from your org to an external destination like a data lake). */
  direction?: Maybe<ConnectorTypeConnectorDirection>;
  /** The unique ID of the Connector type. */
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Array<Maybe<MetadataRecord>>>;
  /** The uneditable, assigned name of the Connector type; this is not the same as the Connector name defined by you when adding it to your org.. */
  name?: Maybe<Scalars['String']>;
  runtimeVersion?: Maybe<ConnectorTypeRuntimeVersion>;
  /** This is an internal-only field; the value(s) included in this field may be requested by support for troubleshooting purposes, but otherwise holds no value for external developers. */
  taskQueue?: Maybe<Scalars['String']>;
  /** This identifies the version of the Connector setup in your org; Connectors may have multiple versions available. */
  version?: Maybe<Scalars['String']>;
  webhookReceiveStorage?: Maybe<ConnectorTypeWebhookReceiveStorage>;
};

export enum ConnectorTypeConnectorDirection {
  ConnectorDirectionUnspecified = 'CONNECTOR_DIRECTION_UNSPECIFIED',
  Destination = 'DESTINATION',
  Source = 'SOURCE'
}

export type ConnectorTypeConnectorDirectionFilterExpressionInput = {
  eq?: Maybe<ConnectorTypeConnectorDirectionInput>;
  in?: Maybe<Array<Maybe<ConnectorTypeConnectorDirectionInput>>>;
};

export enum ConnectorTypeConnectorDirectionInput {
  ConnectorDirectionUnspecified = 'CONNECTOR_DIRECTION_UNSPECIFIED',
  Destination = 'DESTINATION',
  Source = 'SOURCE'
}

/** Used to filter the Connector type results. */
export type ConnectorTypeFilterInput = {
  /** The ID of the Connector type. */
  connectorTypeId?: Maybe<IdFilterExpressionInput>;
  /** The description of the Connector type. */
  description?: Maybe<IdFilterExpressionInput>;
  direction?: Maybe<ConnectorTypeConnectorDirectionFilterExpressionInput>;
  metadataKey?: Maybe<StringFilterExpressionInput>;
  metadataValue?: Maybe<StringFilterExpressionInput>;
  /** The name of the Connector type. */
  name?: Maybe<IdFilterExpressionInput>;
  runtimeVersion?: Maybe<ConnectorTypeRuntimeVersionFilterExpressionInput>;
  /** The version of the Connector type. */
  version?: Maybe<IdFilterExpressionInput>;
  webhookReceiveStorage?: Maybe<ConnectorTypeWebhookReceiveStorageInput>;
};

export type ConnectorTypeListAvailableResponse = {
  __typename?: 'ConnectorTypeListAvailableResponse';
  available?: Maybe<Array<Maybe<ConnectorType>>>;
  /** @deprecated Field no longer supported */
  connectorTypes?: Maybe<Array<Maybe<ConnectorType>>>;
  requested?: Maybe<Array<Maybe<ConnectorType>>>;
  uponRequest?: Maybe<Array<Maybe<ConnectorType>>>;
};

export enum ConnectorTypeRuntimeVersion {
  RuntimeversionUnspecified = 'RUNTIMEVERSION_UNSPECIFIED',
  V1 = 'V1',
  V2 = 'V2',
  V3 = 'V3'
}

export type ConnectorTypeRuntimeVersionFilterExpressionInput = {
  eq?: Maybe<ConnectorTypeRuntimeVersionInput>;
  in?: Maybe<Array<Maybe<ConnectorTypeRuntimeVersionInput>>>;
};

export enum ConnectorTypeRuntimeVersionInput {
  RuntimeversionUnspecified = 'RUNTIMEVERSION_UNSPECIFIED',
  V1 = 'V1',
  V2 = 'V2',
  V3 = 'V3'
}

export enum ConnectorTypeWebhookReceiveStorage {
  ReceivestorageExecuteWorkflow = 'RECEIVESTORAGE_EXECUTE_WORKFLOW',
  ReceivestorageKafkaSharedTopic = 'RECEIVESTORAGE_KAFKA_SHARED_TOPIC',
  ReceivestorageKafkaTopic = 'RECEIVESTORAGE_KAFKA_TOPIC',
  ReceivestorageNatsSubject = 'RECEIVESTORAGE_NATS_SUBJECT',
  ReceivestorageSignalWorkflow = 'RECEIVESTORAGE_SIGNAL_WORKFLOW',
  ReceivestorageUnspecified = 'RECEIVESTORAGE_UNSPECIFIED'
}

export enum ConnectorTypeWebhookReceiveStorageInput {
  ReceivestorageExecuteWorkflow = 'RECEIVESTORAGE_EXECUTE_WORKFLOW',
  ReceivestorageKafkaSharedTopic = 'RECEIVESTORAGE_KAFKA_SHARED_TOPIC',
  ReceivestorageKafkaTopic = 'RECEIVESTORAGE_KAFKA_TOPIC',
  ReceivestorageNatsSubject = 'RECEIVESTORAGE_NATS_SUBJECT',
  ReceivestorageSignalWorkflow = 'RECEIVESTORAGE_SIGNAL_WORKFLOW',
  ReceivestorageUnspecified = 'RECEIVESTORAGE_UNSPECIFIED'
}

export type ConnectorUpdateRequestInput = {
  connector?: Maybe<ConnectorInput>;
};

export type ConnectorUpdateResponse = {
  __typename?: 'ConnectorUpdateResponse';
  connector?: Maybe<Connector>;
};

export type ConnectorUpsertConfigRequestInput = {
  config?: Maybe<Scalars['JSONSchema']>;
  configHash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  restart?: Maybe<ConnectorUpsertConfigRestartOptionsInput>;
};

export type ConnectorUpsertConfigResponse = {
  __typename?: 'ConnectorUpsertConfigResponse';
  config?: Maybe<Scalars['JSONSchema']>;
  configHash?: Maybe<Scalars['String']>;
  configUnchanged?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
};

export enum ConnectorUpsertConfigRestartOptionsInput {
  ConnectorDoNotRestart = 'CONNECTOR_DO_NOT_RESTART',
  ConnectorRestart = 'CONNECTOR_RESTART',
  ConnectorRestartUnspecified = 'CONNECTOR_RESTART_UNSPECIFIED'
}

export type ContributionRequest = {
  __typename?: 'ContributionRequest';
  id?: Maybe<Scalars['String']>;
  properties?: Maybe<ContributionRequestPropertyValues>;
  target?: Maybe<ContributionRequestTargetEntity>;
};

export type ContributionRequestCreateRequestInput = {
  contributionRequest?: Maybe<ContributionRequestInput>;
};

export type ContributionRequestCreateResponse = {
  __typename?: 'ContributionRequestCreateResponse';
  contributionRequest?: Maybe<ContributionRequest>;
};

export type ContributionRequestInput = {
  id?: Maybe<Scalars['String']>;
  properties?: Maybe<ContributionRequestPropertyValuesInput>;
  target?: Maybe<ContributionRequestTargetEntityInput>;
};

export type ContributionRequestPropertyValues = {
  __typename?: 'ContributionRequestPropertyValues';
  additionalName?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  attachment?: Maybe<Array<Maybe<Scalars['String']>>>;
  callInfo?: Maybe<Scalars['String']>;
  countryName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  deviceModelId?: Maybe<Scalars['String']>;
  elevation?: Maybe<Scalars['Float']>;
  endTime?: Maybe<Scalars['DateTime']>;
  exactType?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  firmwareVersion?: Maybe<Scalars['String']>;
  geoshape?: Maybe<Scalars['GeoJSON']>;
  givenName?: Maybe<Scalars['String']>;
  hostname?: Maybe<Scalars['String']>;
  iCalUid?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  ipv4Address?: Maybe<Array<Maybe<Scalars['String']>>>;
  ipv6Address?: Maybe<Array<Maybe<Scalars['String']>>>;
  level?: Maybe<Scalars['Int']>;
  locality?: Maybe<Scalars['String']>;
  macAddress?: Maybe<Scalars['String']>;
  maxLimit?: Maybe<Scalars['Float']>;
  maxOccupancy?: Maybe<Scalars['Int']>;
  minLimit?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['String']>;
  seeAlso?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  stateTexts?: Maybe<Array<Maybe<Scalars['String']>>>;
  streetAddress?: Maybe<Scalars['String']>;
  systemType?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
  unit?: Maybe<Scalars['String']>;
  valueType?: Maybe<Scalars['String']>;
};

export type ContributionRequestPropertyValuesInput = {
  additionalName?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  attachment?: Maybe<Array<Maybe<Scalars['String']>>>;
  callInfo?: Maybe<Scalars['String']>;
  countryName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  deviceModelId?: Maybe<Scalars['String']>;
  elevation?: Maybe<Scalars['Float']>;
  endTime?: Maybe<Scalars['DateTime']>;
  exactType?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  firmwareVersion?: Maybe<Scalars['String']>;
  geoshape?: Maybe<Scalars['GeoJSON']>;
  givenName?: Maybe<Scalars['String']>;
  hostname?: Maybe<Scalars['String']>;
  iCalUid?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  ipv4Address?: Maybe<Array<Maybe<Scalars['String']>>>;
  ipv6Address?: Maybe<Array<Maybe<Scalars['String']>>>;
  level?: Maybe<Scalars['Int']>;
  locality?: Maybe<Scalars['String']>;
  macAddress?: Maybe<Scalars['String']>;
  maxLimit?: Maybe<Scalars['Float']>;
  maxOccupancy?: Maybe<Scalars['Int']>;
  minLimit?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['String']>;
  seeAlso?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  stateTexts?: Maybe<Array<Maybe<Scalars['String']>>>;
  streetAddress?: Maybe<Scalars['String']>;
  systemType?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
  unit?: Maybe<Scalars['String']>;
  valueType?: Maybe<Scalars['String']>;
};

export type ContributionRequestTargetEntity = {
  __typename?: 'ContributionRequestTargetEntity';
  id?: Maybe<Scalars['String']>;
};

export type ContributionRequestTargetEntityInput = {
  id?: Maybe<Scalars['String']>;
};

export enum DatatypeKey {
  DatatypeKeyUnspecified = 'DATATYPE_KEY_UNSPECIFIED',
  Bool = 'bool',
  Double = 'double',
  Enum = 'enum',
  Int = 'int',
  Json = 'json',
  String = 'string'
}


export type DateTimeFilterExpressionInput = {
  eq?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
};

export type DeviceLibraryModel = {
  __typename?: 'DeviceLibraryModel';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<DeviceManufacturer>;
  manufacturerId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  seeAlsoUrls?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DeviceManufacturer = {
  __typename?: 'DeviceManufacturer';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type DeviceModel = GraphNode & {
  __typename?: 'DeviceModel';
  connectedDataSourceId?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  exactType?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  identities?: Maybe<Array<Maybe<DeviceModelIdentityUnion>>>;
  manufacturedBy?: Maybe<Agent>;
  manufacturedByEdges?: Maybe<Array<Maybe<ManufacturedByEdge>>>;
  mappingKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type DeviceModelManufacturedByArgs = {
  filter?: Maybe<AgentFilter>;
};

export type DeviceModelFilter = {
  and?: Maybe<Array<Maybe<DeviceModelFilter>>>;
  connectedDataSourceId?: Maybe<StringFilterExpressionInput>;
  dateCreated?: Maybe<TimestampFilterExpressionInput>;
  dateUpdated?: Maybe<TimestampFilterExpressionInput>;
  exactType?: Maybe<StringFilterExpressionInput>;
  id?: Maybe<IdFilterExpressionInput>;
  mappingKey?: Maybe<StringFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  not?: Maybe<DeviceModelFilter>;
  or?: Maybe<Array<Maybe<DeviceModelFilter>>>;
  type?: Maybe<StringArrayFilterExpressionInput>;
};

export type DeviceModelIdentityUnion = AccessCredentialIdentity | BaCnetObjectId | BaCnetVendorId | EmailAddressIdentity | EmailIdentity | ExternalIdentity | FloorLevelIdentity | GenericIdentity | NameIdentity | PostalAddressIdentity | SpaceCode | SubBuildingCode;

export type Duration = {
  __typename?: 'Duration';
  nanos?: Maybe<Scalars['Int']>;
  seconds?: Maybe<Scalars['Long']>;
};

export type DurationInput = {
  nanos?: Maybe<Scalars['Int']>;
  seconds?: Maybe<Scalars['Long']>;
};

export type Edge = {
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export enum EdgeDirection {
  All = 'ALL',
  Incoming = 'INCOMING',
  Outgoing = 'OUTGOING'
}

export type EdgeDirectionFilterExpressionInput = {
  eq?: Maybe<EdgeDirection>;
};

export type EdgeFilter = {
  direction?: Maybe<EdgeDirectionFilterExpressionInput>;
};

export type EdgeProfile = {
  __typename?: 'EdgeProfile';
  fields?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  patternHashesV1?: Maybe<Array<Maybe<Scalars['String']>>>;
  patterns?: Maybe<Array<Maybe<FingerprintPattern>>>;
  protocol?: Maybe<GatewayProtocol>;
};

export type EdgeProfileFields = {
  __typename?: 'EdgeProfileFields';
  fields?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['String']>;
  protocol?: Maybe<GatewayProtocol>;
};

export type EdgeProfileGetByFingerprintRequestInput = {
  fingerprint?: Maybe<FingerprintInput>;
};

export type EdgeProfileGetByFingerprintResponse = {
  __typename?: 'EdgeProfileGetByFingerprintResponse';
  profile?: Maybe<EdgeProfile>;
};

export type EdgeProfileGetFieldsRequestInput = {
  protocol?: Maybe<GatewayProtocolInput>;
};

export type EdgeProfileGetFieldsResponse = {
  __typename?: 'EdgeProfileGetFieldsResponse';
  fields?: Maybe<Array<Maybe<EdgeProfileFields>>>;
};

export type EmailAddress = GraphNode & {
  __typename?: 'EmailAddress';
  address?: Maybe<Scalars['String']>;
  connectedDataSourceId?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  exactType?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  identities?: Maybe<Array<Maybe<EmailAddressIdentityUnion>>>;
  mappingKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type EmailAddressIdentity = EmailAddressIdentityModel & Identity & {
  __typename?: 'EmailAddressIdentity';
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<ScopeKey>;
  scopeId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type EmailAddressIdentityModel = {
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<ScopeKey>;
  scopeId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type EmailAddressIdentityUnion = AccessCredentialIdentity | BaCnetObjectId | BaCnetVendorId | EmailAddressIdentity | EmailIdentity | ExternalIdentity | FloorLevelIdentity | GenericIdentity | NameIdentity | PostalAddressIdentity | SpaceCode | SubBuildingCode;

export type EmailFilter = {
  and?: Maybe<Array<Maybe<EmailFilter>>>;
  connectedDataSourceId?: Maybe<StringFilterExpressionInput>;
  dateCreated?: Maybe<TimestampFilterExpressionInput>;
  dateUpdated?: Maybe<TimestampFilterExpressionInput>;
  exactType?: Maybe<StringFilterExpressionInput>;
  id?: Maybe<IdFilterExpressionInput>;
  mappingKey?: Maybe<StringFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  not?: Maybe<EmailFilter>;
  or?: Maybe<Array<Maybe<EmailFilter>>>;
  type?: Maybe<StringArrayFilterExpressionInput>;
};

export type EmailIdentity = EmailIdentityModel & Identity & {
  __typename?: 'EmailIdentity';
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<ScopeKey>;
  scopeId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type EmailIdentityModel = {
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<ScopeKey>;
  scopeId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export enum EncodingType {
  Base64 = 'BASE64',
  EncodingtypeUnspecified = 'ENCODINGTYPE_UNSPECIFIED',
  Hex = 'HEX'
}

export enum EncodingTypeInput {
  Base64 = 'BASE64',
  EncodingtypeUnspecified = 'ENCODINGTYPE_UNSPECIFIED',
  Hex = 'HEX'
}

export type EntityFilter = {
  and?: Maybe<Array<Maybe<EntityFilter>>>;
  connectedDataSourceId?: Maybe<StringFilterExpressionInput>;
  dateCreated?: Maybe<TimestampFilterExpressionInput>;
  dateUpdated?: Maybe<TimestampFilterExpressionInput>;
  exactType?: Maybe<StringFilterExpressionInput>;
  id?: Maybe<IdFilterExpressionInput>;
  mappingKey?: Maybe<StringFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  not?: Maybe<EntityFilter>;
  or?: Maybe<Array<Maybe<EntityFilter>>>;
  type?: Maybe<StringArrayFilterExpressionInput>;
};

export type Event = {
  connectedDataSourceId?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['DateTime']>;
  exactType?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  mappingKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['DateTime']>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ExternalIdentity = ExternalIdentityModel & Identity & {
  __typename?: 'ExternalIdentity';
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<ScopeKey>;
  scopeId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ExternalIdentityModel = {
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<ScopeKey>;
  scopeId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type FeedsEdge = Edge & {
  __typename?: 'FeedsEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type FeedsUnion = Building | Collection | Floor | GenericPlace | Site | Space | SubBuilding | Thing | Zone;

export enum FingerprintFieldStatus {
  FieldStatusAccessDenied = 'FIELD_STATUS_ACCESS_DENIED',
  FieldStatusInternalError = 'FIELD_STATUS_INTERNAL_ERROR',
  FieldStatusInvalidAddress = 'FIELD_STATUS_INVALID_ADDRESS',
  FieldStatusInvalidData = 'FIELD_STATUS_INVALID_DATA',
  FieldStatusInvalidDatatype = 'FIELD_STATUS_INVALID_DATATYPE',
  FieldStatusNotFound = 'FIELD_STATUS_NOT_FOUND',
  FieldStatusOk = 'FIELD_STATUS_OK',
  FieldStatusRemoteBusy = 'FIELD_STATUS_REMOTE_BUSY',
  FieldStatusRemoteError = 'FIELD_STATUS_REMOTE_ERROR',
  FieldStatusRequestTimeout = 'FIELD_STATUS_REQUEST_TIMEOUT',
  FieldStatusResponsePending = 'FIELD_STATUS_RESPONSE_PENDING',
  FieldStatusUnspecified = 'FIELD_STATUS_UNSPECIFIED',
  FieldStatusUnsupported = 'FIELD_STATUS_UNSUPPORTED'
}

export enum FingerprintFieldStatusInput {
  FieldStatusAccessDenied = 'FIELD_STATUS_ACCESS_DENIED',
  FieldStatusInternalError = 'FIELD_STATUS_INTERNAL_ERROR',
  FieldStatusInvalidAddress = 'FIELD_STATUS_INVALID_ADDRESS',
  FieldStatusInvalidData = 'FIELD_STATUS_INVALID_DATA',
  FieldStatusInvalidDatatype = 'FIELD_STATUS_INVALID_DATATYPE',
  FieldStatusNotFound = 'FIELD_STATUS_NOT_FOUND',
  FieldStatusOk = 'FIELD_STATUS_OK',
  FieldStatusRemoteBusy = 'FIELD_STATUS_REMOTE_BUSY',
  FieldStatusRemoteError = 'FIELD_STATUS_REMOTE_ERROR',
  FieldStatusRequestTimeout = 'FIELD_STATUS_REQUEST_TIMEOUT',
  FieldStatusResponsePending = 'FIELD_STATUS_RESPONSE_PENDING',
  FieldStatusUnspecified = 'FIELD_STATUS_UNSPECIFIED',
  FieldStatusUnsupported = 'FIELD_STATUS_UNSUPPORTED'
}

export type FingerprintInput = {
  device?: Maybe<GatewaySubtendedDeviceInput>;
  patterns?: Maybe<Array<Maybe<FingerprintPatternInput>>>;
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type FingerprintPattern = {
  __typename?: 'FingerprintPattern';
  fieldQuery?: Maybe<Scalars['String']>;
  fieldStatus?: Maybe<FingerprintFieldStatus>;
  fieldType?: Maybe<Scalars['String']>;
  fieldValue?: Maybe<Scalars['String']>;
  protocol?: Maybe<GatewayProtocol>;
  protocolPort?: Maybe<Scalars['Long']>;
};

export type FingerprintPatternInput = {
  fieldQuery?: Maybe<Scalars['String']>;
  fieldStatus?: Maybe<FingerprintFieldStatusInput>;
  fieldType?: Maybe<Scalars['String']>;
  fieldValue?: Maybe<Scalars['String']>;
  protocol?: Maybe<GatewayProtocolInput>;
  protocolPort?: Maybe<Scalars['Long']>;
};

/** Contains the details about the floor. */
export type Floor = GraphNode & Place & ThingContainer & {
  __typename?: 'Floor';
  /** Contains the details of the building where the floor is present. */
  building: Building;
  calendarEvents?: Maybe<Array<Maybe<CalendarEvent>>>;
  collections?: Maybe<Array<Maybe<Collection>>>;
  connectedDataSourceId?: Maybe<Scalars['String']>;
  /** Any connectors configured for the floor will be listed here. */
  connectors?: Maybe<Array<Maybe<Connector>>>;
  /** This timestamp represents the date the floor was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** This timestamp represents that date the floor was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The description of the floor; often left blank, especially if the floor name is already descriptive. */
  description?: Maybe<Scalars['String']>;
  exactType?: Maybe<Scalars['String']>;
  /** The geographic shape of the floor, represented by latitude/longitude coordinate pairs. */
  geoshape?: Maybe<Scalars['GeoJSON']>;
  grossArea?: Maybe<AreaQuantity>;
  grossAreaEdges?: Maybe<Array<Maybe<GrossAreaEdge>>>;
  /** Lists the spaces on the floor - spaces are "part of" a floor. */
  hasPart?: Maybe<Array<Maybe<Place>>>;
  hasPartEdges?: Maybe<Array<Maybe<HasPartEdge>>>;
  hasPoint?: Maybe<Array<Maybe<Point>>>;
  hasPointEdges?: Maybe<Array<Maybe<HasPointEdge>>>;
  /** The unique ID of the floor. */
  id: Scalars['String'];
  identities?: Maybe<Array<Maybe<FloorIdentityUnion>>>;
  isAdjacentTo?: Maybe<Array<Maybe<Place>>>;
  isAdjacentToEdges?: Maybe<Array<Maybe<IsAdjacentToEdge>>>;
  isFedBy?: Maybe<Array<Maybe<Thing>>>;
  isFedByEdges?: Maybe<Array<Maybe<IsFedByEdge>>>;
  isLocationOf?: Maybe<Array<Maybe<IsLocationOfUnion>>>;
  isLocationOfEdges?: Maybe<Array<Maybe<IsLocationOfEdge>>>;
  /** This contains the next level up in the place hierarchy; for a floor, this will contain building information. */
  isPartOf?: Maybe<Array<Maybe<Place>>>;
  isPartOfEdges?: Maybe<Array<Maybe<IsPartOfEdge>>>;
  isServedBy?: Maybe<Array<Maybe<Thing>>>;
  isServedByEdges?: Maybe<Array<Maybe<IsServedByEdge>>>;
  /** This is the floor level represented numerically. Starting at 0 for ground floor, with basement levels below ground floor identified as negative numbers. */
  level?: Maybe<Scalars['Int']>;
  mappingKey?: Maybe<Scalars['String']>;
  /** The name of the floor, typically just a number or "floor1", "floor2". */
  name?: Maybe<Scalars['String']>;
  /** Any of the points available on the floor will be listed here. */
  points?: Maybe<Array<Maybe<Point>>>;
  rentableArea?: Maybe<AreaQuantity>;
  rentableAreaEdges?: Maybe<Array<Maybe<RentableAreaEdge>>>;
  /** All the spaces present on the floor will be listed here. */
  spaces?: Maybe<Array<Maybe<Space>>>;
  /** All the things associated with the floor, or any spaces on the floor, will show here. */
  things?: Maybe<Array<Maybe<Thing>>>;
  /** Type includes all possible hierarchal types for the building, such as "Place" and "Floor". */
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
  usableArea?: Maybe<AreaQuantity>;
  usableAreaEdges?: Maybe<Array<Maybe<UsableAreaEdge>>>;
  /** Currently in development; will show all the zones associated with the floor. */
  zones?: Maybe<Array<Maybe<Zone>>>;
};


/** Contains the details about the floor. */
export type FloorCalendarEventsArgs = {
  filter?: Maybe<CalendarEventFilter>;
};


/** Contains the details about the floor. */
export type FloorCollectionsArgs = {
  filter?: Maybe<CollectionFilter>;
};


/** Contains the details about the floor. */
export type FloorConnectorsArgs = {
  filter?: Maybe<ConnectorFilterInput>;
};


/** Contains the details about the floor. */
export type FloorGrossAreaArgs = {
  filter?: Maybe<AreaQuantityFilter>;
};


/** Contains the details about the floor. */
export type FloorHasPartArgs = {
  filter?: Maybe<PlaceFilter>;
};


/** Contains the details about the floor. */
export type FloorHasPointArgs = {
  filter?: Maybe<PointFilter>;
};


/** Contains the details about the floor. */
export type FloorIsAdjacentToArgs = {
  filter?: Maybe<PlaceFilter>;
};


/** Contains the details about the floor. */
export type FloorIsFedByArgs = {
  filter?: Maybe<ThingFilter>;
};


/** Contains the details about the floor. */
export type FloorIsLocationOfArgs = {
  filter?: Maybe<EntityFilter>;
};


/** Contains the details about the floor. */
export type FloorIsPartOfArgs = {
  filter?: Maybe<PlaceFilter>;
};


/** Contains the details about the floor. */
export type FloorIsServedByArgs = {
  filter?: Maybe<ThingFilter>;
};


/** Contains the details about the floor. */
export type FloorPointsArgs = {
  filter?: Maybe<PointFilter>;
};


/** Contains the details about the floor. */
export type FloorRentableAreaArgs = {
  filter?: Maybe<AreaQuantityFilter>;
};


/** Contains the details about the floor. */
export type FloorSpacesArgs = {
  childDepth?: Maybe<Scalars['Int']>;
  filter?: Maybe<SpaceFilter>;
};


/** Contains the details about the floor. */
export type FloorThingsArgs = {
  filter?: Maybe<ThingFilter>;
};


/** Contains the details about the floor. */
export type FloorUsableAreaArgs = {
  filter?: Maybe<AreaQuantityFilter>;
};


/** Contains the details about the floor. */
export type FloorZonesArgs = {
  filter?: Maybe<ZoneFilter>;
};

export type FloorCreateRequestInput = {
  floor?: Maybe<FloorMutationInput>;
};

export type FloorCreateResponse = {
  __typename?: 'FloorCreateResponse';
  floor?: Maybe<FloorMutation>;
};

export type FloorDeleteRequestInput = {
  id?: Maybe<Scalars['String']>;
};

export type FloorDeleteResponse = {
  __typename?: 'FloorDeleteResponse';
  _?: Maybe<Scalars['String']>;
};

/** Contains the input values needed to filter floor queries. */
export type FloorFilter = {
  /** Used to combine multiple filter criteria. */
  and?: Maybe<Array<Maybe<FloorFilter>>>;
  connectedDataSourceId?: Maybe<StringFilterExpressionInput>;
  dateCreated?: Maybe<TimestampFilterExpressionInput>;
  dateUpdated?: Maybe<TimestampFilterExpressionInput>;
  exactType?: Maybe<StringFilterExpressionInput>;
  /** Used to filter for a specific ID or IDs (refer to IDFilterExpressionInput for input options) */
  id?: Maybe<IdFilterExpressionInput>;
  level?: Maybe<IntFilterExpressionInput>;
  mappingKey?: Maybe<StringFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  /** Used to omit a specific result or results from the response. */
  not?: Maybe<FloorFilter>;
  /** Used to return results that match at least one of the defined criteria. */
  or?: Maybe<Array<Maybe<FloorFilter>>>;
  type?: Maybe<StringArrayFilterExpressionInput>;
};

export type FloorIdentityUnion = AccessCredentialIdentity | BaCnetObjectId | BaCnetVendorId | EmailAddressIdentity | EmailIdentity | ExternalIdentity | FloorLevelIdentity | GenericIdentity | NameIdentity | PostalAddressIdentity | SpaceCode | SubBuildingCode;

export type FloorLevelIdentity = FloorLevelIdentityModel & Identity & {
  __typename?: 'FloorLevelIdentity';
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<ScopeKey>;
  scopeId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type FloorLevelIdentityModel = {
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<ScopeKey>;
  scopeId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type FloorMutation = {
  __typename?: 'FloorMutation';
  buildingId?: Maybe<Scalars['String']>;
  geoshape?: Maybe<Scalars['GeoJSON']>;
  id?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type FloorMutationInput = {
  buildingId?: Maybe<Scalars['String']>;
  geoshape?: Maybe<Scalars['GeoJSON']>;
  id?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type FloorUpdateRequestInput = {
  floor?: Maybe<FloorMutationInput>;
};

export type FloorUpdateResponse = {
  __typename?: 'FloorUpdateResponse';
  floor?: Maybe<FloorMutation>;
};

export type GrpcRequestOptions = {
  /** Request Timeout in milliseconds */
  requestTimeout?: Maybe<Scalars['Int']>;
};

/** Contains the details about the gateway. */
export type Gateway = {
  __typename?: 'Gateway';
  /** If the gateway is in an active state, this will contain the last seen time value. */
  active?: Maybe<GatewayActiveDetails>;
  /** Contains the gateway place assignment details, including place IDs and system types. */
  assignment?: Maybe<GatewayAssignmentDetails>;
  /** This contains the timestamp for the gateway's first boot. */
  firstBoot?: Maybe<GatewayFirstBootDetails>;
  /** The unique ID of the gateway. */
  gatewayId?: Maybe<Scalars['String']>;
  /** Contains the details about the organization associated with this gateway. */
  organization?: Maybe<Org>;
  /** Contains the timestamp for the gateway's initial provisioning to the organization. */
  provisioning?: Maybe<GatewayProvisioningDetails>;
  /** Contains gateway registration details, including serial number and IMEI information. */
  registration?: Maybe<GatewayRegistrationDetails>;
  /** If the gateway needs to be returned, this will contain details like the RMA reason along with any explanatory notes. */
  rma?: Maybe<GatewayRmaDetails>;
  /** If the gateway is currently in a SHIPPED state, details about the shipment will show here, including carrier and tracking number. */
  shipping?: Maybe<GatewayShippingDetails>;
  /** The current state of the gateway - many states are transitory, like FIRST_BOOT; the more common states will be ACTIVE, ASSIGNED, PROVISIONING and SHIPPED as those exist for longer windows. */
  state?: Maybe<GatewayLifecycleState>;
  /** Timestamp for the start of the current state. */
  stateTime?: Maybe<Scalars['DateTime']>;
  /** If the gateway was suspended, this will contain details like the suspension reason along with any explanatory notes. */
  suspension?: Maybe<GatewaySuspensionDetails>;
  /** If the gateway was terminated, this will contain details like the suspension reason along with any explanatory notes. This differs from suspenson as the gateway cannot be returned to active once terminated. */
  termination?: Maybe<GatewayTerminationDetails>;
};

export type GatewayActiveDetails = {
  __typename?: 'GatewayActiveDetails';
  lastSeenTime?: Maybe<Scalars['DateTime']>;
  ugagentVersion?: Maybe<Scalars['String']>;
};

/** Contains the input values needed to assign a gateway. */
export type GatewayAssignRequestInput = {
  assignment?: Maybe<GatewayAssignmentDetailsInput>;
  gatewayId?: Maybe<Scalars['String']>;
};

export type GatewayAssignResponse = {
  __typename?: 'GatewayAssignResponse';
  _?: Maybe<Scalars['String']>;
};

export type GatewayAssignmentDetails = {
  __typename?: 'GatewayAssignmentDetails';
  assignmentTime?: Maybe<Scalars['DateTime']>;
  physicalPlaceId?: Maybe<Scalars['String']>;
  preciseGeoLocation?: Maybe<Scalars['GeoJSON']>;
  servesPlaceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  servesSystemTypes?: Maybe<Array<Maybe<SystemTypeKey>>>;
  supportAccessAllowed?: Maybe<Scalars['Boolean']>;
  supportAccessExpiration?: Maybe<Scalars['DateTime']>;
  uniqueName?: Maybe<Scalars['String']>;
};

export type GatewayAssignmentDetailsInput = {
  assignmentTime?: Maybe<Scalars['DateTime']>;
  physicalPlaceId?: Maybe<Scalars['String']>;
  preciseGeoLocation?: Maybe<Scalars['GeoJSON']>;
  servesPlaceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  servesSystemTypes?: Maybe<Array<Maybe<SystemTypeKeyInput>>>;
  supportAccessAllowed?: Maybe<Scalars['Boolean']>;
  supportAccessExpiration?: Maybe<Scalars['DateTime']>;
  uniqueName?: Maybe<Scalars['String']>;
};

export enum GatewayAuthTypeInput {
  AuthTypeUnspecified = 'AUTH_TYPE_UNSPECIFIED',
  BasicAuth = 'BASIC_AUTH',
  Digest = 'DIGEST'
}

export enum GatewayCourier {
  CourierDhl = 'COURIER_DHL',
  CourierFedex = 'COURIER_FEDEX',
  CourierUnspecified = 'COURIER_UNSPECIFIED',
  CourierUps = 'COURIER_UPS',
  CourierUsps = 'COURIER_USPS'
}

export type GatewayCredentialsInput = {
  authType?: Maybe<GatewayAuthTypeInput>;
  cleartext?: Maybe<Scalars['String']>;
  hashed?: Maybe<GatewayHashTypeInput>;
  username?: Maybe<Scalars['String']>;
};

/** Contains the input values needed to filter gateway queries. */
export type GatewayFilterInput = {
  /** Used to combine multiple filter criteria. */
  and?: Maybe<Array<Maybe<GatewayFilterInput>>>;
  deviceId?: Maybe<IdFilterExpressionInput>;
  gatewayId?: Maybe<IdFilterExpressionInput>;
  iccid?: Maybe<StringFilterExpressionInput>;
  imei?: Maybe<StringFilterExpressionInput>;
  lanMac?: Maybe<StringFilterExpressionInput>;
  mappedModel?: Maybe<GatewayModelFilterExpressionInput>;
  /** Used to omit a specific result or results from the response. */
  not?: Maybe<Array<Maybe<GatewayFilterInput>>>;
  /** Used to return results that match at least one of the defined criteria. */
  or?: Maybe<Array<Maybe<GatewayFilterInput>>>;
  physicalPlaceId?: Maybe<IdFilterExpressionInput>;
  serialNumber?: Maybe<StringFilterExpressionInput>;
  servesPlaceIds?: Maybe<StringArrayFilterExpressionInput>;
  servesSystemTypes?: Maybe<GatewaySystemTypeFilterExpressionInput>;
  state?: Maybe<GatewayLifecycleStateFilterExpressionInput>;
  stateTime?: Maybe<TimestampFilterExpressionInput>;
  /** Search by the gateway's name, either an exact match, in a defined set or by a partial match. */
  uniqueName?: Maybe<StringFilterExpressionInput>;
};

export type GatewayFirstBootDetails = {
  __typename?: 'GatewayFirstBootDetails';
  bootTime?: Maybe<Scalars['DateTime']>;
};

/** Currently not used, placeholder. */
export type GatewayGenerateContainerSiDsRequestInput = {
  /** NOT USED */
  _?: Maybe<Scalars['String']>;
};

export type GatewayGenerateContainerSiDsResponse = {
  __typename?: 'GatewayGenerateContainerSIDsResponse';
  availableCertificateCn?: Maybe<Scalars['String']>;
  signingCertificateCn?: Maybe<Scalars['String']>;
};

export enum GatewayHashMethodInput {
  HashMethodUnspecified = 'HASH_METHOD_UNSPECIFIED',
  Md5 = 'MD5',
  Sha256 = 'SHA256',
  Sha512 = 'SHA512'
}

export type GatewayHashTypeInput = {
  hash?: Maybe<Scalars['String']>;
  method?: Maybe<GatewayHashMethodInput>;
};

export type GatewayIpAddressInput = {
  v4?: Maybe<GatewayIpv4AddressInput>;
  v6?: Maybe<GatewayIpv6AddressInput>;
};

export type GatewayIpv4AddressInput = {
  address?: Maybe<Scalars['Long']>;
};

export type GatewayIpv6AddressInput = {
  address?: Maybe<Scalars['String']>;
};

export enum GatewayLifecycleState {
  Active = 'ACTIVE',
  Assigned = 'ASSIGNED',
  Configuring = 'CONFIGURING',
  Delivered = 'DELIVERED',
  ExtendedOffline = 'EXTENDED_OFFLINE',
  FirstBoot = 'FIRST_BOOT',
  Inventory = 'INVENTORY',
  LifecycleStateUnspecified = 'LIFECYCLE_STATE_UNSPECIFIED',
  Provisioned = 'PROVISIONED',
  Rma = 'RMA',
  Shipped = 'SHIPPED',
  ShippingException = 'SHIPPING_EXCEPTION',
  Suspended = 'SUSPENDED',
  Terminated = 'TERMINATED'
}

export type GatewayLifecycleStateFilterExpressionInput = {
  eq?: Maybe<GatewayLifecycleStateInput>;
  in?: Maybe<Array<Maybe<GatewayLifecycleStateInput>>>;
};

export enum GatewayLifecycleStateInput {
  Active = 'ACTIVE',
  Assigned = 'ASSIGNED',
  Configuring = 'CONFIGURING',
  Delivered = 'DELIVERED',
  ExtendedOffline = 'EXTENDED_OFFLINE',
  FirstBoot = 'FIRST_BOOT',
  Inventory = 'INVENTORY',
  LifecycleStateUnspecified = 'LIFECYCLE_STATE_UNSPECIFIED',
  Provisioned = 'PROVISIONED',
  Rma = 'RMA',
  Shipped = 'SHIPPED',
  ShippingException = 'SHIPPING_EXCEPTION',
  Suspended = 'SUSPENDED',
  Terminated = 'TERMINATED'
}

export type GatewayModbusKnownFieldsInput = {
  knownFieldQuery?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum GatewayModel {
  ModelUg100 = 'MODEL_UG100',
  ModelUg110 = 'MODEL_UG110',
  ModelUgcloud = 'MODEL_UGCLOUD',
  ModelUgcloudAarch64 = 'MODEL_UGCLOUD_AARCH64',
  ModelUgcontainer = 'MODEL_UGCONTAINER',
  ModelUgcontainerAarch64 = 'MODEL_UGCONTAINER_AARCH64',
  ModelUnspecified = 'MODEL_UNSPECIFIED'
}

export type GatewayModelFilterExpressionInput = {
  eq?: Maybe<GatewayModelInput>;
  in?: Maybe<Array<Maybe<GatewayModelInput>>>;
};

export enum GatewayModelInput {
  ModelUg100 = 'MODEL_UG100',
  ModelUg110 = 'MODEL_UG110',
  ModelUgcloud = 'MODEL_UGCLOUD',
  ModelUgcloudAarch64 = 'MODEL_UGCLOUD_AARCH64',
  ModelUgcontainer = 'MODEL_UGCONTAINER',
  ModelUgcontainerAarch64 = 'MODEL_UGCONTAINER_AARCH64',
  ModelUnspecified = 'MODEL_UNSPECIFIED'
}

export type GatewayNote = {
  __typename?: 'GatewayNote';
  note?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
};

export type GatewayNoteInput = {
  note?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
};

export enum GatewayProtocol {
  Amqp = 'AMQP',
  Bacnet = 'BACNET',
  BitboxPowerMeter = 'BITBOX_POWER_METER',
  BitboxUtility = 'BITBOX_UTILITY',
  Can = 'CAN',
  Crestron = 'CRESTRON',
  CBus = 'C_BUS',
  Dnp3 = 'DNP3',
  Fox = 'FOX',
  Ftp = 'FTP',
  GenetecWebClient = 'GENETEC_WEB_CLIENT',
  Http = 'HTTP',
  Knx = 'KNX',
  LsOpenAccess = 'LS_OPEN_ACCESS',
  Lutron = 'LUTRON',
  Modbus = 'MODBUS',
  ModbusAscii = 'MODBUS_ASCII',
  ModbusRtu = 'MODBUS_RTU',
  Mqtt = 'MQTT',
  Obix = 'OBIX',
  Onvif = 'ONVIF',
  OpcUa = 'OPC_UA',
  Other = 'OTHER',
  ProtocolUnspecified = 'PROTOCOL_UNSPECIFIED',
  S7 = 'S7',
  SiemensDesigoSixWebClient = 'SIEMENS_DESIGO_SIX_WEB_CLIENT',
  Snmp = 'SNMP',
  Ssh = 'SSH',
  Telnet = 'TELNET'
}

export enum GatewayProtocolInput {
  Amqp = 'AMQP',
  Bacnet = 'BACNET',
  BitboxPowerMeter = 'BITBOX_POWER_METER',
  BitboxUtility = 'BITBOX_UTILITY',
  Can = 'CAN',
  Crestron = 'CRESTRON',
  CBus = 'C_BUS',
  Dnp3 = 'DNP3',
  Fox = 'FOX',
  Ftp = 'FTP',
  GenetecWebClient = 'GENETEC_WEB_CLIENT',
  Http = 'HTTP',
  Knx = 'KNX',
  LsOpenAccess = 'LS_OPEN_ACCESS',
  Lutron = 'LUTRON',
  Modbus = 'MODBUS',
  ModbusAscii = 'MODBUS_ASCII',
  ModbusRtu = 'MODBUS_RTU',
  Mqtt = 'MQTT',
  Obix = 'OBIX',
  Onvif = 'ONVIF',
  OpcUa = 'OPC_UA',
  Other = 'OTHER',
  ProtocolUnspecified = 'PROTOCOL_UNSPECIFIED',
  S7 = 'S7',
  SiemensDesigoSixWebClient = 'SIEMENS_DESIGO_SIX_WEB_CLIENT',
  Snmp = 'SNMP',
  Ssh = 'SSH',
  Telnet = 'TELNET'
}

export type GatewayProtocolKnownFieldsInput = {
  modbusKnownFields?: Maybe<GatewayModbusKnownFieldsInput>;
  protocol?: Maybe<GatewayProtocolInput>;
};

export type GatewayProvisioningDetails = {
  __typename?: 'GatewayProvisioningDetails';
  provisionTime?: Maybe<Scalars['DateTime']>;
};

export type GatewayRmaDetails = {
  __typename?: 'GatewayRMADetails';
  notesCustomer?: Maybe<Array<Maybe<GatewayNote>>>;
  reason?: Maybe<GatewayRmaReason>;
  rmaTime?: Maybe<Scalars['DateTime']>;
};

export enum GatewayRmaReason {
  RmaReasonConnectivity = 'RMA_REASON_CONNECTIVITY',
  RmaReasonCustomerReturn = 'RMA_REASON_CUSTOMER_RETURN',
  RmaReasonHardwarefailure = 'RMA_REASON_HARDWAREFAILURE',
  RmaReasonOther = 'RMA_REASON_OTHER',
  RmaReasonUnspecified = 'RMA_REASON_UNSPECIFIED'
}

/** Currently not used, placeholder. */
export type GatewayRegisterContainerRequestInput = {
  availableCertificatePem?: Maybe<Scalars['String']>;
  signingCertificatePem?: Maybe<Scalars['String']>;
};

export type GatewayRegisterContainerResponse = {
  __typename?: 'GatewayRegisterContainerResponse';
  deviceId?: Maybe<Scalars['String']>;
  gatewayId?: Maybe<Scalars['String']>;
};

export type GatewayRegistrationDetails = {
  __typename?: 'GatewayRegistrationDetails';
  imei?: Maybe<Scalars['String']>;
  lanMac?: Maybe<Scalars['String']>;
  mappedModel?: Maybe<GatewayModel>;
  serialNumber?: Maybe<Scalars['String']>;
  sim?: Maybe<GatewaySimInfo>;
};

export type GatewaySimCertificate = {
  __typename?: 'GatewaySIMCertificate';
  id?: Maybe<Scalars['String']>;
  pem?: Maybe<Scalars['String']>;
  subjectKeyId?: Maybe<Scalars['String']>;
};

export type GatewaySimInfo = {
  __typename?: 'GatewaySIMInfo';
  availableCertificate?: Maybe<GatewaySimCertificate>;
  iccid?: Maybe<Scalars['String']>;
  signingCertificate?: Maybe<GatewaySimCertificate>;
  simType?: Maybe<GatewaySimType>;
};

export enum GatewaySimType {
  SimTypeCertsOnly = 'SIM_TYPE_CERTS_ONLY',
  SimTypeEsim = 'SIM_TYPE_ESIM',
  SimTypeTwilioSuper = 'SIM_TYPE_TWILIO_SUPER',
  SimTypeTwilioSuperTob = 'SIM_TYPE_TWILIO_SUPER_TOB',
  SimTypeTwilioTob = 'SIM_TYPE_TWILIO_TOB',
  SimTypeUnspecified = 'SIM_TYPE_UNSPECIFIED'
}

export type GatewayShippingDetails = {
  __typename?: 'GatewayShippingDetails';
  courier?: Maybe<GatewayCourier>;
  shipTime?: Maybe<Scalars['DateTime']>;
  status?: Maybe<GatewayShippingStatus>;
  statusTime?: Maybe<Scalars['DateTime']>;
  trackingNumber?: Maybe<Scalars['String']>;
};

export enum GatewayShippingStatus {
  ShippingStatusDelivered = 'SHIPPING_STATUS_DELIVERED',
  ShippingStatusException = 'SHIPPING_STATUS_EXCEPTION',
  ShippingStatusShipped = 'SHIPPING_STATUS_SHIPPED',
  ShippingStatusUnspecified = 'SHIPPING_STATUS_UNSPECIFIED'
}

export type GatewaySubtendedDeviceInput = {
  applicationSoftwareVersion?: Maybe<Scalars['String']>;
  credentials?: Maybe<GatewayCredentialsInput>;
  deviceDescription?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Array<Maybe<Scalars['String']>>>;
  deviceLocation?: Maybe<Scalars['String']>;
  deviceName?: Maybe<Scalars['String']>;
  deviceVersion?: Maybe<Scalars['String']>;
  hostName?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<GatewayIpAddressInput>;
  knownFields?: Maybe<Array<Maybe<GatewayProtocolKnownFieldsInput>>>;
  macAddress?: Maybe<Scalars['String']>;
  manufacturerId?: Maybe<Scalars['String']>;
  manufacturerName?: Maybe<Scalars['String']>;
  modelName?: Maybe<Scalars['String']>;
  port?: Maybe<Scalars['Long']>;
  protocol?: Maybe<GatewayProtocolInput>;
};

/** Contains the input values needed to suspend a gateway. */
export type GatewaySuspendRequestInput = {
  details?: Maybe<GatewaySuspensionDetailsInput>;
  gatewayId?: Maybe<Scalars['String']>;
};

export type GatewaySuspendResponse = {
  __typename?: 'GatewaySuspendResponse';
  _?: Maybe<Scalars['String']>;
};

export type GatewaySuspensionDetails = {
  __typename?: 'GatewaySuspensionDetails';
  notesCustomer?: Maybe<Array<Maybe<GatewayNote>>>;
  reason?: Maybe<GatewaySuspensionReason>;
  suspensionTime?: Maybe<Scalars['DateTime']>;
};

export type GatewaySuspensionDetailsInput = {
  notesCustomer?: Maybe<Array<Maybe<GatewayNoteInput>>>;
  reason?: Maybe<GatewaySuspensionReasonInput>;
  suspensionTime?: Maybe<Scalars['DateTime']>;
};

export enum GatewaySuspensionReason {
  SuspensionReasonAccountState = 'SUSPENSION_REASON_ACCOUNT_STATE',
  SuspensionReasonCustomerRequest = 'SUSPENSION_REASON_CUSTOMER_REQUEST',
  SuspensionReasonLostTemporary = 'SUSPENSION_REASON_LOST_TEMPORARY',
  SuspensionReasonUnspecified = 'SUSPENSION_REASON_UNSPECIFIED',
  SuspensionReasonUnsuspend = 'SUSPENSION_REASON_UNSUSPEND'
}

export enum GatewaySuspensionReasonInput {
  SuspensionReasonAccountState = 'SUSPENSION_REASON_ACCOUNT_STATE',
  SuspensionReasonCustomerRequest = 'SUSPENSION_REASON_CUSTOMER_REQUEST',
  SuspensionReasonLostTemporary = 'SUSPENSION_REASON_LOST_TEMPORARY',
  SuspensionReasonUnspecified = 'SUSPENSION_REASON_UNSPECIFIED',
  SuspensionReasonUnsuspend = 'SUSPENSION_REASON_UNSUSPEND'
}

export type GatewaySystemTypeFilterExpressionInput = {
  eq?: Maybe<SystemTypeKeyInput>;
  in?: Maybe<Array<Maybe<SystemTypeKeyInput>>>;
};

export type GatewayTerminationDetails = {
  __typename?: 'GatewayTerminationDetails';
  notesCustomer?: Maybe<Array<Maybe<GatewayNote>>>;
  reason?: Maybe<GatewayTerminationReason>;
  terminationTime?: Maybe<Scalars['DateTime']>;
};

export enum GatewayTerminationReason {
  TerminationDamaged = 'TERMINATION_DAMAGED',
  TerminationFailure = 'TERMINATION_FAILURE',
  TerminationLost = 'TERMINATION_LOST',
  TerminationReasonAccountState = 'TERMINATION_REASON_ACCOUNT_STATE',
  TerminationReasonCustomerRequest = 'TERMINATION_REASON_CUSTOMER_REQUEST',
  TerminationReasonUnspecified = 'TERMINATION_REASON_UNSPECIFIED'
}

export type GenericIdentity = Identity & {
  __typename?: 'GenericIdentity';
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<ScopeKey>;
  scopeId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type GenericPlace = GraphNode & Place & ThingContainer & {
  __typename?: 'GenericPlace';
  address?: Maybe<Address>;
  calendarEvents?: Maybe<Array<Maybe<CalendarEvent>>>;
  collections?: Maybe<Array<Maybe<Collection>>>;
  connectedDataSourceId?: Maybe<Scalars['String']>;
  connectors?: Maybe<Array<Maybe<Connector>>>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  exactType?: Maybe<Scalars['String']>;
  floors?: Maybe<Array<Maybe<Floor>>>;
  geoshape?: Maybe<Scalars['GeoJSON']>;
  grossArea?: Maybe<AreaQuantity>;
  grossAreaEdges?: Maybe<Array<Maybe<GrossAreaEdge>>>;
  hasPart?: Maybe<Array<Maybe<Place>>>;
  hasPartEdges?: Maybe<Array<Maybe<HasPartEdge>>>;
  hasPoint?: Maybe<Array<Maybe<Point>>>;
  hasPointEdges?: Maybe<Array<Maybe<HasPointEdge>>>;
  id: Scalars['String'];
  identities?: Maybe<Array<Maybe<GenericPlaceIdentityUnion>>>;
  isAdjacentTo?: Maybe<Array<Maybe<Place>>>;
  isAdjacentToEdges?: Maybe<Array<Maybe<IsAdjacentToEdge>>>;
  isFedBy?: Maybe<Array<Maybe<Thing>>>;
  isFedByEdges?: Maybe<Array<Maybe<IsFedByEdge>>>;
  isLocationOf?: Maybe<Array<Maybe<IsLocationOfUnion>>>;
  isLocationOfEdges?: Maybe<Array<Maybe<IsLocationOfEdge>>>;
  isPartOf?: Maybe<Array<Maybe<Place>>>;
  isPartOfEdges?: Maybe<Array<Maybe<IsPartOfEdge>>>;
  isServedBy?: Maybe<Array<Maybe<Thing>>>;
  isServedByEdges?: Maybe<Array<Maybe<IsServedByEdge>>>;
  mappingKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  points?: Maybe<Array<Maybe<Point>>>;
  rentableArea?: Maybe<AreaQuantity>;
  rentableAreaEdges?: Maybe<Array<Maybe<RentableAreaEdge>>>;
  sites?: Maybe<Array<Maybe<Site>>>;
  things?: Maybe<Array<Maybe<Thing>>>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
  usableArea?: Maybe<AreaQuantity>;
  usableAreaEdges?: Maybe<Array<Maybe<UsableAreaEdge>>>;
};


export type GenericPlaceCalendarEventsArgs = {
  filter?: Maybe<CalendarEventFilter>;
};


export type GenericPlaceCollectionsArgs = {
  filter?: Maybe<CollectionFilter>;
};


export type GenericPlaceConnectorsArgs = {
  filter?: Maybe<ConnectorFilterInput>;
};


export type GenericPlaceFloorsArgs = {
  filter?: Maybe<FloorFilter>;
};


export type GenericPlaceGrossAreaArgs = {
  filter?: Maybe<AreaQuantityFilter>;
};


export type GenericPlaceHasPartArgs = {
  filter?: Maybe<PlaceFilter>;
};


export type GenericPlaceHasPointArgs = {
  filter?: Maybe<PointFilter>;
};


export type GenericPlaceIsAdjacentToArgs = {
  filter?: Maybe<PlaceFilter>;
};


export type GenericPlaceIsFedByArgs = {
  filter?: Maybe<ThingFilter>;
};


export type GenericPlaceIsLocationOfArgs = {
  filter?: Maybe<EntityFilter>;
};


export type GenericPlaceIsPartOfArgs = {
  filter?: Maybe<PlaceFilter>;
};


export type GenericPlaceIsServedByArgs = {
  filter?: Maybe<ThingFilter>;
};


export type GenericPlacePointsArgs = {
  filter?: Maybe<PointFilter>;
};


export type GenericPlaceRentableAreaArgs = {
  filter?: Maybe<AreaQuantityFilter>;
};


export type GenericPlaceSitesArgs = {
  filter?: Maybe<SiteFilter>;
};


export type GenericPlaceThingsArgs = {
  filter?: Maybe<ThingFilter>;
};


export type GenericPlaceUsableAreaArgs = {
  filter?: Maybe<AreaQuantityFilter>;
};

export type GenericPlaceIdentityUnion = AccessCredentialIdentity | BaCnetObjectId | BaCnetVendorId | EmailAddressIdentity | EmailIdentity | ExternalIdentity | FloorLevelIdentity | GenericIdentity | NameIdentity | PostalAddressIdentity | SpaceCode;


export type GeoPoint = {
  __typename?: 'GeoPoint';
  coordinates?: Maybe<Array<Maybe<Scalars['Float']>>>;
  type?: Maybe<Scalars['String']>;
};

export type GeoPointQuantity = {
  __typename?: 'GeoPointQuantity';
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type GeoPointQuantityFilter = {
  and?: Maybe<Array<Maybe<GeoPointQuantityFilter>>>;
  not?: Maybe<GeoPointQuantityFilter>;
  or?: Maybe<Array<Maybe<GeoPointQuantityFilter>>>;
};

export type GeolocationEdge = Edge & {
  __typename?: 'GeolocationEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

/** Currently in development; will contain the details about an access grant. */
export type Grant = {
  __typename?: 'Grant';
  approvalTime?: Maybe<Scalars['DateTime']>;
  grantedPlacesAndTypes?: Maybe<Array<Maybe<GrantPlacesAndTypes>>>;
  granteeUserId?: Maybe<Scalars['String']>;
  grantorNotes?: Maybe<Array<Maybe<GrantNote>>>;
  grantorUserId?: Maybe<Scalars['String']>;
  /** The unique ID of the grant. */
  id?: Maybe<Scalars['String']>;
  requestTime?: Maybe<Scalars['DateTime']>;
  requests?: Maybe<Array<Maybe<GrantRequest>>>;
  state?: Maybe<GrantState>;
  updateTime?: Maybe<Scalars['DateTime']>;
};

/** Contains the input values needed to create an access grant. */
export type GrantCreateRequestInput = {
  requestedAddress?: Maybe<PostalAddressInput>;
  requests?: Maybe<Array<Maybe<GrantRequestInput>>>;
};

export type GrantCreateResponse = {
  __typename?: 'GrantCreateResponse';
  id?: Maybe<Scalars['String']>;
};

/** Contains the input values needed to delete an access grant. */
export type GrantDeleteRequestInput = {
  grantorNote?: Maybe<Scalars['String']>;
  ids?: Maybe<Array<Maybe<Scalars['String']>>>;
  maintainChain?: Maybe<Scalars['Boolean']>;
};

export type GrantDeleteResponse = {
  __typename?: 'GrantDeleteResponse';
  _?: Maybe<Scalars['String']>;
};

/** Contains the input values needed to filter grant queries. */
export type GrantFilterInput = {
  /** Used to combine multiple filter criteria. */
  and?: Maybe<Array<Maybe<GrantFilterInput>>>;
  grantedIds?: Maybe<IdFilterExpressionInput>;
  grantedTypes?: Maybe<SystemTypeFilterExpressionInput>;
  granteeUserId?: Maybe<IdFilterExpressionInput>;
  grantorUserId?: Maybe<IdFilterExpressionInput>;
  /** Used to filter for a specific ID or IDs (refer to IDFilterExpressionInput for input options). */
  id?: Maybe<IdFilterExpressionInput>;
  /** Used to omit a specific result or results from the response. */
  not?: Maybe<Array<Maybe<GrantFilterInput>>>;
  /** Used to return results that match at least one of the defined criteria. */
  or?: Maybe<Array<Maybe<GrantFilterInput>>>;
  state?: Maybe<GrantStateFilterExpressionInput>;
};

export type GrantNote = {
  __typename?: 'GrantNote';
  note?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
};

export type GrantPlacesAndTypes = {
  __typename?: 'GrantPlacesAndTypes';
  grantedIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  grantedSystemTypes?: Maybe<Array<Maybe<SystemTypeKey>>>;
};

export type GrantPlacesAndTypesInput = {
  grantedIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  grantedSystemTypes?: Maybe<Array<Maybe<SystemTypeKeyInput>>>;
};

export type GrantRequest = {
  __typename?: 'GrantRequest';
  requestNote?: Maybe<Scalars['String']>;
  requestType?: Maybe<GrantRequestType>;
  systemTypes?: Maybe<Array<Maybe<SystemTypeKey>>>;
};

export type GrantRequestInput = {
  requestNote?: Maybe<Scalars['String']>;
  requestType?: Maybe<GrantRequestTypeInput>;
  systemTypes?: Maybe<Array<Maybe<SystemTypeKeyInput>>>;
};

export enum GrantRequestType {
  EntireBuildings = 'ENTIRE_BUILDINGS',
  EntireFloors = 'ENTIRE_FLOORS',
  EntireSite = 'ENTIRE_SITE',
  PartialFloors = 'PARTIAL_FLOORS',
  RequestedUnspecified = 'REQUESTED_UNSPECIFIED'
}

export enum GrantRequestTypeInput {
  EntireBuildings = 'ENTIRE_BUILDINGS',
  EntireFloors = 'ENTIRE_FLOORS',
  EntireSite = 'ENTIRE_SITE',
  PartialFloors = 'PARTIAL_FLOORS',
  RequestedUnspecified = 'REQUESTED_UNSPECIFIED'
}

export enum GrantState {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  GrantstateUnspecified = 'GRANTSTATE_UNSPECIFIED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type GrantStateFilterExpressionInput = {
  eq?: Maybe<GrantStateInput>;
  in?: Maybe<Array<Maybe<GrantStateInput>>>;
};

export enum GrantStateInput {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  GrantstateUnspecified = 'GRANTSTATE_UNSPECIFIED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** Contains the input values needed to update an access grant. */
export type GrantUpdateRequestInput = {
  grantedPlacesAndTypes?: Maybe<Array<Maybe<GrantPlacesAndTypesInput>>>;
  grantorNote?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  requests?: Maybe<Array<Maybe<GrantRequestInput>>>;
  state?: Maybe<GrantStateInput>;
};

export type GrantUpdateResponse = {
  __typename?: 'GrantUpdateResponse';
  _?: Maybe<Scalars['String']>;
};

export type GranularInput = {
  add?: Maybe<Array<Maybe<Scalars['String']>>>;
  remove?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** The list of available graph edge directions */
export enum GraphEdgeDirection {
  In = 'IN',
  Out = 'OUT'
}

export type GraphNode = {
  connectedDataSourceId?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  exactType?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  mappingKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type GrossAreaEdge = Edge & {
  __typename?: 'GrossAreaEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type Hmac256 = {
  __typename?: 'HMAC256';
  signingKeys?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Hmac256Input = {
  signingKeys?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum HttpMethod {
  Connect = 'CONNECT',
  Delete = 'DELETE',
  Get = 'GET',
  Head = 'HEAD',
  HttpmethodUnspecified = 'HTTPMETHOD_UNSPECIFIED',
  Options = 'OPTIONS',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT',
  Trace = 'TRACE'
}

export enum HttpMethodInput {
  Connect = 'CONNECT',
  Delete = 'DELETE',
  Get = 'GET',
  Head = 'HEAD',
  HttpmethodUnspecified = 'HTTPMETHOD_UNSPECIFIED',
  Options = 'OPTIONS',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT',
  Trace = 'TRACE'
}

export type HttpMethodWrapperInput = {
  value?: Maybe<HttpMethodInput>;
};

export type HasAccessCredentialEdge = Edge & {
  __typename?: 'HasAccessCredentialEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type HasAddressEdge = Edge & {
  __typename?: 'HasAddressEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type HasAssignedGroupEdge = Edge & {
  __typename?: 'HasAssignedGroupEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type HasAssigneeEdge = Edge & {
  __typename?: 'HasAssigneeEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type HasBillEdge = Edge & {
  __typename?: 'HasBillEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type HasDeviceModelEdge = Edge & {
  __typename?: 'HasDeviceModelEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type HasHeartbeatEdge = Edge & {
  __typename?: 'HasHeartbeatEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type HasLocationEdge = Edge & {
  __typename?: 'HasLocationEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type HasMemberEdge = Edge & {
  __typename?: 'HasMemberEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type HasPartEdge = Edge & {
  __typename?: 'HasPartEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type HasPartUnion = Building | Collection | Floor | GenericPlace | Site | Space | SubBuilding | Thing | Zone;

export type HasPointEdge = Edge & {
  __typename?: 'HasPointEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type HasPrimaryContactEdge = Edge & {
  __typename?: 'HasPrimaryContactEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type HasProviderEdge = Edge & {
  __typename?: 'HasProviderEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type Heartbeat = GraphNode & {
  __typename?: 'Heartbeat';
  connectedDataSourceId?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  exactType?: Maybe<Scalars['String']>;
  hasHeartbeat?: Maybe<Heartbeat>;
  hasHeartbeatEdges?: Maybe<Array<Maybe<HasHeartbeatEdge>>>;
  id: Scalars['String'];
  identities?: Maybe<Array<Maybe<HeartbeatIdentityUnion>>>;
  isBilledTo?: Maybe<Account>;
  isBilledToEdges?: Maybe<Array<Maybe<IsBilledToEdge>>>;
  isPointOf?: Maybe<Array<Maybe<IsPointOfUnion>>>;
  isPointOfEdges?: Maybe<Array<Maybe<IsPointOfEdge>>>;
  mappingKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type HeartbeatHasHeartbeatArgs = {
  filter?: Maybe<HeartbeatFilter>;
};


export type HeartbeatIsBilledToArgs = {
  filter?: Maybe<AccountFilter>;
};


export type HeartbeatIsPointOfArgs = {
  filter?: Maybe<EntityFilter>;
};

export type HeartbeatFilter = {
  and?: Maybe<Array<Maybe<HeartbeatFilter>>>;
  connectedDataSourceId?: Maybe<StringFilterExpressionInput>;
  dateCreated?: Maybe<TimestampFilterExpressionInput>;
  dateUpdated?: Maybe<TimestampFilterExpressionInput>;
  exactType?: Maybe<StringFilterExpressionInput>;
  id?: Maybe<IdFilterExpressionInput>;
  mappingKey?: Maybe<StringFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  not?: Maybe<HeartbeatFilter>;
  or?: Maybe<Array<Maybe<HeartbeatFilter>>>;
  type?: Maybe<StringArrayFilterExpressionInput>;
  unused?: Maybe<SimpleBoolFilterExpressionInput>;
};

export type HeartbeatIdentityUnion = AccessCredentialIdentity | BaCnetObjectId | BaCnetVendorId | EmailAddressIdentity | EmailIdentity | ExternalIdentity | FloorLevelIdentity | GenericIdentity | NameIdentity | PostalAddressIdentity | SpaceCode | SubBuildingCode;

/** Used as the input control for the filter, determining if you're looking for a single result or multiple results. */
export type IdFilterExpressionInput = {
  /** Use this field to filter for a single, specific ID. */
  eq?: Maybe<Scalars['String']>;
  /** Use this field to return results for all IDs present in a set, like [ID12345, ID67890]. */
  in?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type IpAllowlistMatch = {
  __typename?: 'IPAllowlistMatch';
  allowedIps?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type IpAllowlistMatchInput = {
  allowedIps?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Identity = {
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<ScopeKey>;
  scopeId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type IntFilterExpressionInput = {
  eq?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
};

export enum Interval {
  IntervalCustom = 'INTERVAL_CUSTOM',
  IntervalEvery_3Months = 'INTERVAL_EVERY_3_MONTHS',
  IntervalEvery_6Months = 'INTERVAL_EVERY_6_MONTHS',
  IntervalEveryMonth = 'INTERVAL_EVERY_MONTH',
  IntervalEveryYear = 'INTERVAL_EVERY_YEAR',
  IntervalOneTime = 'INTERVAL_ONE_TIME',
  IntervalUnspecified = 'INTERVAL_UNSPECIFIED'
}

/** Contains the details about a user invite. */
export type Invite = {
  __typename?: 'Invite';
  /** This timestamp represents the date the invite was created. */
  created?: Maybe<Scalars['DateTime']>;
  /** The email of the user receiving the invite. */
  email?: Maybe<Scalars['String']>;
  /** The expiration of the invite; once an invite expires, it cannot be accepted any longer. */
  expiration?: Maybe<Scalars['DateTime']>;
  /** The id of the invite itself. */
  id?: Maybe<Scalars['String']>;
  /** The id of the user that is created after accepting the invite. */
  inviterUserId?: Maybe<Scalars['String']>;
  /** The organization the user was invited to join. */
  organization?: Maybe<Org>;
  /** The role or roles assigned to the user when they accept the invite, such as ADMIN. */
  roles?: Maybe<Array<Maybe<Role>>>;
  /** The current status of the invite, such as PENDING or ACCEPTED. */
  status?: Maybe<InviteStatus>;
};

export type InviteCreateRequestInput = {
  invite?: Maybe<InviteInput>;
  skipSendEmail?: Maybe<Scalars['Boolean']>;
};

export type InviteCreateResponse = {
  __typename?: 'InviteCreateResponse';
  invite?: Maybe<Invite>;
  inviteToken?: Maybe<Scalars['String']>;
};

export type InviteDeleteRequestInput = {
  id?: Maybe<Scalars['String']>;
};

export type InviteDeleteResponse = {
  __typename?: 'InviteDeleteResponse';
  _?: Maybe<Scalars['String']>;
};

export type InviteFilterInput = {
  and?: Maybe<Array<Maybe<InviteFilterInput>>>;
  email?: Maybe<StringFilterExpressionInput>;
  inviteId?: Maybe<IdFilterExpressionInput>;
  not?: Maybe<Array<Maybe<InviteFilterInput>>>;
  or?: Maybe<Array<Maybe<InviteFilterInput>>>;
  state?: Maybe<InviteStatusFilterExpressionInput>;
};

/** Contains the details about a user invite. */
export type InviteInput = {
  /** This timestamp represents the date the invite was created. */
  created?: Maybe<Scalars['DateTime']>;
  /** The email of the user receiving the invite. */
  email?: Maybe<Scalars['String']>;
  /** The expiration of the invite; once an invite expires, it cannot be accepted any longer. */
  expiration?: Maybe<Scalars['DateTime']>;
  /** The id of the invite itself. */
  id?: Maybe<Scalars['String']>;
  /** The id of the user that is created after accepting the invite. */
  inviterUserId?: Maybe<Scalars['String']>;
  /** The role or roles assigned to the user when they accept the invite, such as ADMIN. */
  roles?: Maybe<Array<Maybe<RoleInput>>>;
  /** The current status of the invite, such as PENDING or ACCEPTED. */
  status?: Maybe<InviteStatusInput>;
};

export enum InviteStatus {
  Accepted = 'ACCEPTED',
  Deleted = 'DELETED',
  Expired = 'EXPIRED',
  InviteStatusUnspecified = 'INVITE_STATUS_UNSPECIFIED',
  Pending = 'PENDING',
  Redeemed = 'REDEEMED'
}

export type InviteStatusFilterExpressionInput = {
  eq?: Maybe<InviteStatusInput>;
  in?: Maybe<Array<Maybe<InviteStatusInput>>>;
};

export enum InviteStatusInput {
  Accepted = 'ACCEPTED',
  Deleted = 'DELETED',
  Expired = 'EXPIRED',
  InviteStatusUnspecified = 'INVITE_STATUS_UNSPECIFIED',
  Pending = 'PENDING',
  Redeemed = 'REDEEMED'
}

export type InviteUpdateRequestInput = {
  invite?: Maybe<InviteInput>;
};

export type InviteUpdateResponse = {
  __typename?: 'InviteUpdateResponse';
  invite?: Maybe<Invite>;
};

export type IsAdjacentToEdge = Edge & {
  __typename?: 'IsAdjacentToEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type IsBilledToEdge = Edge & {
  __typename?: 'IsBilledToEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type IsClosedByEdge = Edge & {
  __typename?: 'IsClosedByEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type IsCreatedByEdge = Edge & {
  __typename?: 'IsCreatedByEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type IsFedByEdge = Edge & {
  __typename?: 'IsFedByEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type IsFedByUnion = Collection | Thing;

export type IsLocationOfEdge = Edge & {
  __typename?: 'IsLocationOfEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type IsLocationOfUnion = Collection | Thing;

export type IsMemberOfEdge = Edge & {
  __typename?: 'IsMemberOfEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type IsPartOfEdge = Edge & {
  __typename?: 'IsPartOfEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type IsPointOfEdge = Edge & {
  __typename?: 'IsPointOfEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type IsPointOfUnion = Building | Collection | Floor | GenericPlace | Site | Space | SubBuilding | Thing | Zone;

export type IsReportedByEdge = Edge & {
  __typename?: 'IsReportedByEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type IsResponsibilityOfEdge = Edge & {
  __typename?: 'IsResponsibilityOfEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type IsResponsibleForEdge = Edge & {
  __typename?: 'IsResponsibleForEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type IsServedByEdge = Edge & {
  __typename?: 'IsServedByEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};



export type Lease = GraphNode & {
  __typename?: 'Lease';
  connectedDataSourceId?: Maybe<Scalars['String']>;
  connectors?: Maybe<Array<Maybe<Connector>>>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  exactType?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  identities?: Maybe<Array<Maybe<LeaseIdentityUnion>>>;
  leaseOf?: Maybe<Array<Place>>;
  leasee?: Maybe<Org>;
  mappingKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type LeaseConnectorsArgs = {
  filter?: Maybe<ConnectorFilterInput>;
};


export type LeaseLeaseOfArgs = {
  filter?: Maybe<PlaceFilter>;
};

export type LeaseFilter = {
  and?: Maybe<Array<Maybe<LeaseFilter>>>;
  connectedDataSourceId?: Maybe<StringFilterExpressionInput>;
  dateCreated?: Maybe<TimestampFilterExpressionInput>;
  dateUpdated?: Maybe<TimestampFilterExpressionInput>;
  exactType?: Maybe<StringFilterExpressionInput>;
  id?: Maybe<IdFilterExpressionInput>;
  mappingKey?: Maybe<StringFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  not?: Maybe<LeaseFilter>;
  or?: Maybe<Array<Maybe<LeaseFilter>>>;
  type?: Maybe<StringArrayFilterExpressionInput>;
};

export type LeaseIdentityUnion = AccessCredentialIdentity | BaCnetObjectId | BaCnetVendorId | EmailAddressIdentity | EmailIdentity | ExternalIdentity | FloorLevelIdentity | GenericIdentity | NameIdentity | PostalAddressIdentity | SpaceCode | SubBuildingCode;

/** Contains all the detals about a live query. */
export type LiveQuery = {
  __typename?: 'LiveQuery';
  /** This timestamp represents the date the live query was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** This timestamp represents the date the lie query was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The unique id of the live query. */
  id?: Maybe<Scalars['String']>;
  /** This timestamp represents the last time the live query encountered an error. */
  lastErrorDate?: Maybe<Scalars['DateTime']>;
  /** This returns the last result of the live query, in standard Mapped JSON format. */
  lastResult?: Maybe<Scalars['GraphQLJSON']>;
  /** This timestamp represents the date for the most recent live query result. */
  lastResultDate?: Maybe<Scalars['DateTime']>;
  /** The unique name of the live query. */
  name?: Maybe<Scalars['String']>;
  /** The organization the live query belongs to. */
  organization?: Maybe<Org>;
  /** The query being run by the live query, i.e. the request being made to the Mapped API. */
  query?: Maybe<Scalars['String']>;
  /** This identifies whether the live query is currently RUNNING, PAUSED, FAILED or LIVE_QUERY_STATUS_UNSPECIFIED. */
  status?: Maybe<LiveQueryStatus>;
  /** The user the live query belong to. */
  user?: Maybe<User>;
  variables?: Maybe<Scalars['GraphQLJSON']>;
};

export type LiveQueryCreateRequestInput = {
  liveQuery?: Maybe<LiveQueryInput>;
};

export type LiveQueryCreateResponse = {
  __typename?: 'LiveQueryCreateResponse';
  liveQuery?: Maybe<LiveQuery>;
};

export type LiveQueryDeleteRequestInput = {
  id?: Maybe<Scalars['String']>;
};

export type LiveQueryDeleteResponse = {
  __typename?: 'LiveQueryDeleteResponse';
  _?: Maybe<Scalars['String']>;
};

export type LiveQueryFilterInput = {
  and?: Maybe<Array<Maybe<LiveQueryFilterInput>>>;
  id?: Maybe<IdFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  not?: Maybe<Array<Maybe<LiveQueryFilterInput>>>;
  or?: Maybe<Array<Maybe<LiveQueryFilterInput>>>;
  status?: Maybe<LiveQueryStatusFilterExpressionInput>;
};

/** Contains all the detals about a live query. */
export type LiveQueryInput = {
  /** This timestamp represents the date the live query was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** This timestamp represents the date the lie query was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The unique id of the live query. */
  id?: Maybe<Scalars['String']>;
  /** This timestamp represents the last time the live query encountered an error. */
  lastErrorDate?: Maybe<Scalars['DateTime']>;
  /** This timestamp represents the date for the most recent live query result. */
  lastResultDate?: Maybe<Scalars['DateTime']>;
  /** The unique name of the live query. */
  name?: Maybe<Scalars['String']>;
  /** The query being run by the live query, i.e. the request being made to the Mapped API. */
  query?: Maybe<Scalars['String']>;
  /** This identifies whether the live query is currently RUNNING, PAUSED, FAILED or LIVE_QUERY_STATUS_UNSPECIFIED. */
  status?: Maybe<LiveQueryStatusInput>;
  variables?: Maybe<Scalars['GraphQLJSON']>;
};

export type LiveQueryPauseRequestInput = {
  id?: Maybe<Scalars['String']>;
};

export type LiveQueryPauseResponse = {
  __typename?: 'LiveQueryPauseResponse';
  _?: Maybe<Scalars['String']>;
};

export type LiveQueryResumeRequestInput = {
  id?: Maybe<Scalars['String']>;
};

export type LiveQueryResumeResponse = {
  __typename?: 'LiveQueryResumeResponse';
  _?: Maybe<Scalars['String']>;
};

/** Contains the details about the status field for a live query. */
export enum LiveQueryStatus {
  /** The live query encountered an error and is not running; contact support@mapped.com for help. */
  Failing = 'FAILING',
  /** The live query is returning an uncategorized status; contact support@mapped.com for help. */
  LiveQueryStatusUnspecified = 'LIVE_QUERY_STATUS_UNSPECIFIED',
  /** The live query is paused, using pauseLiveQuery. Use resumeLiveQuery to restore it to active. */
  Paused = 'PAUSED',
  /** The live query is actively running and monitoring for changes to the defined query. */
  Running = 'RUNNING'
}

export type LiveQueryStatusFilterExpressionInput = {
  eq?: Maybe<LiveQueryStatusInput>;
  in?: Maybe<Array<Maybe<LiveQueryStatusInput>>>;
};

/** Contains the details about the status field for a live query. */
export enum LiveQueryStatusInput {
  /** The live query encountered an error and is not running; contact support@mapped.com for help. */
  Failing = 'FAILING',
  /** The live query is returning an uncategorized status; contact support@mapped.com for help. */
  LiveQueryStatusUnspecified = 'LIVE_QUERY_STATUS_UNSPECIFIED',
  /** The live query is paused, using pauseLiveQuery. Use resumeLiveQuery to restore it to active. */
  Paused = 'PAUSED',
  /** The live query is actively running and monitoring for changes to the defined query. */
  Running = 'RUNNING'
}

export type LiveQueryUpdateInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type LiveQueryUpdateRequestInput = {
  liveQuery?: Maybe<LiveQueryUpdateInput>;
};

export type LiveQueryUpdateResponse = {
  __typename?: 'LiveQueryUpdateResponse';
  liveQuery?: Maybe<LiveQuery>;
};


export type MtlsMatch = {
  __typename?: 'MTLSMatch';
  clientCert?: Maybe<Certificate>;
  issuerCert?: Maybe<Certificate>;
  mappedCert?: Maybe<Scalars['Boolean']>;
  matchCert?: Maybe<CertMatch>;
};

export type MtlsMatchInput = {
  clientCert?: Maybe<CertificateInput>;
  issuerCert?: Maybe<CertificateInput>;
  mappedCert?: Maybe<Scalars['Boolean']>;
  matchCert?: Maybe<CertMatchInput>;
};

export type ManufacturedByEdge = Edge & {
  __typename?: 'ManufacturedByEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};


export type Match = {
  __typename?: 'Match';
  ipAllowlist?: Maybe<IpAllowlistMatch>;
  mtls?: Maybe<MtlsMatch>;
  noAuth?: Maybe<Scalars['Boolean']>;
  regex?: Maybe<RegexMatch>;
  signature?: Maybe<SignatureMatch>;
  value?: Maybe<ValueMatch>;
};

export type MatchInput = {
  ipAllowlist?: Maybe<IpAllowlistMatchInput>;
  mtls?: Maybe<MtlsMatchInput>;
  noAuth?: Maybe<Scalars['Boolean']>;
  regex?: Maybe<RegexMatchInput>;
  signature?: Maybe<SignatureMatchInput>;
  value?: Maybe<ValueMatchInput>;
};

export type MetadataEntry = {
  __typename?: 'MetadataEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type MetadataRecord = {
  __typename?: 'MetadataRecord';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type MetadataRecordInput = {
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type MetadataUpdateInput = {
  granular?: Maybe<GranularInput>;
  replace?: Maybe<MetadataValueInput>;
};

export type MetadataValueInput = {
  values?: Maybe<Array<Maybe<MetadataRecordInput>>>;
};

/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type Mutation = {
  __typename?: 'Mutation';
  /** Used to assign a provisioned gateway to a building and/or spaces. */
  assignGateway?: Maybe<GatewayAssignResponse>;
  /** Used to assign a new acount role to a user (such as ADMIN); does not remove the previously assigned role. */
  assignRole?: Maybe<UserAssignRoleResponse>;
  /** Used to create a new building for a specific site. */
  createBuilding?: Maybe<BuildingCreateResponse>;
  /** Currently in development; will be used to create a new Connector. */
  createConnector?: Maybe<ConnectorCreateResponse>;
  /** Currently in development; will be used to create the auth details for a Connector, including token details. */
  createConnectorAuth?: Maybe<ConnectorAuthCreateResponse>;
  createConnectorRequest?: Maybe<ConnectorRequestCreateResponse>;
  createContributionRequest?: Maybe<ContributionRequestCreateResponse>;
  /** Used to create a new floor for a specific building. */
  createFloor?: Maybe<FloorCreateResponse>;
  /** Currently in development; will be used to add an access right grant to an external user so they can view specific organization place data (like granting building tenants the right to view data about a particular space). */
  createGrant?: Maybe<GrantCreateResponse>;
  /** Used to create a new invite to add a new user to the org. */
  createInvite?: Maybe<InviteCreateResponse>;
  /** Used to create a new live query. */
  createLiveQuery?: Maybe<LiveQueryCreateResponse>;
  createOrgRoleGroup?: Maybe<OrgRoleGroupCreateResponse>;
  createOrgServiceAccount?: Maybe<OrgServiceAccountCreateResponse>;
  /** Used to create a new personal access token, assuming the token you're using has the needed scope (PERSONALACCESSTOKEN_READWRITE or the admin scope PERSONALACCESSTOKEN_READWRITE_ALL). */
  createPersonalAccessToken?: Maybe<PersonalAccessTokenCreateResponse>;
  createSecretOrgServiceAccount?: Maybe<OrgServiceAccountCreateSecretResponse>;
  /** Used to create a new site for the org. */
  createSite?: Maybe<SiteCreateResponse>;
  /** Used to create a new space for a floor in a building. */
  createSpace?: Maybe<SpaceCreateResponse>;
  createSubBuilding?: Maybe<SubBuildingCreateResponse>;
  /** Used to create a new user in the organization; only available for admins. */
  createUser?: Maybe<UserCreateResponse>;
  /** Used to create a new webhook. */
  createWebhookTarget?: Maybe<WebhookTargetCreateResponse>;
  /** Used to delete an existing building. */
  deleteBuilding?: Maybe<BuildingDeleteResponse>;
  /** Used to remove an existing Connector. */
  deleteConnector?: Maybe<ConnectorDeleteResponse>;
  /** Used to delete the auth settings for a specific Connector. */
  deleteConnectorAuth?: Maybe<ConnectorAuthDeleteResponse>;
  /** Used to delete an existing floor in a building. */
  deleteFloor?: Maybe<FloorDeleteResponse>;
  /** Currently in development; will be used to remove an access grant from an external user. */
  deleteGrant?: Maybe<GrantDeleteResponse>;
  /** Used to delete an user invite. */
  deleteInvite?: Maybe<InviteDeleteResponse>;
  /** Used to delete a live query. */
  deleteLiveQuery?: Maybe<LiveQueryDeleteResponse>;
  deleteOrgRoleGroup?: Maybe<OrgRoleGroupDeleteResponse>;
  deleteOrgServiceAccount?: Maybe<OrgServiceAccountDeleteResponse>;
  /** Used to delete an existing personal access token, assuming the token you're using has the needed scope (PERSONALACCESSTOKEN_READWRITE or the admin scope PERSONALACCESSTOKEN_READWRITE_ALL). */
  deletePersonalAccessToken?: Maybe<PersonalAccessTokenDeleteResponse>;
  deleteSecretsOrgServiceAccount?: Maybe<OrgServiceAccountDeleteSecretsResponse>;
  /** Used to delete a specific site from the org. */
  deleteSite?: Maybe<SiteDeleteResponse>;
  /** Used to delete a specific space from a floor in a building. */
  deleteSpace?: Maybe<SpaceDeleteResponse>;
  deleteSubBuilding?: Maybe<SubBuildingDeleteResponse>;
  deleteWebhookReceiver?: Maybe<WebhookReceiverDeleteResponse>;
  /** Used to delete a specific webhook. */
  deleteWebhookTarget?: Maybe<WebhookTargetDeleteResponse>;
  /** Used to enable or disable a webhook using a true / false boolean. */
  enableWebhookTarget?: Maybe<WebhookTargetEnableResponse>;
  /** Used to generate containerized software gateway security identifiers. */
  generateContainerSIDs?: Maybe<GatewayGenerateContainerSiDsResponse>;
  getEdgeProfileByFingerprint?: Maybe<EdgeProfileGetByFingerprintResponse>;
  getEdgeProfileFields?: Maybe<EdgeProfileGetFieldsResponse>;
  /** Used to pause a live query, so it stops actively monitoring for changes. */
  pauseLiveQuery?: Maybe<LiveQueryPauseResponse>;
  /** Creates the container for a software gateway. */
  registerGatewayContainer?: Maybe<GatewayRegisterContainerResponse>;
  /** Currently in development; will be used to remove an access grant related org membership for a particular user. */
  removeOrgMembershipUser?: Maybe<UserRemoveOrgMembershipResponse>;
  removeOrgUser?: Maybe<OrgRemoveOrgUserAsyncResponse>;
  /** Used to remove a role from a user (such as ADMIN). */
  removeRole?: Maybe<UserRemoveRoleResponse>;
  /** Used to restart a Connector, typically a troubleshooting step if a Connector ceases to feed data to the graph. */
  restartConnector?: Maybe<ConnectorRestartResponse>;
  /** Used to resume/restart a live query that was paused, so it starts actively monitoring for changes again. */
  resumeLiveQuery?: Maybe<LiveQueryResumeResponse>;
  /** Used to start a Connector back up after it was stopped. */
  startConnector?: Maybe<ConnectorStartResponse>;
  /** Used to stop a Connector from polling for data or processing incoming webhook data. All config and mapping is preserved. */
  stopConnector?: Maybe<ConnectorStopResponse>;
  /** Used to suspend a gateway; this takes the gateway offline and prevents it from receiving or sending any further data. */
  suspendGateway?: Maybe<GatewaySuspendResponse>;
  /** Used to update the details of a specific building. */
  updateBuilding?: Maybe<BuildingUpdateResponse>;
  /** Used to update an existing Connector. */
  updateConnector?: Maybe<ConnectorUpdateResponse>;
  updateConnectorAuth?: Maybe<ConnectorAuthUpdateResponse>;
  /** Used to update the details of a specific floor in a building. */
  updateFloor?: Maybe<FloorUpdateResponse>;
  /** Currently in development; will be used to update/modify an existing access grant. */
  updateGrant?: Maybe<GrantUpdateResponse>;
  /** Used to update the details of a specific user invite. */
  updateInvite?: Maybe<InviteUpdateResponse>;
  /** Used to update the details of a specific live query. */
  updateLiveQuery?: Maybe<LiveQueryUpdateResponse>;
  updateOrgRoleGroup?: Maybe<OrgRoleGroupUpdateResponse>;
  updateOrgServiceAccount?: Maybe<OrgServiceAccountUpdateResponse>;
  /** Used to update your organization information, such as the organization name. */
  updateOrganization?: Maybe<OrgUpdateResponse>;
  updateOrganizationV2?: Maybe<OrgUpdateV2Response>;
  /** Used to update the scopes of an existing personal access token. */
  updatePersonalAccessToken?: Maybe<PersonalAccessTokenUpdateResponse>;
  /** Used to update the details of a specific site. */
  updateSite?: Maybe<SiteUpdateResponse>;
  /** Used to update the details of a specific space on a floor in a building. */
  updateSpace?: Maybe<SpaceUpdateResponse>;
  updateSubBuilding?: Maybe<SubBuildingUpdateResponse>;
  /** Used to update information about a user. If you're using an admin token, you can update the information of other users; if not, you can only update your own details. */
  updateUser?: Maybe<UserUpdateResponse>;
  /** Used to update the details of a specific webhook. */
  updateWebhookTarget?: Maybe<WebhookTargetUpdateResponse>;
  /** Currently in development; will be used to update an existing connector configuration, or create a new configuration if one does not already exist. */
  upsertConfigConnector?: Maybe<ConnectorUpsertConfigResponse>;
  upsertWebhookReceiver?: Maybe<WebhookReceiverUpsertResponse>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationAssignGatewayArgs = {
  input?: Maybe<GatewayAssignRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationAssignRoleArgs = {
  input?: Maybe<UserAssignRoleRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationCreateBuildingArgs = {
  input?: Maybe<BuildingCreateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationCreateConnectorArgs = {
  input?: Maybe<ConnectorCreateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationCreateConnectorAuthArgs = {
  input?: Maybe<ConnectorAuthCreateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationCreateConnectorRequestArgs = {
  input?: Maybe<ConnectorRequestCreateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationCreateContributionRequestArgs = {
  input?: Maybe<ContributionRequestCreateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationCreateFloorArgs = {
  input?: Maybe<FloorCreateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationCreateGrantArgs = {
  input?: Maybe<GrantCreateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationCreateInviteArgs = {
  input?: Maybe<InviteCreateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationCreateLiveQueryArgs = {
  input?: Maybe<LiveQueryCreateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationCreateOrgRoleGroupArgs = {
  input?: Maybe<OrgRoleGroupCreateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationCreateOrgServiceAccountArgs = {
  input?: Maybe<OrgServiceAccountCreateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationCreatePersonalAccessTokenArgs = {
  input?: Maybe<PersonalAccessTokenCreateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationCreateSecretOrgServiceAccountArgs = {
  input?: Maybe<OrgServiceAccountCreateSecretRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationCreateSiteArgs = {
  input?: Maybe<SiteCreateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationCreateSpaceArgs = {
  input?: Maybe<SpaceCreateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationCreateSubBuildingArgs = {
  input?: Maybe<SubBuildingCreateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationCreateUserArgs = {
  input?: Maybe<UserCreateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationCreateWebhookTargetArgs = {
  input?: Maybe<WebhookTargetCreateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationDeleteBuildingArgs = {
  input?: Maybe<BuildingDeleteRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationDeleteConnectorArgs = {
  input?: Maybe<ConnectorDeleteRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationDeleteConnectorAuthArgs = {
  input?: Maybe<ConnectorAuthDeleteRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationDeleteFloorArgs = {
  input?: Maybe<FloorDeleteRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationDeleteGrantArgs = {
  input?: Maybe<GrantDeleteRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationDeleteInviteArgs = {
  input?: Maybe<InviteDeleteRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationDeleteLiveQueryArgs = {
  input?: Maybe<LiveQueryDeleteRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationDeleteOrgRoleGroupArgs = {
  input?: Maybe<OrgRoleGroupDeleteRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationDeleteOrgServiceAccountArgs = {
  input?: Maybe<OrgServiceAccountDeleteRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationDeletePersonalAccessTokenArgs = {
  input?: Maybe<PersonalAccessTokenDeleteRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationDeleteSecretsOrgServiceAccountArgs = {
  input?: Maybe<OrgServiceAccountDeleteSecretsRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationDeleteSiteArgs = {
  input?: Maybe<SiteDeleteRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationDeleteSpaceArgs = {
  input?: Maybe<SpaceDeleteRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationDeleteSubBuildingArgs = {
  input?: Maybe<SubBuildingDeleteRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationDeleteWebhookReceiverArgs = {
  input?: Maybe<WebhookReceiverDeleteRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationDeleteWebhookTargetArgs = {
  input?: Maybe<WebhookTargetDeleteRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationEnableWebhookTargetArgs = {
  input?: Maybe<WebhookTargetEnableRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationGenerateContainerSiDsArgs = {
  input?: Maybe<GatewayGenerateContainerSiDsRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationGetEdgeProfileByFingerprintArgs = {
  input?: Maybe<EdgeProfileGetByFingerprintRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationGetEdgeProfileFieldsArgs = {
  input?: Maybe<EdgeProfileGetFieldsRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationPauseLiveQueryArgs = {
  input?: Maybe<LiveQueryPauseRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationRegisterGatewayContainerArgs = {
  input?: Maybe<GatewayRegisterContainerRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationRemoveOrgMembershipUserArgs = {
  input?: Maybe<UserRemoveOrgMembershipRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationRemoveOrgUserArgs = {
  input?: Maybe<OrgRemoveOrgUserAsyncRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationRemoveRoleArgs = {
  input?: Maybe<UserRemoveRoleRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationRestartConnectorArgs = {
  input?: Maybe<ConnectorRestartRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationResumeLiveQueryArgs = {
  input?: Maybe<LiveQueryResumeRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationStartConnectorArgs = {
  input?: Maybe<ConnectorStartRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationStopConnectorArgs = {
  input?: Maybe<ConnectorStopRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationSuspendGatewayArgs = {
  input?: Maybe<GatewaySuspendRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationUpdateBuildingArgs = {
  input?: Maybe<BuildingUpdateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationUpdateConnectorArgs = {
  input?: Maybe<ConnectorUpdateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationUpdateConnectorAuthArgs = {
  input?: Maybe<ConnectorAuthUpdateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationUpdateFloorArgs = {
  input?: Maybe<FloorUpdateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationUpdateGrantArgs = {
  input?: Maybe<GrantUpdateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationUpdateInviteArgs = {
  input?: Maybe<InviteUpdateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationUpdateLiveQueryArgs = {
  input?: Maybe<LiveQueryUpdateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationUpdateOrgRoleGroupArgs = {
  input?: Maybe<OrgRoleGroupUpdateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationUpdateOrgServiceAccountArgs = {
  input?: Maybe<OrgServiceAccountUpdateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationUpdateOrganizationArgs = {
  input?: Maybe<OrgUpdateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationUpdateOrganizationV2Args = {
  input?: Maybe<OrgUpdateV2RequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationUpdatePersonalAccessTokenArgs = {
  input?: Maybe<PersonalAccessTokenUpdateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationUpdateSiteArgs = {
  input?: Maybe<SiteUpdateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationUpdateSpaceArgs = {
  input?: Maybe<SpaceUpdateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationUpdateSubBuildingArgs = {
  input?: Maybe<SubBuildingUpdateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationUpdateUserArgs = {
  input?: Maybe<UserUpdateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationUpdateWebhookTargetArgs = {
  input?: Maybe<WebhookTargetUpdateRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationUpsertConfigConnectorArgs = {
  input?: Maybe<ConnectorUpsertConfigRequestInput>;
};


/** Mutations modify data in the data store. They can be used to insert, update, or delete data. */
export type MutationUpsertWebhookReceiverArgs = {
  input?: Maybe<WebhookReceiverUpsertRequestInput>;
};

export type NameIdentity = Identity & NameIdentityModel & {
  __typename?: 'NameIdentity';
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<ScopeKey>;
  scopeId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type NameIdentityModel = {
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<ScopeKey>;
  scopeId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type NodesMapping = {
  /** GRPC field name in JSON format. You can use dot as a delimiter for nested fields. For example: filter.id.in */
  childField: Scalars['String'];
  /** Parent field (GraphQL source) */
  parentField: Scalars['String'];
};

export type OAuth2ClientCredentialsFlow = {
  __typename?: 'OAuth2ClientCredentialsFlow';
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  headerPrefix?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  tokenEndpoint?: Maybe<Scalars['String']>;
};

export type OAuth2ClientCredentialsFlowInput = {
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  headerPrefix?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  tokenEndpoint?: Maybe<Scalars['String']>;
};

export type OneTimePriceItem = {
  __typename?: 'OneTimePriceItem';
  priceId?: Maybe<Scalars['String']>;
  tier?: Maybe<Tier>;
};

export type OneTimePriceItems = {
  __typename?: 'OneTimePriceItems';
  items?: Maybe<Array<Maybe<OneTimePriceItem>>>;
};

/** Contains the details about a org. */
export type Org = {
  __typename?: 'Org';
  authenticationChallenge?: Maybe<OrgAuthenticationChallenge>;
  /** Contains the list of org connectors, across all places in the org. */
  connectors?: Maybe<Array<Maybe<Connector>>>;
  /** Timestamp for the org creation. */
  created?: Maybe<Scalars['DateTime']>;
  /** Contains the list of org gateways, across all places in the org. */
  gateways?: Maybe<Array<Maybe<Gateway>>>;
  /** The unique ID of the organization. */
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Array<Maybe<MetadataRecord>>>;
  /** The name of the organization. */
  name?: Maybe<Scalars['String']>;
  provisioningState?: Maybe<OrgProvisioningState>;
  /** Contains the list of sites in the org. */
  sites?: Maybe<Array<Maybe<Site>>>;
  state?: Maybe<OrgState>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  /** Contains the list of things, across all places in the org. */
  things?: Maybe<Array<Maybe<Thing>>>;
  updated?: Maybe<Scalars['DateTime']>;
  /** Contains the list of users in the org. */
  users?: Maybe<Array<Maybe<User>>>;
};


/** Contains the details about a org. */
export type OrgConnectorsArgs = {
  filter?: Maybe<ConnectorFilterInput>;
};


/** Contains the details about a org. */
export type OrgGatewaysArgs = {
  filter?: Maybe<GatewayFilterInput>;
};


/** Contains the details about a org. */
export type OrgSitesArgs = {
  filter?: Maybe<SiteFilter>;
};


/** Contains the details about a org. */
export type OrgThingsArgs = {
  filter?: Maybe<ThingFilter>;
};


/** Contains the details about a org. */
export type OrgUsersArgs = {
  filter?: Maybe<UserFilterInput>;
};

export type OrgAuthenticationChallenge = {
  __typename?: 'OrgAuthenticationChallenge';
  connection?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type OrgAuthenticationChallengeGranularInput = {
  connection?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type OrgAuthenticationChallengeInput = {
  connection?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type OrgGranularInput = {
  authenticationChallenge?: Maybe<OrgAuthenticationChallengeGranularInput>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<MetadataUpdateInput>;
  name?: Maybe<Scalars['String']>;
  provisioningState?: Maybe<OrgProvisioningStateWrapperInput>;
  state?: Maybe<OrgStateWrapperInput>;
  stripeCustomerId?: Maybe<Scalars['String']>;
};

/** Contains the details about a org. */
export type OrgInput = {
  authenticationChallenge?: Maybe<OrgAuthenticationChallengeInput>;
  /** Timestamp for the org creation. */
  created?: Maybe<Scalars['DateTime']>;
  /** The unique ID of the organization. */
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Array<Maybe<MetadataRecordInput>>>;
  /** The name of the organization. */
  name?: Maybe<Scalars['String']>;
  provisioningState?: Maybe<OrgProvisioningStateInput>;
  state?: Maybe<OrgStateInput>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type OrgIsOrgNameAvailableResponse = {
  __typename?: 'OrgIsOrgNameAvailableResponse';
  isAvailable?: Maybe<Scalars['Boolean']>;
  suggestedOrgName?: Maybe<Scalars['String']>;
};

export enum OrgProvisioningState {
  ProvisioningStateAccepted = 'PROVISIONING_STATE_ACCEPTED',
  ProvisioningStateComplete = 'PROVISIONING_STATE_COMPLETE',
  ProvisioningStateUnspecified = 'PROVISIONING_STATE_UNSPECIFIED'
}

export enum OrgProvisioningStateInput {
  ProvisioningStateAccepted = 'PROVISIONING_STATE_ACCEPTED',
  ProvisioningStateComplete = 'PROVISIONING_STATE_COMPLETE',
  ProvisioningStateUnspecified = 'PROVISIONING_STATE_UNSPECIFIED'
}

export type OrgProvisioningStateWrapperInput = {
  value?: Maybe<OrgProvisioningStateInput>;
};

export type OrgRemoveOrgUserAsyncRequestInput = {
  orgUser?: Maybe<OrgUserInput>;
};

export type OrgRemoveOrgUserAsyncResponse = {
  __typename?: 'OrgRemoveOrgUserAsyncResponse';
  _?: Maybe<Scalars['String']>;
};

export type OrgRoleGroupCreateRequestInput = {
  orgRoleGroup?: Maybe<OrgRoleGroupInput>;
};

export type OrgRoleGroupCreateResponse = {
  __typename?: 'OrgRoleGroupCreateResponse';
  orgRoleGroup?: Maybe<OrgRoleGroupDto>;
};

export type OrgRoleGroupDto = {
  __typename?: 'OrgRoleGroupDTO';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSynced?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  state?: Maybe<OrgRoleGroupState>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrgRoleGroupDeleteRequestInput = {
  name?: Maybe<Scalars['String']>;
};

export type OrgRoleGroupDeleteResponse = {
  __typename?: 'OrgRoleGroupDeleteResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type OrgRoleGroupFilterInput = {
  and?: Maybe<Array<Maybe<OrgRoleGroupFilterInput>>>;
  description?: Maybe<StringFilterExpressionInput>;
  isSynced?: Maybe<BoolFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  not?: Maybe<Array<Maybe<OrgRoleGroupFilterInput>>>;
  or?: Maybe<Array<Maybe<OrgRoleGroupFilterInput>>>;
  roles?: Maybe<StringArrayFilterExpressionInput>;
  state?: Maybe<OrgRoleGroupStateFilterExpressionInput>;
};

export type OrgRoleGroupInput = {
  description?: Maybe<Scalars['String']>;
  isSynced?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  state?: Maybe<OrgRoleGroupStateInput>;
};

export enum OrgRoleGroupState {
  OrgrolegroupStateDisabled = 'ORGROLEGROUP_STATE_DISABLED',
  OrgrolegroupStateEnabled = 'ORGROLEGROUP_STATE_ENABLED',
  OrgrolegroupStateUnspecified = 'ORGROLEGROUP_STATE_UNSPECIFIED'
}

export type OrgRoleGroupStateFilterExpressionInput = {
  eq?: Maybe<OrgRoleGroupStateInput>;
  in?: Maybe<Array<Maybe<OrgRoleGroupStateInput>>>;
};

export enum OrgRoleGroupStateInput {
  OrgrolegroupStateDisabled = 'ORGROLEGROUP_STATE_DISABLED',
  OrgrolegroupStateEnabled = 'ORGROLEGROUP_STATE_ENABLED',
  OrgrolegroupStateUnspecified = 'ORGROLEGROUP_STATE_UNSPECIFIED'
}

export type OrgRoleGroupStateValueInput = {
  value?: Maybe<OrgRoleGroupStateInput>;
};

export type OrgRoleGroupUpdateInput = {
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  roles?: Maybe<StringArrayUpdateInput>;
  state?: Maybe<OrgRoleGroupStateValueInput>;
};

export type OrgRoleGroupUpdateRequestInput = {
  granular?: Maybe<OrgRoleGroupUpdateInput>;
  replace?: Maybe<OrgRoleGroupInput>;
};

export type OrgRoleGroupUpdateResponse = {
  __typename?: 'OrgRoleGroupUpdateResponse';
  orgRoleGroup?: Maybe<OrgRoleGroupDto>;
};

export type OrgServiceAccountContainer = {
  __typename?: 'OrgServiceAccountContainer';
  orgServiceAccount?: Maybe<OrgServiceAccountDto>;
  secrets?: Maybe<Array<Maybe<OrgServiceAccountSecretHint>>>;
};

export type OrgServiceAccountCreateRequestInput = {
  orgServiceAccount?: Maybe<OrgServiceAccountInput>;
};

export type OrgServiceAccountCreateResponse = {
  __typename?: 'OrgServiceAccountCreateResponse';
  orgServiceAccount?: Maybe<OrgServiceAccountDto>;
};

export type OrgServiceAccountCreateSecretRequestInput = {
  expirationUnix?: Maybe<Scalars['Long']>;
  secretName?: Maybe<Scalars['String']>;
  serviceAccountName?: Maybe<Scalars['String']>;
};

export type OrgServiceAccountCreateSecretResponse = {
  __typename?: 'OrgServiceAccountCreateSecretResponse';
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  expirationUnix?: Maybe<Scalars['Long']>;
  secretName?: Maybe<Scalars['String']>;
  serviceAccountName?: Maybe<Scalars['String']>;
};

export type OrgServiceAccountCustomRole = {
  __typename?: 'OrgServiceAccountCustomRole';
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OrgServiceAccountCustomRoleInput = {
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OrgServiceAccountCustomRoleUpdateInput = {
  permissions?: Maybe<StringArrayUpdateInput>;
};

export type OrgServiceAccountDto = {
  __typename?: 'OrgServiceAccountDTO';
  clientId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customRole?: Maybe<OrgServiceAccountCustomRole>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSynced?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  orgRoleGroups?: Maybe<Array<Maybe<Scalars['String']>>>;
  state?: Maybe<OrgServiceAccountState>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrgServiceAccountDeleteRequestInput = {
  name?: Maybe<Scalars['String']>;
};

export type OrgServiceAccountDeleteResponse = {
  __typename?: 'OrgServiceAccountDeleteResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type OrgServiceAccountDeleteSecretsRequestInput = {
  all?: Maybe<OrgServiceAccountOneOfAllInput>;
  granular?: Maybe<OrgServiceAccountOneOfSecretsGranularInput>;
  serviceAccountName?: Maybe<Scalars['String']>;
};

export type OrgServiceAccountDeleteSecretsResponse = {
  __typename?: 'OrgServiceAccountDeleteSecretsResponse';
  _?: Maybe<Scalars['String']>;
};

export type OrgServiceAccountFilterInput = {
  and?: Maybe<Array<Maybe<OrgServiceAccountFilterInput>>>;
  description?: Maybe<StringFilterExpressionInput>;
  isSynced?: Maybe<BoolFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  not?: Maybe<Array<Maybe<OrgServiceAccountFilterInput>>>;
  or?: Maybe<Array<Maybe<OrgServiceAccountFilterInput>>>;
  orgRoleGroups?: Maybe<StringArrayFilterExpressionInput>;
  state?: Maybe<OrgServiceAccountStateFilterExpressionInput>;
};

export type OrgServiceAccountInput = {
  customRole?: Maybe<OrgServiceAccountCustomRoleInput>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orgRoleGroups?: Maybe<Array<Maybe<Scalars['String']>>>;
  state?: Maybe<OrgServiceAccountStateInput>;
};

export type OrgServiceAccountOneOfAllInput = {
  /** NOT USED */
  _?: Maybe<Scalars['String']>;
};

export type OrgServiceAccountOneOfSecretsGranularInput = {
  secretNames?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OrgServiceAccountSecretHint = {
  __typename?: 'OrgServiceAccountSecretHint';
  expirationUnix?: Maybe<Scalars['Long']>;
  secretName?: Maybe<Scalars['String']>;
};

export enum OrgServiceAccountState {
  OrgserviceaccountStateDisabled = 'ORGSERVICEACCOUNT_STATE_DISABLED',
  OrgserviceaccountStateEnabled = 'ORGSERVICEACCOUNT_STATE_ENABLED',
  OrgserviceaccountStateUnspecified = 'ORGSERVICEACCOUNT_STATE_UNSPECIFIED'
}

export type OrgServiceAccountStateFilterExpressionInput = {
  eq?: Maybe<OrgServiceAccountStateInput>;
  in?: Maybe<Array<Maybe<OrgServiceAccountStateInput>>>;
};

export enum OrgServiceAccountStateInput {
  OrgserviceaccountStateDisabled = 'ORGSERVICEACCOUNT_STATE_DISABLED',
  OrgserviceaccountStateEnabled = 'ORGSERVICEACCOUNT_STATE_ENABLED',
  OrgserviceaccountStateUnspecified = 'ORGSERVICEACCOUNT_STATE_UNSPECIFIED'
}

export type OrgServiceAccountStateValueInput = {
  value?: Maybe<OrgServiceAccountStateInput>;
};

export type OrgServiceAccountUpdateInput = {
  customRole?: Maybe<OrgServiceAccountCustomRoleUpdateInput>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orgRoleGroups?: Maybe<StringArrayUpdateInput>;
  state?: Maybe<OrgServiceAccountStateValueInput>;
};

export type OrgServiceAccountUpdateRequestInput = {
  granular?: Maybe<OrgServiceAccountUpdateInput>;
  replace?: Maybe<OrgServiceAccountInput>;
};

export type OrgServiceAccountUpdateResponse = {
  __typename?: 'OrgServiceAccountUpdateResponse';
  orgServiceAccount?: Maybe<OrgServiceAccountDto>;
};

export enum OrgState {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  OrgStateUnspecified = 'ORG_STATE_UNSPECIFIED',
  Provisioning = 'PROVISIONING',
  Reserved = 'RESERVED'
}

export enum OrgStateInput {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  OrgStateUnspecified = 'ORG_STATE_UNSPECIFIED',
  Provisioning = 'PROVISIONING',
  Reserved = 'RESERVED'
}

export type OrgStateWrapperInput = {
  value?: Maybe<OrgStateInput>;
};

/** Contains the input values needed to update an organization. */
export type OrgUpdateRequestInput = {
  /** Contains the input values for the org details, such as name and admin contact. */
  org?: Maybe<OrgInput>;
};

export type OrgUpdateResponse = {
  __typename?: 'OrgUpdateResponse';
  org?: Maybe<Org>;
};

export type OrgUpdateV2RequestInput = {
  org?: Maybe<OrgGranularInput>;
};

export type OrgUpdateV2Response = {
  __typename?: 'OrgUpdateV2Response';
  org?: Maybe<Org>;
};

export type OrgUserInput = {
  orgId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type Organization = GraphNode & {
  __typename?: 'Organization';
  connectedDataSourceId?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  exactType?: Maybe<Scalars['String']>;
  hasMember?: Maybe<Array<Maybe<Person>>>;
  hasMemberEdges?: Maybe<Array<Maybe<HasMemberEdge>>>;
  hasPart?: Maybe<Array<Maybe<Organization>>>;
  hasPartEdges?: Maybe<Array<Maybe<HasPartEdge>>>;
  hasPrimaryContact?: Maybe<Array<Maybe<Person>>>;
  hasPrimaryContactEdges?: Maybe<Array<Maybe<HasPrimaryContactEdge>>>;
  id: Scalars['String'];
  identities?: Maybe<Array<Maybe<OrganizationIdentityUnion>>>;
  isProviderOf?: Maybe<Array<Maybe<Account>>>;
  isServedBy?: Maybe<Array<Maybe<Thing>>>;
  isServedByEdges?: Maybe<Array<Maybe<IsServedByEdge>>>;
  mappingKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type OrganizationHasMemberArgs = {
  filter?: Maybe<PersonFilter>;
};


export type OrganizationHasPartArgs = {
  filter?: Maybe<OrganizationFilter>;
};


export type OrganizationHasPrimaryContactArgs = {
  filter?: Maybe<PersonFilter>;
};


export type OrganizationIsProviderOfArgs = {
  filter?: Maybe<AccountFilter>;
};


export type OrganizationIsServedByArgs = {
  filter?: Maybe<ThingFilter>;
};

export type OrganizationFilter = {
  and?: Maybe<Array<Maybe<OrganizationFilter>>>;
  connectedDataSourceId?: Maybe<StringFilterExpressionInput>;
  dateCreated?: Maybe<TimestampFilterExpressionInput>;
  dateUpdated?: Maybe<TimestampFilterExpressionInput>;
  exactType?: Maybe<StringFilterExpressionInput>;
  id?: Maybe<IdFilterExpressionInput>;
  mappingKey?: Maybe<StringFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  not?: Maybe<OrganizationFilter>;
  or?: Maybe<Array<Maybe<OrganizationFilter>>>;
  type?: Maybe<StringArrayFilterExpressionInput>;
};

export type OrganizationIdentityUnion = AccessCredentialIdentity | BaCnetObjectId | BaCnetVendorId | EmailAddressIdentity | EmailIdentity | ExternalIdentity | FloorLevelIdentity | GenericIdentity | NameIdentity | PostalAddressIdentity | SpaceCode | SubBuildingCode;

export type PeopleGroup = GraphNode & {
  __typename?: 'PeopleGroup';
  connectedDataSourceId?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  exactType?: Maybe<Scalars['String']>;
  hasMember?: Maybe<Array<Maybe<Person>>>;
  hasMemberEdges?: Maybe<Array<Maybe<HasMemberEdge>>>;
  hasPart?: Maybe<Org>;
  hasPrimaryContact?: Maybe<Array<Maybe<Person>>>;
  hasPrimaryContactEdges?: Maybe<Array<Maybe<HasPrimaryContactEdge>>>;
  id: Scalars['String'];
  identities?: Maybe<Array<Maybe<PeopleGroupIdentityUnion>>>;
  isProviderOf?: Maybe<Array<Maybe<Account>>>;
  isResponsibleFor?: Maybe<Array<Maybe<Thing>>>;
  isResponsibleForEdges?: Maybe<Array<Maybe<IsResponsibleForEdge>>>;
  isServedBy?: Maybe<Array<Maybe<Thing>>>;
  isServedByEdges?: Maybe<Array<Maybe<IsServedByEdge>>>;
  mappingKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type PeopleGroupHasMemberArgs = {
  filter?: Maybe<PersonFilter>;
};


export type PeopleGroupHasPrimaryContactArgs = {
  filter?: Maybe<PersonFilter>;
};


export type PeopleGroupIsProviderOfArgs = {
  filter?: Maybe<AccountFilter>;
};


export type PeopleGroupIsResponsibleForArgs = {
  filter?: Maybe<ThingFilter>;
};


export type PeopleGroupIsServedByArgs = {
  filter?: Maybe<ThingFilter>;
};

export type PeopleGroupFilter = {
  and?: Maybe<Array<Maybe<PeopleGroupFilter>>>;
  connectedDataSourceId?: Maybe<StringFilterExpressionInput>;
  dateCreated?: Maybe<TimestampFilterExpressionInput>;
  dateUpdated?: Maybe<TimestampFilterExpressionInput>;
  exactType?: Maybe<StringFilterExpressionInput>;
  id?: Maybe<IdFilterExpressionInput>;
  mappingKey?: Maybe<StringFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  not?: Maybe<PeopleGroupFilter>;
  or?: Maybe<Array<Maybe<PeopleGroupFilter>>>;
  type?: Maybe<StringArrayFilterExpressionInput>;
};

export type PeopleGroupIdentityUnion = AccessCredentialIdentity | BaCnetObjectId | BaCnetVendorId | EmailAddressIdentity | EmailIdentity | ExternalIdentity | FloorLevelIdentity | GenericIdentity | NameIdentity | PostalAddressIdentity | SpaceCode | SubBuildingCode;

export enum Permission {
  AnaxienrichmentReadwriteAll = 'ANAXIENRICHMENT_READWRITE_ALL',
  AnaxienrichmentReadAll = 'ANAXIENRICHMENT_READ_ALL',
  AnaxiinferenceReadwriteAll = 'ANAXIINFERENCE_READWRITE_ALL',
  AnaxiinferenceReadAll = 'ANAXIINFERENCE_READ_ALL',
  AnaxilabelRead = 'ANAXILABEL_READ',
  AnaxilabelReadwrite = 'ANAXILABEL_READWRITE',
  AnaxilabelReadwriteAll = 'ANAXILABEL_READWRITE_ALL',
  AnaxilabelReadAll = 'ANAXILABEL_READ_ALL',
  AnaximodelReadwriteAll = 'ANAXIMODEL_READWRITE_ALL',
  AnaximodelReadAll = 'ANAXIMODEL_READ_ALL',
  AnaxistandardlabelReadwriteAll = 'ANAXISTANDARDLABEL_READWRITE_ALL',
  AnaxistandardlabelReadAll = 'ANAXISTANDARDLABEL_READ_ALL',
  BillingRead = 'BILLING_READ',
  BillingReadwrite = 'BILLING_READWRITE',
  BillingReadwriteAll = 'BILLING_READWRITE_ALL',
  BillingReadAll = 'BILLING_READ_ALL',
  BusinessWrite = 'BUSINESS_WRITE',
  ConnectorauthserviceReadwriteAll = 'CONNECTORAUTHSERVICE_READWRITE_ALL',
  ConnectorauthserviceReadAll = 'CONNECTORAUTHSERVICE_READ_ALL',
  ConnectorauthAccess = 'CONNECTORAUTH_ACCESS',
  ConnectorauthReadwriteAll = 'CONNECTORAUTH_READWRITE_ALL',
  ConnectorauthReadAll = 'CONNECTORAUTH_READ_ALL',
  ConnectorDestinationRead = 'CONNECTOR_DESTINATION_READ',
  ConnectorDestinationReadAll = 'CONNECTOR_DESTINATION_READ_ALL',
  ConnectorDestinationWrite = 'CONNECTOR_DESTINATION_WRITE',
  ConnectorDestinationWriteAll = 'CONNECTOR_DESTINATION_WRITE_ALL',
  ConnectorReadwriteAll = 'CONNECTOR_READWRITE_ALL',
  ConnectorReadAll = 'CONNECTOR_READ_ALL',
  ConnectorSourceRead = 'CONNECTOR_SOURCE_READ',
  ConnectorSourceReadAll = 'CONNECTOR_SOURCE_READ_ALL',
  ConnectorSourceWrite = 'CONNECTOR_SOURCE_WRITE',
  ContributionrequestReadwrite = 'CONTRIBUTIONREQUEST_READWRITE',
  DevicemanufacturerReadwriteAll = 'DEVICEMANUFACTURER_READWRITE_ALL',
  DevicemanufacturerReadAll = 'DEVICEMANUFACTURER_READ_ALL',
  DevicemodelReadwriteAll = 'DEVICEMODEL_READWRITE_ALL',
  DevicemodelReadAll = 'DEVICEMODEL_READ_ALL',
  DeviceprofileReadwriteAll = 'DEVICEPROFILE_READWRITE_ALL',
  DeviceprofileReadAll = 'DEVICEPROFILE_READ_ALL',
  EdgedeviceprofileFingerprintAll = 'EDGEDEVICEPROFILE_FINGERPRINT_ALL',
  EdgedeviceprofileReadwriteAll = 'EDGEDEVICEPROFILE_READWRITE_ALL',
  EdgedeviceprofileReadAll = 'EDGEDEVICEPROFILE_READ_ALL',
  EventReadAll = 'EVENT_READ_ALL',
  GatewayPipelineAll = 'GATEWAY_PIPELINE_ALL',
  GatewayReadwriteAll = 'GATEWAY_READWRITE_ALL',
  GatewayReadAll = 'GATEWAY_READ_ALL',
  GrantsRead = 'GRANTS_READ',
  GrantsReadwrite = 'GRANTS_READWRITE',
  GrantsReadwriteAll = 'GRANTS_READWRITE_ALL',
  GrantsReadAll = 'GRANTS_READ_ALL',
  GraphReadwriteAll = 'GRAPH_READWRITE_ALL',
  GraphReadAll = 'GRAPH_READ_ALL',
  LivequeryRead = 'LIVEQUERY_READ',
  LivequeryReadwrite = 'LIVEQUERY_READWRITE',
  LivequeryReadwriteAll = 'LIVEQUERY_READWRITE_ALL',
  LivequeryReadAll = 'LIVEQUERY_READ_ALL',
  MastodonClientCreate = 'MASTODON_CLIENT_CREATE',
  MastodonGod = 'MASTODON_GOD',
  MastodonRead = 'MASTODON_READ',
  MastodonReadwrite = 'MASTODON_READWRITE',
  MessagingRead = 'MESSAGING_READ',
  MessagingReadwrite = 'MESSAGING_READWRITE',
  MessagingReadwriteAll = 'MESSAGING_READWRITE_ALL',
  MessagingReadAll = 'MESSAGING_READ_ALL',
  OpenfgaWrite = 'OPENFGA_WRITE',
  OrgRead = 'ORG_READ',
  OrgReadwrite = 'ORG_READWRITE',
  OrgReadwriteAll = 'ORG_READWRITE_ALL',
  OrgReadAll = 'ORG_READ_ALL',
  PermissionUnspecified = 'PERMISSION_UNSPECIFIED',
  PersonalaccesstokenRead = 'PERSONALACCESSTOKEN_READ',
  PersonalaccesstokenReadwrite = 'PERSONALACCESSTOKEN_READWRITE',
  PersonalaccesstokenReadwriteAll = 'PERSONALACCESSTOKEN_READWRITE_ALL',
  PersonalaccesstokenReadAll = 'PERSONALACCESSTOKEN_READ_ALL',
  PersonReadAll = 'PERSON_READ_ALL',
  PlaceReadwriteAll = 'PLACE_READWRITE_ALL',
  PlaceReadAll = 'PLACE_READ_ALL',
  SecretsReadwriteAll = 'SECRETS_READWRITE_ALL',
  SecretsReadAll = 'SECRETS_READ_ALL',
  ThingReadwriteAll = 'THING_READWRITE_ALL',
  ThingReadAll = 'THING_READ_ALL',
  TimeseriesGod = 'TIMESERIES_GOD',
  UserRead = 'USER_READ',
  UserReadwrite = 'USER_READWRITE',
  UserReadwriteAll = 'USER_READWRITE_ALL',
  UserReadAll = 'USER_READ_ALL',
  WebhookreceiverReadwriteAll = 'WEBHOOKRECEIVER_READWRITE_ALL',
  WebhookreceiverReadAll = 'WEBHOOKRECEIVER_READ_ALL',
  WebhooksenderReadwriteAll = 'WEBHOOKSENDER_READWRITE_ALL',
  WebhooksenderReadAll = 'WEBHOOKSENDER_READ_ALL',
  WebhooktargetRead = 'WEBHOOKTARGET_READ',
  WebhooktargetReadwrite = 'WEBHOOKTARGET_READWRITE',
  WebhooktargetReadwriteAll = 'WEBHOOKTARGET_READWRITE_ALL',
  WebhooktargetReadAll = 'WEBHOOKTARGET_READ_ALL'
}

export type PermissionFilterExpressionInput = {
  eq?: Maybe<PermissionInput>;
  in?: Maybe<Array<Maybe<PermissionInput>>>;
};

export enum PermissionInput {
  AnaxienrichmentReadwriteAll = 'ANAXIENRICHMENT_READWRITE_ALL',
  AnaxienrichmentReadAll = 'ANAXIENRICHMENT_READ_ALL',
  AnaxiinferenceReadwriteAll = 'ANAXIINFERENCE_READWRITE_ALL',
  AnaxiinferenceReadAll = 'ANAXIINFERENCE_READ_ALL',
  AnaxilabelRead = 'ANAXILABEL_READ',
  AnaxilabelReadwrite = 'ANAXILABEL_READWRITE',
  AnaxilabelReadwriteAll = 'ANAXILABEL_READWRITE_ALL',
  AnaxilabelReadAll = 'ANAXILABEL_READ_ALL',
  AnaximodelReadwriteAll = 'ANAXIMODEL_READWRITE_ALL',
  AnaximodelReadAll = 'ANAXIMODEL_READ_ALL',
  AnaxistandardlabelReadwriteAll = 'ANAXISTANDARDLABEL_READWRITE_ALL',
  AnaxistandardlabelReadAll = 'ANAXISTANDARDLABEL_READ_ALL',
  BillingRead = 'BILLING_READ',
  BillingReadwrite = 'BILLING_READWRITE',
  BillingReadwriteAll = 'BILLING_READWRITE_ALL',
  BillingReadAll = 'BILLING_READ_ALL',
  BusinessWrite = 'BUSINESS_WRITE',
  ConnectorauthserviceReadwriteAll = 'CONNECTORAUTHSERVICE_READWRITE_ALL',
  ConnectorauthserviceReadAll = 'CONNECTORAUTHSERVICE_READ_ALL',
  ConnectorauthAccess = 'CONNECTORAUTH_ACCESS',
  ConnectorauthReadwriteAll = 'CONNECTORAUTH_READWRITE_ALL',
  ConnectorauthReadAll = 'CONNECTORAUTH_READ_ALL',
  ConnectorDestinationRead = 'CONNECTOR_DESTINATION_READ',
  ConnectorDestinationReadAll = 'CONNECTOR_DESTINATION_READ_ALL',
  ConnectorDestinationWrite = 'CONNECTOR_DESTINATION_WRITE',
  ConnectorDestinationWriteAll = 'CONNECTOR_DESTINATION_WRITE_ALL',
  ConnectorReadwriteAll = 'CONNECTOR_READWRITE_ALL',
  ConnectorReadAll = 'CONNECTOR_READ_ALL',
  ConnectorSourceRead = 'CONNECTOR_SOURCE_READ',
  ConnectorSourceReadAll = 'CONNECTOR_SOURCE_READ_ALL',
  ConnectorSourceWrite = 'CONNECTOR_SOURCE_WRITE',
  ContributionrequestReadwrite = 'CONTRIBUTIONREQUEST_READWRITE',
  DevicemanufacturerReadwriteAll = 'DEVICEMANUFACTURER_READWRITE_ALL',
  DevicemanufacturerReadAll = 'DEVICEMANUFACTURER_READ_ALL',
  DevicemodelReadwriteAll = 'DEVICEMODEL_READWRITE_ALL',
  DevicemodelReadAll = 'DEVICEMODEL_READ_ALL',
  DeviceprofileReadwriteAll = 'DEVICEPROFILE_READWRITE_ALL',
  DeviceprofileReadAll = 'DEVICEPROFILE_READ_ALL',
  EdgedeviceprofileFingerprintAll = 'EDGEDEVICEPROFILE_FINGERPRINT_ALL',
  EdgedeviceprofileReadwriteAll = 'EDGEDEVICEPROFILE_READWRITE_ALL',
  EdgedeviceprofileReadAll = 'EDGEDEVICEPROFILE_READ_ALL',
  EventReadAll = 'EVENT_READ_ALL',
  GatewayPipelineAll = 'GATEWAY_PIPELINE_ALL',
  GatewayReadwriteAll = 'GATEWAY_READWRITE_ALL',
  GatewayReadAll = 'GATEWAY_READ_ALL',
  GrantsRead = 'GRANTS_READ',
  GrantsReadwrite = 'GRANTS_READWRITE',
  GrantsReadwriteAll = 'GRANTS_READWRITE_ALL',
  GrantsReadAll = 'GRANTS_READ_ALL',
  GraphReadwriteAll = 'GRAPH_READWRITE_ALL',
  GraphReadAll = 'GRAPH_READ_ALL',
  LivequeryRead = 'LIVEQUERY_READ',
  LivequeryReadwrite = 'LIVEQUERY_READWRITE',
  LivequeryReadwriteAll = 'LIVEQUERY_READWRITE_ALL',
  LivequeryReadAll = 'LIVEQUERY_READ_ALL',
  MastodonClientCreate = 'MASTODON_CLIENT_CREATE',
  MastodonGod = 'MASTODON_GOD',
  MastodonRead = 'MASTODON_READ',
  MastodonReadwrite = 'MASTODON_READWRITE',
  MessagingRead = 'MESSAGING_READ',
  MessagingReadwrite = 'MESSAGING_READWRITE',
  MessagingReadwriteAll = 'MESSAGING_READWRITE_ALL',
  MessagingReadAll = 'MESSAGING_READ_ALL',
  OpenfgaWrite = 'OPENFGA_WRITE',
  OrgRead = 'ORG_READ',
  OrgReadwrite = 'ORG_READWRITE',
  OrgReadwriteAll = 'ORG_READWRITE_ALL',
  OrgReadAll = 'ORG_READ_ALL',
  PermissionUnspecified = 'PERMISSION_UNSPECIFIED',
  PersonalaccesstokenRead = 'PERSONALACCESSTOKEN_READ',
  PersonalaccesstokenReadwrite = 'PERSONALACCESSTOKEN_READWRITE',
  PersonalaccesstokenReadwriteAll = 'PERSONALACCESSTOKEN_READWRITE_ALL',
  PersonalaccesstokenReadAll = 'PERSONALACCESSTOKEN_READ_ALL',
  PersonReadAll = 'PERSON_READ_ALL',
  PlaceReadwriteAll = 'PLACE_READWRITE_ALL',
  PlaceReadAll = 'PLACE_READ_ALL',
  SecretsReadwriteAll = 'SECRETS_READWRITE_ALL',
  SecretsReadAll = 'SECRETS_READ_ALL',
  ThingReadwriteAll = 'THING_READWRITE_ALL',
  ThingReadAll = 'THING_READ_ALL',
  TimeseriesGod = 'TIMESERIES_GOD',
  UserRead = 'USER_READ',
  UserReadwrite = 'USER_READWRITE',
  UserReadwriteAll = 'USER_READWRITE_ALL',
  UserReadAll = 'USER_READ_ALL',
  WebhookreceiverReadwriteAll = 'WEBHOOKRECEIVER_READWRITE_ALL',
  WebhookreceiverReadAll = 'WEBHOOKRECEIVER_READ_ALL',
  WebhooksenderReadwriteAll = 'WEBHOOKSENDER_READWRITE_ALL',
  WebhooksenderReadAll = 'WEBHOOKSENDER_READ_ALL',
  WebhooktargetRead = 'WEBHOOKTARGET_READ',
  WebhooktargetReadwrite = 'WEBHOOKTARGET_READWRITE',
  WebhooktargetReadwriteAll = 'WEBHOOKTARGET_READWRITE_ALL',
  WebhooktargetReadAll = 'WEBHOOKTARGET_READ_ALL'
}

/** Contains the details about a individual detected in the data from a building, such as a conference room booking. */
export type Person = GraphNode & {
  __typename?: 'Person';
  additionalName?: Maybe<Scalars['String']>;
  connectedDataSourceId?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  /** Any emails associated with the individual. */
  emails?: Maybe<Array<Maybe<EmailAddress>>>;
  exactType?: Maybe<Scalars['String']>;
  /** Surname or last name of the individual. */
  familyName?: Maybe<Scalars['String']>;
  /** Personal name or first name of the individual. */
  givenName?: Maybe<Scalars['String']>;
  hasAccessCredential?: Maybe<Array<Maybe<AccessCredential>>>;
  hasAccessCredentialEdges?: Maybe<Array<Maybe<HasAccessCredentialEdge>>>;
  hasCalendarEvents?: Maybe<Array<Maybe<CalendarEvent>>>;
  hasCalendarInvitations?: Maybe<Array<Maybe<CalendarInvitation>>>;
  /** The unique ID of the individual. */
  id: Scalars['String'];
  identities?: Maybe<Array<Maybe<PersonIdentityUnion>>>;
  isMemberOf?: Maybe<Array<Maybe<Organization>>>;
  isMemberOfEdges?: Maybe<Array<Maybe<IsMemberOfEdge>>>;
  mappingKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** Contains the details about a individual detected in the data from a building, such as a conference room booking. */
export type PersonEmailsArgs = {
  filter?: Maybe<EmailFilter>;
};


/** Contains the details about a individual detected in the data from a building, such as a conference room booking. */
export type PersonHasAccessCredentialArgs = {
  filter?: Maybe<AccessCredentialFilter>;
};


/** Contains the details about a individual detected in the data from a building, such as a conference room booking. */
export type PersonHasCalendarEventsArgs = {
  filter?: Maybe<CalendarEventFilter>;
};


/** Contains the details about a individual detected in the data from a building, such as a conference room booking. */
export type PersonHasCalendarInvitationsArgs = {
  filter?: Maybe<CalendarInvitationFilter>;
};


/** Contains the details about a individual detected in the data from a building, such as a conference room booking. */
export type PersonIsMemberOfArgs = {
  filter?: Maybe<OrganizationFilter>;
};

export type PersonFilter = {
  and?: Maybe<Array<Maybe<PersonFilter>>>;
  connectedDataSourceId?: Maybe<StringFilterExpressionInput>;
  dateCreated?: Maybe<TimestampFilterExpressionInput>;
  dateUpdated?: Maybe<TimestampFilterExpressionInput>;
  email?: Maybe<StringFilterExpressionInput>;
  exactType?: Maybe<StringFilterExpressionInput>;
  id?: Maybe<IdFilterExpressionInput>;
  mappingKey?: Maybe<StringFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  not?: Maybe<PersonFilter>;
  or?: Maybe<Array<Maybe<PersonFilter>>>;
  type?: Maybe<StringArrayFilterExpressionInput>;
};

export type PersonIdentityUnion = AccessCredentialIdentity | BaCnetObjectId | BaCnetVendorId | EmailAddressIdentity | EmailIdentity | ExternalIdentity | FloorLevelIdentity | GenericIdentity | NameIdentity | PostalAddressIdentity | SpaceCode | SubBuildingCode;

/** Contains the details about a personal access token. */
export type PersonalAccessToken = {
  __typename?: 'PersonalAccessToken';
  /** Timestamp of the token creation. */
  created?: Maybe<Scalars['DateTime']>;
  /** The unique ID of the access token. */
  id?: Maybe<Scalars['String']>;
  integrityId?: Maybe<Scalars['String']>;
  /** The last time the token was used. */
  lastExchanged?: Maybe<Scalars['DateTime']>;
  /** The name assigned to the access token. */
  name?: Maybe<Scalars['String']>;
  /** The available permissions / scopes for the token, such as THING_READ_ALL */
  permissions?: Maybe<Array<Maybe<Permission>>>;
  /** Timestamp the token was last updated, including when permissions were added or removed. */
  updated?: Maybe<Scalars['DateTime']>;
  /** The user the token belongs to. */
  userId?: Maybe<Scalars['String']>;
};

/** Contains the input values needed to create a token. */
export type PersonalAccessTokenCreateRequestInput = {
  /** Contains the input values for the token details, such as name and permissions. */
  pat?: Maybe<PersonalAccessTokenInput>;
};

export type PersonalAccessTokenCreateResponse = {
  __typename?: 'PersonalAccessTokenCreateResponse';
  pat?: Maybe<PersonalAccessToken>;
  token?: Maybe<Scalars['String']>;
};

/** Contains the input values needed to delete a token. */
export type PersonalAccessTokenDeleteRequestInput = {
  /** Provide the id of the token here. */
  id?: Maybe<Scalars['String']>;
};

export type PersonalAccessTokenDeleteResponse = {
  __typename?: 'PersonalAccessTokenDeleteResponse';
  _?: Maybe<Scalars['String']>;
};

/** Contains the input values needed to filter token queries. */
export type PersonalAccessTokenFilterInput = {
  /** Used to combine multiple filter criteria. */
  and?: Maybe<Array<Maybe<PersonalAccessTokenFilterInput>>>;
  /** Used to filter for a specific ID or IDs (refer to IDFilterExpressionInput for input options). */
  id?: Maybe<IdFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  /** Used to omit a specific result or results from the response. */
  not?: Maybe<Array<Maybe<PersonalAccessTokenFilterInput>>>;
  /** Used to return results that match at least one of the defined criteria. */
  or?: Maybe<Array<Maybe<PersonalAccessTokenFilterInput>>>;
  permissions?: Maybe<PermissionFilterExpressionInput>;
  userId?: Maybe<IdFilterExpressionInput>;
};

export type PersonalAccessTokenGetAccessTokenFromPatRequestInput = {
  personalAccessToken?: Maybe<Scalars['String']>;
};

/** Contains the details about a personal access token. */
export type PersonalAccessTokenInput = {
  /** Timestamp of the token creation. */
  created?: Maybe<Scalars['DateTime']>;
  /** The unique ID of the access token. */
  id?: Maybe<Scalars['String']>;
  integrityId?: Maybe<Scalars['String']>;
  /** The last time the token was used. */
  lastExchanged?: Maybe<Scalars['DateTime']>;
  /** The name assigned to the access token. */
  name?: Maybe<Scalars['String']>;
  /** The available permissions / scopes for the token, such as THING_READ_ALL */
  permissions?: Maybe<Array<Maybe<PermissionInput>>>;
  /** Timestamp the token was last updated, including when permissions were added or removed. */
  updated?: Maybe<Scalars['DateTime']>;
  /** The user the token belongs to. */
  userId?: Maybe<Scalars['String']>;
};

export type PersonalAccessTokenIsPatNameAvailableResponse = {
  __typename?: 'PersonalAccessTokenIsPatNameAvailableResponse';
  isAvailable?: Maybe<Scalars['Boolean']>;
  suggestedName?: Maybe<Scalars['String']>;
};

/** Contains the input values needed to update a token. */
export type PersonalAccessTokenUpdateRequestInput = {
  /** Contains the input values for the token details, such as name and permissions. */
  pat?: Maybe<PersonalAccessTokenInput>;
};

export type PersonalAccessTokenUpdateResponse = {
  __typename?: 'PersonalAccessTokenUpdateResponse';
  pat?: Maybe<PersonalAccessToken>;
  token?: Maybe<Scalars['String']>;
};

/** Contains all the details of any places associated with a particular thing, such as a space or a floor. */
export type Place = {
  calendarEvents?: Maybe<Array<Maybe<CalendarEvent>>>;
  collections?: Maybe<Array<Maybe<Collection>>>;
  connectedDataSourceId?: Maybe<Scalars['String']>;
  connectors?: Maybe<Array<Maybe<Connector>>>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  exactType?: Maybe<Scalars['String']>;
  grossArea?: Maybe<AreaQuantity>;
  grossAreaEdges?: Maybe<Array<Maybe<GrossAreaEdge>>>;
  hasPart?: Maybe<Array<Maybe<Place>>>;
  hasPartEdges?: Maybe<Array<Maybe<HasPartEdge>>>;
  hasPoint?: Maybe<Array<Maybe<Point>>>;
  hasPointEdges?: Maybe<Array<Maybe<HasPointEdge>>>;
  /** The unique ID of the place. */
  id: Scalars['String'];
  isAdjacentTo?: Maybe<Array<Maybe<Place>>>;
  isAdjacentToEdges?: Maybe<Array<Maybe<IsAdjacentToEdge>>>;
  isFedBy?: Maybe<Array<Maybe<Thing>>>;
  isFedByEdges?: Maybe<Array<Maybe<IsFedByEdge>>>;
  isLocationOf?: Maybe<Array<Maybe<IsLocationOfUnion>>>;
  isLocationOfEdges?: Maybe<Array<Maybe<IsLocationOfEdge>>>;
  isPartOf?: Maybe<Array<Maybe<Place>>>;
  isPartOfEdges?: Maybe<Array<Maybe<IsPartOfEdge>>>;
  isServedBy?: Maybe<Array<Maybe<Thing>>>;
  isServedByEdges?: Maybe<Array<Maybe<IsServedByEdge>>>;
  mappingKey?: Maybe<Scalars['String']>;
  /** The name of the place. */
  name?: Maybe<Scalars['String']>;
  points?: Maybe<Array<Maybe<Point>>>;
  rentableArea?: Maybe<AreaQuantity>;
  rentableAreaEdges?: Maybe<Array<Maybe<RentableAreaEdge>>>;
  /** Contains the complete list of things associated with the place. */
  things?: Maybe<Array<Maybe<Thing>>>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
  usableArea?: Maybe<AreaQuantity>;
  usableAreaEdges?: Maybe<Array<Maybe<UsableAreaEdge>>>;
};


/** Contains all the details of any places associated with a particular thing, such as a space or a floor. */
export type PlaceCalendarEventsArgs = {
  filter?: Maybe<CalendarEventFilter>;
};


/** Contains all the details of any places associated with a particular thing, such as a space or a floor. */
export type PlaceCollectionsArgs = {
  filter?: Maybe<CollectionFilter>;
};


/** Contains all the details of any places associated with a particular thing, such as a space or a floor. */
export type PlaceConnectorsArgs = {
  filter?: Maybe<ConnectorFilterInput>;
};


/** Contains all the details of any places associated with a particular thing, such as a space or a floor. */
export type PlaceGrossAreaArgs = {
  filter?: Maybe<AreaQuantityFilter>;
};


/** Contains all the details of any places associated with a particular thing, such as a space or a floor. */
export type PlaceHasPartArgs = {
  filter?: Maybe<PlaceFilter>;
};


/** Contains all the details of any places associated with a particular thing, such as a space or a floor. */
export type PlaceHasPointArgs = {
  filter?: Maybe<PointFilter>;
};


/** Contains all the details of any places associated with a particular thing, such as a space or a floor. */
export type PlaceIsAdjacentToArgs = {
  filter?: Maybe<PlaceFilter>;
};


/** Contains all the details of any places associated with a particular thing, such as a space or a floor. */
export type PlaceIsFedByArgs = {
  filter?: Maybe<ThingFilter>;
};


/** Contains all the details of any places associated with a particular thing, such as a space or a floor. */
export type PlaceIsLocationOfArgs = {
  filter?: Maybe<EntityFilter>;
};


/** Contains all the details of any places associated with a particular thing, such as a space or a floor. */
export type PlaceIsPartOfArgs = {
  filter?: Maybe<PlaceFilter>;
};


/** Contains all the details of any places associated with a particular thing, such as a space or a floor. */
export type PlaceIsServedByArgs = {
  filter?: Maybe<ThingFilter>;
};


/** Contains all the details of any places associated with a particular thing, such as a space or a floor. */
export type PlacePointsArgs = {
  filter?: Maybe<PointFilter>;
};


/** Contains all the details of any places associated with a particular thing, such as a space or a floor. */
export type PlaceRentableAreaArgs = {
  filter?: Maybe<AreaQuantityFilter>;
};


/** Contains all the details of any places associated with a particular thing, such as a space or a floor. */
export type PlaceThingsArgs = {
  filter?: Maybe<ThingFilter>;
};


/** Contains all the details of any places associated with a particular thing, such as a space or a floor. */
export type PlaceUsableAreaArgs = {
  filter?: Maybe<AreaQuantityFilter>;
};

export type PlaceFilter = {
  and?: Maybe<Array<Maybe<PlaceFilter>>>;
  connectedDataSourceId?: Maybe<StringFilterExpressionInput>;
  dateCreated?: Maybe<TimestampFilterExpressionInput>;
  dateUpdated?: Maybe<TimestampFilterExpressionInput>;
  exactType?: Maybe<StringFilterExpressionInput>;
  id?: Maybe<IdFilterExpressionInput>;
  mappingKey?: Maybe<StringFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  not?: Maybe<PlaceFilter>;
  or?: Maybe<Array<Maybe<PlaceFilter>>>;
  type?: Maybe<StringArrayFilterExpressionInput>;
};

/** Contains the details about the point, such as a thermostat setpoint. */
export type Point = GraphNode & {
  __typename?: 'Point';
  /** Time series data gathered together to return a new value, such as an average temperature across a set time pe or a min or max value. */
  aggregation?: Maybe<Array<Maybe<TimeseriesAggregateRow>>>;
  connectedDataSourceId?: Maybe<Scalars['String']>;
  datatype?: Maybe<DatatypeKey>;
  /** This timestamp represents the date the point was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** This timestamp represents that date the point was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The description of the point, like "Cooling Temperature Setpoint". */
  description?: Maybe<Scalars['String']>;
  /** This is the most specific type available for the point, i.e. where 'type' may return a list like [Point, Alarm, TemperatureAlarm, HighTemperatureAlarm], exactType will return just HighTemperatureAlarm. */
  exactType?: Maybe<Scalars['String']>;
  hasBill?: Maybe<Array<Maybe<Point>>>;
  hasHeartbeat?: Maybe<Heartbeat>;
  hasHeartbeatEdges?: Maybe<Array<Maybe<HasHeartbeatEdge>>>;
  /** The unique ID of the point. */
  id: Scalars['String'];
  identities?: Maybe<Array<Maybe<PointIdentityUnion>>>;
  isBilledTo?: Maybe<Account>;
  isBilledToEdges?: Maybe<Array<Maybe<IsBilledToEdge>>>;
  isPointOf?: Maybe<Array<Maybe<IsPointOfUnion>>>;
  isPointOfEdges?: Maybe<Array<Maybe<IsPointOfEdge>>>;
  mappingKey?: Maybe<Scalars['String']>;
  /** The name assigned to the point. */
  name?: Maybe<Scalars['String']>;
  /** Time series data for the point, such as what the air temperature setpoint was for a VAV, limited by a defined start and end time. */
  series?: Maybe<Array<Maybe<TimeseriesRow>>>;
  /** Ordered list of additional descriptive data to help explain float values like 0.0, 1.0 and 2.0. */
  stateTexts?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The class or subclass of the point, like "Alarm" and "TemperatureAlarm". */
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The unit of measurement associated with this point, such as "Degrees". */
  unit?: Maybe<Unit>;
  unused?: Maybe<Scalars['Boolean']>;
  valueMap?: Maybe<Scalars['Map']>;
};


/** Contains the details about the point, such as a thermostat setpoint. */
export type PointAggregationArgs = {
  endTime?: Maybe<Scalars['DateTime']>;
  period?: Maybe<TimeseriesAggPeriodInput>;
  periodIncrement?: Maybe<Scalars['Int']>;
  startTime?: Maybe<Scalars['DateTime']>;
};


/** Contains the details about the point, such as a thermostat setpoint. */
export type PointHasBillArgs = {
  filter?: Maybe<PointFilter>;
};


/** Contains the details about the point, such as a thermostat setpoint. */
export type PointHasHeartbeatArgs = {
  filter?: Maybe<HeartbeatFilter>;
};


/** Contains the details about the point, such as a thermostat setpoint. */
export type PointIsBilledToArgs = {
  filter?: Maybe<AccountFilter>;
};


/** Contains the details about the point, such as a thermostat setpoint. */
export type PointIsPointOfArgs = {
  filter?: Maybe<EntityFilter>;
};


/** Contains the details about the point, such as a thermostat setpoint. */
export type PointSeriesArgs = {
  endTime?: Maybe<Scalars['DateTime']>;
  ingestionEndTime?: Maybe<Scalars['DateTime']>;
  ingestionStartTime?: Maybe<Scalars['DateTime']>;
  latest?: Maybe<Scalars['Boolean']>;
  startTime?: Maybe<Scalars['DateTime']>;
};

/** Contains the input values needed to filter point queries. */
export type PointFilter = {
  /** Used to combine multiple filter criteria. */
  and?: Maybe<Array<Maybe<PointFilter>>>;
  connectedDataSourceId?: Maybe<StringFilterExpressionInput>;
  dateCreated?: Maybe<TimestampFilterExpressionInput>;
  dateUpdated?: Maybe<TimestampFilterExpressionInput>;
  exactType?: Maybe<StringFilterExpressionInput>;
  /** Used to filter for a specific ID or IDs (refer to IDFilterExpressionInput for input options). */
  id?: Maybe<IdFilterExpressionInput>;
  mappingKey?: Maybe<StringFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  /** Used to omit a specific result or results from the response. */
  not?: Maybe<PointFilter>;
  /** Used to return results that match at least one of the defined criteria. */
  or?: Maybe<Array<Maybe<PointFilter>>>;
  /** Used to filter on a class or subclass of the point, like "Alarm" and "TemperatureAlarm". */
  type?: Maybe<StringArrayFilterExpressionInput>;
  unused?: Maybe<SimpleBoolFilterExpressionInput>;
};

export type PointIdentityUnion = AccessCredentialIdentity | BaCnetObjectId | BaCnetVendorId | EmailAddressIdentity | EmailIdentity | ExternalIdentity | FloorLevelIdentity | GenericIdentity | NameIdentity | PostalAddressIdentity | SpaceCode | SubBuildingCode;

export type PostalAddressIdentity = Identity & PostalAddressIdentityModel & {
  __typename?: 'PostalAddressIdentity';
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<ScopeKey>;
  scopeId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type PostalAddressIdentityModel = {
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<ScopeKey>;
  scopeId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type PostalAddressInput = {
  addressLines?: Maybe<Array<Maybe<Scalars['String']>>>;
  administrativeArea?: Maybe<Scalars['String']>;
  languageCode?: Maybe<Scalars['String']>;
  locality?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  recipients?: Maybe<Array<Maybe<Scalars['String']>>>;
  regionCode?: Maybe<Scalars['String']>;
  revision?: Maybe<Scalars['Int']>;
  sortingCode?: Maybe<Scalars['String']>;
  sublocality?: Maybe<Scalars['String']>;
};

export enum PriceType {
  PriceTypeMetered = 'PRICE_TYPE_METERED',
  PriceTypeOneTime = 'PRICE_TYPE_ONE_TIME',
  PriceTypePlatform = 'PRICE_TYPE_PLATFORM',
  PriceTypePrepaidMetered = 'PRICE_TYPE_PREPAID_METERED',
  PriceTypeUnspecified = 'PRICE_TYPE_UNSPECIFIED'
}

export type ProductBundleResponse = {
  __typename?: 'ProductBundleResponse';
  archived_at?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  interval?: Maybe<Interval>;
  items?: Maybe<Array<Maybe<ProductPriceItemResponse>>>;
  metadata?: Maybe<Array<Maybe<MetadataEntry>>>;
  plan?: Maybe<Scalars['String']>;
  productType?: Maybe<ProductType>;
  sku?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  state?: Maybe<BundleState>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type ProductPriceItemResponse = {
  __typename?: 'ProductPriceItemResponse';
  lookupKey?: Maybe<Scalars['String']>;
  metadata?: Maybe<Array<Maybe<MetadataEntry>>>;
  oneTimePriceItems?: Maybe<OneTimePriceItems>;
  priceId?: Maybe<Scalars['String']>;
  quantityEnabled?: Maybe<Scalars['Boolean']>;
  quantityRange?: Maybe<QuantityRange>;
  slug?: Maybe<Scalars['String']>;
  tiers?: Maybe<Array<Maybe<Tier>>>;
  tiersMode?: Maybe<Scalars['String']>;
  type?: Maybe<PriceType>;
  unitAmount?: Maybe<Scalars['Long']>;
  unitAmountDecimal?: Maybe<Scalars['String']>;
};

export enum ProductType {
  ProductTypeOneTime = 'PRODUCT_TYPE_ONE_TIME',
  ProductTypeRecurring = 'PRODUCT_TYPE_RECURRING',
  ProductTypeUnspecified = 'PRODUCT_TYPE_UNSPECIFIED'
}

export type QuantityRange = {
  __typename?: 'QuantityRange';
  max?: Maybe<Scalars['Long']>;
  min?: Maybe<Scalars['Long']>;
};

/** Queries retrieve data from the data store. */
export type Query = {
  __typename?: 'Query';
  accessConnectorAuth?: Maybe<ConnectorAuthResponseSecret>;
  accessTokenFromPAT?: Maybe<Scalars['String']>;
  accounts?: Maybe<Array<Maybe<Account>>>;
  /** Returns the complete list of Connector Types (type = category or vendor) available to you for install; this does not reflect which Connectors are already installed, use "connectors" for that query. */
  availableConnectorTypes?: Maybe<ConnectorTypeListAvailableResponse>;
  /** Buildings are subsections of sites, where each site may have multiple associated buildings. Use this query to view building specific data such as id, name and geoshape. */
  buildings?: Maybe<Array<Maybe<Building>>>;
  /** Currently in development; will be used in association with Connectors that expose calendar events such as scheduled meetings. */
  calendarEvents?: Maybe<Array<Maybe<CalendarEvent>>>;
  collections?: Maybe<Array<Maybe<Collection>>>;
  /** Currently in development. */
  connectorAuth?: Maybe<ConnectorAuth>;
  /** Currently in development. */
  connectorTypes?: Maybe<Array<Maybe<ConnectorType>>>;
  /** Use this query to view data about the Connectors configured for the organization, including gateways. */
  connectors?: Maybe<Array<Maybe<Connector>>>;
  /** Floors are subsections of buildings, typically identified numerically like "floor1". Use this query to view floor specific data such as id, name or geoshape. */
  floors?: Maybe<Array<Maybe<Floor>>>;
  /** Provides details about the gateways associated with the organization, such as id or provisioning/active status. */
  gateways?: Maybe<Array<Maybe<Gateway>>>;
  getOrgMembershipsUser?: Maybe<Array<Maybe<UserOrgDetail>>>;
  /** Currently in development; will be used to list details about grants that provide access rights to parties outside the organization (like granting building tenants the right to view data about their spaces) */
  grants?: Maybe<Array<Maybe<Grant>>>;
  /** Invites are used to add additional users to the org. Use this query to return the list of user invites created by your org, including those that were ACCEPTED or still PENDING. */
  invites?: Maybe<Array<Maybe<Invite>>>;
  isOrgNameAvailable?: Maybe<OrgIsOrgNameAvailableResponse>;
  isPatNameAvailable?: Maybe<PersonalAccessTokenIsPatNameAvailableResponse>;
  leases?: Maybe<Array<Maybe<Lease>>>;
  /** Live queries are GraphQL queries created once and then remain active, monitoring for changes perpetually for easy retrieval. Typically paired with a webhook to get proactive notificiations of changes pushed to an endpoint. */
  liveQueries?: Maybe<Array<Maybe<LiveQuery>>>;
  /** Use this query to view data about the user associated with the token, such as name or id. */
  me?: Maybe<User>;
  orgRoleGroups?: Maybe<Array<Maybe<OrgRoleGroupDto>>>;
  orgServiceAccounts?: Maybe<Array<Maybe<OrgServiceAccountContainer>>>;
  /** Use this query to view data about the organization associated with the the token, such as name or id. */
  organization?: Maybe<Org>;
  /** Currently in development and will be used in with connectors that expose information about individuals, such as calendar events. */
  people?: Maybe<Array<Maybe<Person>>>;
  /** A particular output at a particular time, like on/off for a device like a light. For more complex devices like a thermostat, points could be the ambient temperature in the room, what temperature is set, is the thermostat set to heat or set to cool. */
  points?: Maybe<Array<Maybe<Point>>>;
  /** For internal use only. */
  productBundleSubscriptions?: Maybe<Array<Maybe<BillingProductBundleSubscriptionResponse>>>;
  roleManagers?: Maybe<Array<Maybe<RoleManagerRoleDto>>>;
  serviceRequests?: Maybe<Array<Maybe<ServiceRequest>>>;
  /** Sites are the top level place - they contain buildings, which contain floors, which contain spaces. Use this query to view site specific data such as id, name or geoshape. */
  sites?: Maybe<Array<Maybe<Site>>>;
  /** Spaces are subsections of a floor, such as an office or a breakroom. Use this query to view space specific data such as id, name or geoshape. */
  spaces?: Maybe<Array<Maybe<Space>>>;
  subBuildings?: Maybe<Array<Maybe<SubBuilding>>>;
  suggestEquivalentSpaces?: Maybe<Array<Maybe<SpaceMappingSuggestedEquivalentSpaces>>>;
  suggestFloorLevels?: Maybe<Array<Maybe<SpaceMappingFloorLevelSuggestion>>>;
  suggestSpaceCodes?: Maybe<Array<Maybe<SpaceMappingSpaceCodeSuggestion>>>;
  /** All the devices in your places - HVAC systems, security systems, lighting, badge readers, elevators and similar. */
  things?: Maybe<Array<Maybe<Thing>>>;
  /** This will return information about the tokens in your account, or if you're an admin, you can look at tokens for other users. Note this will not return the actual Personal Access Token, only the token record id and data like the name and scopes. */
  tokens?: Maybe<Array<Maybe<PersonalAccessToken>>>;
  /** Predefined / global list containing units of measurement for point data, such as "Degrees". Used for timeseries data comprehension, i.e. series data for a point shows "65", units helps you understand that means 65 degrees. */
  units?: Maybe<Array<Maybe<Unit>>>;
  /** If you're an admin, use this query to retrieve data about users. If you're a non-admin user, you can review the listed data about yourself. */
  users?: Maybe<Array<Maybe<User>>>;
  /** Used to return data about webhook targets created by org admins. */
  webhookTargets?: Maybe<Array<Maybe<WebhookTarget>>>;
  workOrders?: Maybe<Array<Maybe<WorkOrder>>>;
  zones?: Maybe<Array<Maybe<Zone>>>;
};


/** Queries retrieve data from the data store. */
export type QueryAccessConnectorAuthArgs = {
  input?: Maybe<ConnectorAuthAccessRequestInput>;
};


/** Queries retrieve data from the data store. */
export type QueryAccessTokenFromPatArgs = {
  input?: Maybe<PersonalAccessTokenGetAccessTokenFromPatRequestInput>;
};


/** Queries retrieve data from the data store. */
export type QueryAccountsArgs = {
  filter?: Maybe<AccountFilter>;
};


/** Queries retrieve data from the data store. */
export type QueryAvailableConnectorTypesArgs = {
  filter?: Maybe<ConnectorTypeFilterInput>;
  includeRequested?: Maybe<Scalars['Boolean']>;
  includeUponRequest?: Maybe<Scalars['Boolean']>;
};


/** Queries retrieve data from the data store. */
export type QueryBuildingsArgs = {
  filter?: Maybe<BuildingFilter>;
};


/** Queries retrieve data from the data store. */
export type QueryCalendarEventsArgs = {
  filter?: Maybe<CalendarEventFilter>;
};


/** Queries retrieve data from the data store. */
export type QueryCollectionsArgs = {
  filter?: Maybe<CollectionFilter>;
};


/** Queries retrieve data from the data store. */
export type QueryConnectorAuthArgs = {
  id?: Maybe<Scalars['String']>;
};


/** Queries retrieve data from the data store. */
export type QueryConnectorTypesArgs = {
  filter?: Maybe<ConnectorTypeFilterInput>;
};


/** Queries retrieve data from the data store. */
export type QueryConnectorsArgs = {
  filter?: Maybe<ConnectorFilterInput>;
};


/** Queries retrieve data from the data store. */
export type QueryFloorsArgs = {
  filter?: Maybe<FloorFilter>;
};


/** Queries retrieve data from the data store. */
export type QueryGatewaysArgs = {
  filter?: Maybe<GatewayFilterInput>;
};


/** Queries retrieve data from the data store. */
export type QueryGrantsArgs = {
  filter?: Maybe<GrantFilterInput>;
};


/** Queries retrieve data from the data store. */
export type QueryInvitesArgs = {
  filter?: Maybe<InviteFilterInput>;
};


/** Queries retrieve data from the data store. */
export type QueryIsOrgNameAvailableArgs = {
  orgName?: Maybe<Scalars['String']>;
};


/** Queries retrieve data from the data store. */
export type QueryIsPatNameAvailableArgs = {
  name?: Maybe<Scalars['String']>;
};


/** Queries retrieve data from the data store. */
export type QueryLeasesArgs = {
  filter?: Maybe<LeaseFilter>;
};


/** Queries retrieve data from the data store. */
export type QueryLiveQueriesArgs = {
  filter?: Maybe<LiveQueryFilterInput>;
};


/** Queries retrieve data from the data store. */
export type QueryOrgRoleGroupsArgs = {
  filter?: Maybe<OrgRoleGroupFilterInput>;
};


/** Queries retrieve data from the data store. */
export type QueryOrgServiceAccountsArgs = {
  filter?: Maybe<OrgServiceAccountFilterInput>;
};


/** Queries retrieve data from the data store. */
export type QueryPeopleArgs = {
  filter?: Maybe<PersonFilter>;
};


/** Queries retrieve data from the data store. */
export type QueryPointsArgs = {
  filter?: Maybe<PointFilter>;
};


/** Queries retrieve data from the data store. */
export type QueryRoleManagersArgs = {
  filter?: Maybe<RoleManagerFilterInput>;
};


/** Queries retrieve data from the data store. */
export type QueryServiceRequestsArgs = {
  filter?: Maybe<ServiceRequestFilter>;
};


/** Queries retrieve data from the data store. */
export type QuerySitesArgs = {
  filter?: Maybe<SiteFilter>;
};


/** Queries retrieve data from the data store. */
export type QuerySpacesArgs = {
  filter?: Maybe<SpaceFilter>;
};


/** Queries retrieve data from the data store. */
export type QuerySubBuildingsArgs = {
  filter?: Maybe<SubBuildingFilter>;
};


/** Queries retrieve data from the data store. */
export type QuerySuggestEquivalentSpacesArgs = {
  input?: Maybe<SpaceMappingSuggestEquivalentSpacesRequestInput>;
};


/** Queries retrieve data from the data store. */
export type QuerySuggestFloorLevelsArgs = {
  input?: Maybe<SpaceMappingSuggestFloorLevelsRequestInput>;
};


/** Queries retrieve data from the data store. */
export type QuerySuggestSpaceCodesArgs = {
  input?: Maybe<SpaceMappingSuggestSpaceCodesRequestInput>;
};


/** Queries retrieve data from the data store. */
export type QueryThingsArgs = {
  filter?: Maybe<ThingFilter>;
};


/** Queries retrieve data from the data store. */
export type QueryTokensArgs = {
  filter?: Maybe<PersonalAccessTokenFilterInput>;
};


/** Queries retrieve data from the data store. */
export type QueryUnitsArgs = {
  filter?: Maybe<UnitFilterInput>;
};


/** Queries retrieve data from the data store. */
export type QueryUsersArgs = {
  filter?: Maybe<UserFilterInput>;
};


/** Queries retrieve data from the data store. */
export type QueryWebhookTargetsArgs = {
  filter?: Maybe<WebhookTargetFilterInput>;
};


/** Queries retrieve data from the data store. */
export type QueryWorkOrdersArgs = {
  filter?: Maybe<WorkOrderFilter>;
};


/** Queries retrieve data from the data store. */
export type QueryZonesArgs = {
  filter?: Maybe<ZoneFilter>;
};

export type RegexMatch = {
  __typename?: 'RegexMatch';
  location?: Maybe<ValueLocation>;
  regex?: Maybe<Scalars['String']>;
};

export type RegexMatchInput = {
  location?: Maybe<ValueLocationInput>;
  regex?: Maybe<Scalars['String']>;
};

export type RelatesToEdge = Edge & {
  __typename?: 'RelatesToEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type RelatesToUnion = Building | Floor | GenericPlace | ServiceRequest | Site | Space | SubBuilding | Thing | Zone;

export type RentableAreaEdge = Edge & {
  __typename?: 'RentableAreaEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export enum Role {
  Admin = 'ADMIN',
  DestinationConnectorManagers = 'DESTINATION_CONNECTOR_MANAGERS',
  Explorer = 'EXPLORER',
  RoleUnspecified = 'ROLE_UNSPECIFIED'
}

export enum RoleInput {
  Admin = 'ADMIN',
  DestinationConnectorManagers = 'DESTINATION_CONNECTOR_MANAGERS',
  Explorer = 'EXPLORER',
  RoleUnspecified = 'ROLE_UNSPECIFIED'
}

export type RoleManagerFilterInput = {
  and?: Maybe<Array<Maybe<RoleManagerFilterInput>>>;
  description?: Maybe<StringFilterExpressionInput>;
  isSynced?: Maybe<BoolFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  not?: Maybe<Array<Maybe<RoleManagerFilterInput>>>;
  or?: Maybe<Array<Maybe<RoleManagerFilterInput>>>;
  permissions?: Maybe<StringArrayFilterExpressionInput>;
  roleType?: Maybe<RoleManagerRoleTypeFilterExpressionInput>;
  state?: Maybe<RoleManagerRoleStateFilterExpressionInput>;
};

export type RoleManagerRoleDto = {
  __typename?: 'RoleManagerRoleDTO';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSynced?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Array<Maybe<MetadataRecord>>>;
  name?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  roleType?: Maybe<RoleManagerRoleType>;
  state?: Maybe<RoleManagerRoleState>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum RoleManagerRoleState {
  RoleStateDisabled = 'ROLE_STATE_DISABLED',
  RoleStateEnabled = 'ROLE_STATE_ENABLED',
  RoleStateUnspecified = 'ROLE_STATE_UNSPECIFIED'
}

export type RoleManagerRoleStateFilterExpressionInput = {
  eq?: Maybe<RoleManagerRoleStateInput>;
  in?: Maybe<Array<Maybe<RoleManagerRoleStateInput>>>;
};

export enum RoleManagerRoleStateInput {
  RoleStateDisabled = 'ROLE_STATE_DISABLED',
  RoleStateEnabled = 'ROLE_STATE_ENABLED',
  RoleStateUnspecified = 'ROLE_STATE_UNSPECIFIED'
}

export enum RoleManagerRoleType {
  RoleTypeCommon = 'ROLE_TYPE_COMMON',
  RoleTypeOrgContext = 'ROLE_TYPE_ORG_CONTEXT',
  RoleTypeUnspecified = 'ROLE_TYPE_UNSPECIFIED'
}

export type RoleManagerRoleTypeFilterExpressionInput = {
  eq?: Maybe<RoleManagerRoleTypeInput>;
  in?: Maybe<Array<Maybe<RoleManagerRoleTypeInput>>>;
};

export enum RoleManagerRoleTypeInput {
  RoleTypeCommon = 'ROLE_TYPE_COMMON',
  RoleTypeOrgContext = 'ROLE_TYPE_ORG_CONTEXT',
  RoleTypeUnspecified = 'ROLE_TYPE_UNSPECIFIED'
}

export enum ScopeKey {
  Building = 'BUILDING',
  Connector = 'CONNECTOR',
  Floor = 'FLOOR',
  Global = 'GLOBAL',
  Org = 'ORG',
  ScopeKeyUnspecified = 'SCOPE_KEY_UNSPECIFIED',
  Site = 'SITE',
  Space = 'SPACE',
  Subbuilding = 'SUBBUILDING',
  Thing = 'THING'
}

export type ServesEdge = Edge & {
  __typename?: 'ServesEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

export type ServesUnion = Building | Floor | GenericPlace | Organization | Site | Space | SubBuilding | Zone;

export type ServiceRequest = GraphNode & {
  __typename?: 'ServiceRequest';
  connectedDataSourceId?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  exactType?: Maybe<Scalars['String']>;
  hasAssignee?: Maybe<Array<Maybe<Person>>>;
  hasAssigneeEdges?: Maybe<Array<Maybe<HasAssigneeEdge>>>;
  id: Scalars['String'];
  identities?: Maybe<Array<Maybe<ServiceRequestIdentityUnion>>>;
  isReportedBy?: Maybe<Person>;
  isReportedByEdges?: Maybe<Array<Maybe<IsReportedByEdge>>>;
  isResponsibilityOf?: Maybe<Array<Maybe<PeopleGroup>>>;
  isResponsibilityOfEdges?: Maybe<Array<Maybe<IsResponsibilityOfEdge>>>;
  jobPriority?: Maybe<Scalars['String']>;
  mappingKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  referenceUrl?: Maybe<Scalars['String']>;
  relatesTo?: Maybe<Array<Maybe<RelatesToUnion>>>;
  relatesToEdges?: Maybe<Array<Maybe<RelatesToEdge>>>;
  requestStatus?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type ServiceRequestHasAssigneeArgs = {
  filter?: Maybe<PersonFilter>;
};


export type ServiceRequestIsReportedByArgs = {
  filter?: Maybe<PersonFilter>;
};


export type ServiceRequestIsResponsibilityOfArgs = {
  filter?: Maybe<PeopleGroupFilter>;
};


export type ServiceRequestRelatesToArgs = {
  filter?: Maybe<EntityFilter>;
};

export type ServiceRequestFilter = {
  and?: Maybe<Array<Maybe<ServiceRequestFilter>>>;
  connectedDataSourceId?: Maybe<StringFilterExpressionInput>;
  dateCreated?: Maybe<TimestampFilterExpressionInput>;
  dateUpdated?: Maybe<TimestampFilterExpressionInput>;
  exactType?: Maybe<StringFilterExpressionInput>;
  id?: Maybe<IdFilterExpressionInput>;
  mappingKey?: Maybe<StringFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  not?: Maybe<ServiceRequestFilter>;
  or?: Maybe<Array<Maybe<ServiceRequestFilter>>>;
  type?: Maybe<StringArrayFilterExpressionInput>;
};

export type ServiceRequestIdentityUnion = AccessCredentialIdentity | BaCnetObjectId | BaCnetVendorId | EmailAddressIdentity | EmailIdentity | ExternalIdentity | FloorLevelIdentity | GenericIdentity | NameIdentity | PostalAddressIdentity | SpaceCode | SubBuildingCode;

export type SignatureMatch = {
  __typename?: 'SignatureMatch';
  asymmetricKey?: Maybe<Certificate>;
  location?: Maybe<ValueLocation>;
  symmetricKey?: Maybe<Scalars['String']>;
  type?: Maybe<SignatureType>;
};

export type SignatureMatchInput = {
  asymmetricKey?: Maybe<CertificateInput>;
  location?: Maybe<ValueLocationInput>;
  symmetricKey?: Maybe<Scalars['String']>;
  type?: Maybe<SignatureTypeInput>;
};

export enum SignatureType {
  EcdsaSha1 = 'ECDSA_SHA1',
  EcdsaSha224 = 'ECDSA_SHA224',
  EcdsaSha256 = 'ECDSA_SHA256',
  EcdsaSha384 = 'ECDSA_SHA384',
  EcdsaSha3_224 = 'ECDSA_SHA3_224',
  EcdsaSha3_256 = 'ECDSA_SHA3_256',
  EcdsaSha3_384 = 'ECDSA_SHA3_384',
  EcdsaSha3_512 = 'ECDSA_SHA3_512',
  EcdsaSha512 = 'ECDSA_SHA512',
  HmacSha1 = 'HMAC_SHA1',
  HmacSha224 = 'HMAC_SHA224',
  HmacSha256 = 'HMAC_SHA256',
  HmacSha384 = 'HMAC_SHA384',
  HmacSha3_224 = 'HMAC_SHA3_224',
  HmacSha3_256 = 'HMAC_SHA3_256',
  HmacSha3_384 = 'HMAC_SHA3_384',
  HmacSha3_512 = 'HMAC_SHA3_512',
  HmacSha512 = 'HMAC_SHA512',
  RsassaPkcs1V1_5Sha1 = 'RSASSA_PKCS1_V1_5_SHA1',
  RsassaPkcs1V1_5Sha224 = 'RSASSA_PKCS1_V1_5_SHA224',
  RsassaPkcs1V1_5Sha256 = 'RSASSA_PKCS1_V1_5_SHA256',
  RsassaPkcs1V1_5Sha384 = 'RSASSA_PKCS1_V1_5_SHA384',
  RsassaPkcs1V1_5Sha512 = 'RSASSA_PKCS1_V1_5_SHA512',
  RsassaPssSha3_224 = 'RSASSA_PSS_SHA3_224',
  RsassaPssSha3_256 = 'RSASSA_PSS_SHA3_256',
  RsassaPssSha3_384 = 'RSASSA_PSS_SHA3_384',
  RsassaPssSha3_512 = 'RSASSA_PSS_SHA3_512',
  SignaturetypeUnspecified = 'SIGNATURETYPE_UNSPECIFIED'
}

export enum SignatureTypeInput {
  EcdsaSha1 = 'ECDSA_SHA1',
  EcdsaSha224 = 'ECDSA_SHA224',
  EcdsaSha256 = 'ECDSA_SHA256',
  EcdsaSha384 = 'ECDSA_SHA384',
  EcdsaSha3_224 = 'ECDSA_SHA3_224',
  EcdsaSha3_256 = 'ECDSA_SHA3_256',
  EcdsaSha3_384 = 'ECDSA_SHA3_384',
  EcdsaSha3_512 = 'ECDSA_SHA3_512',
  EcdsaSha512 = 'ECDSA_SHA512',
  HmacSha1 = 'HMAC_SHA1',
  HmacSha224 = 'HMAC_SHA224',
  HmacSha256 = 'HMAC_SHA256',
  HmacSha384 = 'HMAC_SHA384',
  HmacSha3_224 = 'HMAC_SHA3_224',
  HmacSha3_256 = 'HMAC_SHA3_256',
  HmacSha3_384 = 'HMAC_SHA3_384',
  HmacSha3_512 = 'HMAC_SHA3_512',
  HmacSha512 = 'HMAC_SHA512',
  RsassaPkcs1V1_5Sha1 = 'RSASSA_PKCS1_V1_5_SHA1',
  RsassaPkcs1V1_5Sha224 = 'RSASSA_PKCS1_V1_5_SHA224',
  RsassaPkcs1V1_5Sha256 = 'RSASSA_PKCS1_V1_5_SHA256',
  RsassaPkcs1V1_5Sha384 = 'RSASSA_PKCS1_V1_5_SHA384',
  RsassaPkcs1V1_5Sha512 = 'RSASSA_PKCS1_V1_5_SHA512',
  RsassaPssSha3_224 = 'RSASSA_PSS_SHA3_224',
  RsassaPssSha3_256 = 'RSASSA_PSS_SHA3_256',
  RsassaPssSha3_384 = 'RSASSA_PSS_SHA3_384',
  RsassaPssSha3_512 = 'RSASSA_PSS_SHA3_512',
  SignaturetypeUnspecified = 'SIGNATURETYPE_UNSPECIFIED'
}

export type SimpleBoolFilterExpressionInput = {
  eq?: Maybe<Scalars['Boolean']>;
  ne?: Maybe<Scalars['Boolean']>;
};

/** Contains the details about a site. */
export type Site = GraphNode & Place & ThingContainer & {
  __typename?: 'Site';
  /** All the buildings in a site will be listed here. */
  buildings?: Maybe<Array<Maybe<Building>>>;
  calendarEvents?: Maybe<Array<Maybe<CalendarEvent>>>;
  collections?: Maybe<Array<Maybe<Collection>>>;
  connectedDataSourceId?: Maybe<Scalars['String']>;
  /** Any connectors configured for a site will be listed here. */
  connectors?: Maybe<Array<Maybe<Connector>>>;
  /** This timestamp represents the date the site was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** This timestamp represents that date the site was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The description of a site; often left blank, especially if the site name is already descriptive. */
  description?: Maybe<Scalars['String']>;
  exactType?: Maybe<Scalars['String']>;
  grossArea?: Maybe<AreaQuantity>;
  grossAreaEdges?: Maybe<Array<Maybe<GrossAreaEdge>>>;
  hasPart?: Maybe<Array<Maybe<Place>>>;
  hasPartEdges?: Maybe<Array<Maybe<HasPartEdge>>>;
  hasPoint?: Maybe<Array<Maybe<Point>>>;
  hasPointEdges?: Maybe<Array<Maybe<HasPointEdge>>>;
  /** The unique ID of the site. */
  id: Scalars['String'];
  identities?: Maybe<Array<Maybe<SiteIdentityUnion>>>;
  isAdjacentTo?: Maybe<Array<Maybe<Place>>>;
  isAdjacentToEdges?: Maybe<Array<Maybe<IsAdjacentToEdge>>>;
  isFedBy?: Maybe<Array<Maybe<Thing>>>;
  isFedByEdges?: Maybe<Array<Maybe<IsFedByEdge>>>;
  isLocationOf?: Maybe<Array<Maybe<IsLocationOfUnion>>>;
  isLocationOfEdges?: Maybe<Array<Maybe<IsLocationOfEdge>>>;
  isPartOf?: Maybe<Array<Maybe<Place>>>;
  isPartOfEdges?: Maybe<Array<Maybe<IsPartOfEdge>>>;
  isServedBy?: Maybe<Array<Maybe<Thing>>>;
  isServedByEdges?: Maybe<Array<Maybe<IsServedByEdge>>>;
  mappingKey?: Maybe<Scalars['String']>;
  /** The name assigned to the site, like the name of a campus containing multiple buildings. */
  name?: Maybe<Scalars['String']>;
  /** The organization a site belongs to; this field will be restricted by access rights. */
  organization?: Maybe<Org>;
  points?: Maybe<Array<Maybe<Point>>>;
  rentableArea?: Maybe<AreaQuantity>;
  rentableAreaEdges?: Maybe<Array<Maybe<RentableAreaEdge>>>;
  /** All the things associated with a site, or any sublevels of the site (building, floor or space), will show here. */
  things?: Maybe<Array<Maybe<Thing>>>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
  usableArea?: Maybe<AreaQuantity>;
  usableAreaEdges?: Maybe<Array<Maybe<UsableAreaEdge>>>;
  zones?: Maybe<Array<Maybe<Zone>>>;
};


/** Contains the details about a site. */
export type SiteBuildingsArgs = {
  filter?: Maybe<BuildingFilter>;
};


/** Contains the details about a site. */
export type SiteCalendarEventsArgs = {
  filter?: Maybe<CalendarEventFilter>;
};


/** Contains the details about a site. */
export type SiteCollectionsArgs = {
  filter?: Maybe<CollectionFilter>;
};


/** Contains the details about a site. */
export type SiteConnectorsArgs = {
  filter?: Maybe<ConnectorFilterInput>;
};


/** Contains the details about a site. */
export type SiteGrossAreaArgs = {
  filter?: Maybe<AreaQuantityFilter>;
};


/** Contains the details about a site. */
export type SiteHasPartArgs = {
  filter?: Maybe<PlaceFilter>;
};


/** Contains the details about a site. */
export type SiteHasPointArgs = {
  filter?: Maybe<PointFilter>;
};


/** Contains the details about a site. */
export type SiteIsAdjacentToArgs = {
  filter?: Maybe<PlaceFilter>;
};


/** Contains the details about a site. */
export type SiteIsFedByArgs = {
  filter?: Maybe<ThingFilter>;
};


/** Contains the details about a site. */
export type SiteIsLocationOfArgs = {
  filter?: Maybe<EntityFilter>;
};


/** Contains the details about a site. */
export type SiteIsPartOfArgs = {
  filter?: Maybe<PlaceFilter>;
};


/** Contains the details about a site. */
export type SiteIsServedByArgs = {
  filter?: Maybe<ThingFilter>;
};


/** Contains the details about a site. */
export type SitePointsArgs = {
  filter?: Maybe<PointFilter>;
};


/** Contains the details about a site. */
export type SiteRentableAreaArgs = {
  filter?: Maybe<AreaQuantityFilter>;
};


/** Contains the details about a site. */
export type SiteThingsArgs = {
  filter?: Maybe<ThingFilter>;
};


/** Contains the details about a site. */
export type SiteUsableAreaArgs = {
  filter?: Maybe<AreaQuantityFilter>;
};


/** Contains the details about a site. */
export type SiteZonesArgs = {
  filter?: Maybe<ZoneFilter>;
};

export type SiteCreateRequestInput = {
  site?: Maybe<SiteMutationInput>;
};

export type SiteCreateResponse = {
  __typename?: 'SiteCreateResponse';
  site?: Maybe<SiteMutation>;
};

export type SiteDeleteRequestInput = {
  id?: Maybe<Scalars['String']>;
};

export type SiteDeleteResponse = {
  __typename?: 'SiteDeleteResponse';
  _?: Maybe<Scalars['String']>;
};

/** Contains the input values needed to filter site queries. */
export type SiteFilter = {
  /** Used to combine multiple filter criteria. */
  and?: Maybe<Array<Maybe<SiteFilter>>>;
  connectedDataSourceId?: Maybe<StringFilterExpressionInput>;
  dateCreated?: Maybe<TimestampFilterExpressionInput>;
  dateUpdated?: Maybe<TimestampFilterExpressionInput>;
  exactType?: Maybe<StringFilterExpressionInput>;
  /** Used to filter for a specific ID or IDs (refer to IDFilterExpressionInput for input options). */
  id?: Maybe<IdFilterExpressionInput>;
  mappingKey?: Maybe<StringFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  /** Used to omit a specific result or results from the response. */
  not?: Maybe<SiteFilter>;
  /** Used to return results that match at least one of the defined criteria. */
  or?: Maybe<Array<Maybe<SiteFilter>>>;
  type?: Maybe<StringArrayFilterExpressionInput>;
};

export type SiteIdentityUnion = AccessCredentialIdentity | BaCnetObjectId | BaCnetVendorId | EmailAddressIdentity | EmailIdentity | ExternalIdentity | FloorLevelIdentity | GenericIdentity | NameIdentity | PostalAddressIdentity | SpaceCode | SubBuildingCode;

export type SiteMutation = {
  __typename?: 'SiteMutation';
  /** @deprecated Field no longer supported */
  geoshape?: Maybe<Scalars['GeoJSON']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type SiteMutationInput = {
  geoshape?: Maybe<Scalars['GeoJSON']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type SiteUpdateRequestInput = {
  site?: Maybe<SiteMutationInput>;
};

export type SiteUpdateResponse = {
  __typename?: 'SiteUpdateResponse';
  site?: Maybe<SiteMutation>;
};

/** Contains the details about the space. */
export type Space = GraphNode & Place & ThingContainer & {
  __typename?: 'Space';
  calendarEvents?: Maybe<Array<Maybe<CalendarEvent>>>;
  collections?: Maybe<Array<Maybe<Collection>>>;
  connectedDataSourceId?: Maybe<Scalars['String']>;
  /** Any connectors configured for the space will be listed here. */
  connectors?: Maybe<Array<Maybe<Connector>>>;
  /** This timestamp represents the date the space was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** This timestamp represents that date the space was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The description of the space; often left blank, especially if the space name is already descriptive. */
  description?: Maybe<Scalars['String']>;
  /** This is the most specific type available for the space, i.e. where 'type' may return a list like [Place, Space, Room, Office], exactType will return just Office. */
  exactType?: Maybe<Scalars['String']>;
  /** Contains the details of the floor where the space is present. */
  floor: Floor;
  /** The geographic shape of the space, represented by latitude/longitude coordinate pairs. */
  geoshape?: Maybe<Scalars['GeoJSON']>;
  grossArea?: Maybe<AreaQuantity>;
  grossAreaEdges?: Maybe<Array<Maybe<GrossAreaEdge>>>;
  hasPart?: Maybe<Array<Maybe<Place>>>;
  hasPartEdges?: Maybe<Array<Maybe<HasPartEdge>>>;
  /** _ */
  hasPoint?: Maybe<Array<Maybe<Point>>>;
  hasPointEdges?: Maybe<Array<Maybe<HasPointEdge>>>;
  /** The unique ID of the space. */
  id: Scalars['String'];
  identities?: Maybe<Array<Maybe<SpaceIdentityUnion>>>;
  isAdjacentTo?: Maybe<Array<Maybe<Place>>>;
  isAdjacentToEdges?: Maybe<Array<Maybe<IsAdjacentToEdge>>>;
  /** _ */
  isFedBy?: Maybe<Array<Maybe<Thing>>>;
  isFedByEdges?: Maybe<Array<Maybe<IsFedByEdge>>>;
  /** _ */
  isLocationOf?: Maybe<Array<Maybe<IsLocationOfUnion>>>;
  isLocationOfEdges?: Maybe<Array<Maybe<IsLocationOfEdge>>>;
  isPartOf?: Maybe<Array<Maybe<Place>>>;
  isPartOfEdges?: Maybe<Array<Maybe<IsPartOfEdge>>>;
  isServedBy?: Maybe<Array<Maybe<Thing>>>;
  isServedByEdges?: Maybe<Array<Maybe<IsServedByEdge>>>;
  mappingKey?: Maybe<Scalars['String']>;
  maxOccupancy?: Maybe<Scalars['Int']>;
  /** The name assigned to the space, like "breakroom" or "rm101". */
  name?: Maybe<Scalars['String']>;
  /** _ */
  parentSpaceId?: Maybe<Scalars['String']>;
  points?: Maybe<Array<Maybe<Point>>>;
  rentableArea?: Maybe<AreaQuantity>;
  rentableAreaEdges?: Maybe<Array<Maybe<RentableAreaEdge>>>;
  /** All the things associated with a space will show here. */
  things?: Maybe<Array<Maybe<Thing>>>;
  /** The class or subclass of a space, like Room and Office. */
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
  usableArea?: Maybe<AreaQuantity>;
  usableAreaEdges?: Maybe<Array<Maybe<UsableAreaEdge>>>;
};


/** Contains the details about the space. */
export type SpaceCalendarEventsArgs = {
  filter?: Maybe<CalendarEventFilter>;
};


/** Contains the details about the space. */
export type SpaceCollectionsArgs = {
  filter?: Maybe<CollectionFilter>;
};


/** Contains the details about the space. */
export type SpaceConnectorsArgs = {
  filter?: Maybe<ConnectorFilterInput>;
};


/** Contains the details about the space. */
export type SpaceGrossAreaArgs = {
  filter?: Maybe<AreaQuantityFilter>;
};


/** Contains the details about the space. */
export type SpaceHasPartArgs = {
  filter?: Maybe<PlaceFilter>;
};


/** Contains the details about the space. */
export type SpaceHasPointArgs = {
  filter?: Maybe<PointFilter>;
};


/** Contains the details about the space. */
export type SpaceIsAdjacentToArgs = {
  filter?: Maybe<PlaceFilter>;
};


/** Contains the details about the space. */
export type SpaceIsFedByArgs = {
  filter?: Maybe<ThingFilter>;
};


/** Contains the details about the space. */
export type SpaceIsLocationOfArgs = {
  filter?: Maybe<EntityFilter>;
};


/** Contains the details about the space. */
export type SpaceIsPartOfArgs = {
  filter?: Maybe<PlaceFilter>;
};


/** Contains the details about the space. */
export type SpaceIsServedByArgs = {
  filter?: Maybe<ThingFilter>;
};


/** Contains the details about the space. */
export type SpacePointsArgs = {
  filter?: Maybe<PointFilter>;
};


/** Contains the details about the space. */
export type SpaceRentableAreaArgs = {
  filter?: Maybe<AreaQuantityFilter>;
};


/** Contains the details about the space. */
export type SpaceThingsArgs = {
  filter?: Maybe<ThingFilter>;
};


/** Contains the details about the space. */
export type SpaceUsableAreaArgs = {
  filter?: Maybe<AreaQuantityFilter>;
};

export type SpaceCode = Identity & SpaceCodeModel & {
  __typename?: 'SpaceCode';
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<ScopeKey>;
  scopeId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type SpaceCodeModel = {
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<ScopeKey>;
  scopeId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type SpaceCreateRequestInput = {
  space?: Maybe<SpaceMutationInput>;
};

export type SpaceCreateResponse = {
  __typename?: 'SpaceCreateResponse';
  space?: Maybe<SpaceMutation>;
};

export type SpaceDeleteRequestInput = {
  id?: Maybe<Scalars['String']>;
};

export type SpaceDeleteResponse = {
  __typename?: 'SpaceDeleteResponse';
  _?: Maybe<Scalars['String']>;
};

/** Contains the input values needed to filter space queries. */
export type SpaceFilter = {
  /** Used to combine multiple filter criteria. */
  and?: Maybe<Array<Maybe<SpaceFilter>>>;
  connectedDataSourceId?: Maybe<StringFilterExpressionInput>;
  dateCreated?: Maybe<TimestampFilterExpressionInput>;
  dateUpdated?: Maybe<TimestampFilterExpressionInput>;
  exactType?: Maybe<StringFilterExpressionInput>;
  /** Used to filter for a specific ID or IDs (refer to IDFilterExpressionInput for input options). */
  id?: Maybe<IdFilterExpressionInput>;
  mappingKey?: Maybe<StringFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  /** Used to omit a specific result or results from the response. */
  not?: Maybe<SpaceFilter>;
  /** Used to return results that match at least one of the defined criteria. */
  or?: Maybe<Array<Maybe<SpaceFilter>>>;
  type?: Maybe<StringArrayFilterExpressionInput>;
};

export type SpaceIdentityUnion = AccessCredentialIdentity | BaCnetObjectId | BaCnetVendorId | EmailAddressIdentity | EmailIdentity | ExternalIdentity | FloorLevelIdentity | GenericIdentity | NameIdentity | PostalAddressIdentity | SpaceCode | SubBuildingCode;

export type SpaceMappingEquivalentSpaceSuggestion = {
  __typename?: 'SpaceMappingEquivalentSpaceSuggestion';
  confidence?: Maybe<Scalars['Float']>;
  space?: Maybe<SpaceMutation>;
};

export type SpaceMappingFloorLevelSuggestion = {
  __typename?: 'SpaceMappingFloorLevelSuggestion';
  confidence?: Maybe<Scalars['Float']>;
  level?: Maybe<Scalars['Int']>;
};

export type SpaceMappingSpaceCodeSuggestion = {
  __typename?: 'SpaceMappingSpaceCodeSuggestion';
  confidence?: Maybe<Scalars['Float']>;
  spaceCode?: Maybe<Scalars['String']>;
};

export type SpaceMappingSuggestEquivalentSpacesRequestInput = {
  buildingId?: Maybe<Scalars['String']>;
  spaces?: Maybe<Array<Maybe<SpaceMutationInput>>>;
};

export type SpaceMappingSuggestFloorLevelsRequestInput = {
  buildingId?: Maybe<Scalars['String']>;
  groundFloorLevel?: Maybe<Scalars['Int']>;
  spaces?: Maybe<Array<Maybe<SpaceMutationInput>>>;
};

export type SpaceMappingSuggestSpaceCodesRequestInput = {
  buildingId?: Maybe<Scalars['String']>;
  spaces?: Maybe<Array<Maybe<SpaceMutationInput>>>;
};

export type SpaceMappingSuggestedEquivalentSpaces = {
  __typename?: 'SpaceMappingSuggestedEquivalentSpaces';
  spaces?: Maybe<Array<Maybe<SpaceMappingEquivalentSpaceSuggestion>>>;
};

export type SpaceMutation = {
  __typename?: 'SpaceMutation';
  exactType?: Maybe<Array<Maybe<Scalars['String']>>>;
  floorId?: Maybe<Scalars['String']>;
  geoshape?: Maybe<Scalars['GeoJSON']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentSpaceId?: Maybe<Scalars['String']>;
};

export type SpaceMutationInput = {
  exactType?: Maybe<Array<Maybe<Scalars['String']>>>;
  floorId?: Maybe<Scalars['String']>;
  geoshape?: Maybe<Scalars['GeoJSON']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentSpaceId?: Maybe<Scalars['String']>;
};

export type SpaceUpdateRequestInput = {
  space?: Maybe<SpaceMutationInput>;
};

export type SpaceUpdateResponse = {
  __typename?: 'SpaceUpdateResponse';
  space?: Maybe<SpaceMutation>;
};

export type StringArrayFilterExpressionInput = {
  eq?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Maybe<Scalars['String']>>>;
  ne?: Maybe<Scalars['String']>;
};

export type StringArrayUpdateInput = {
  granular?: Maybe<GranularInput>;
  replace?: Maybe<StringArrayValueInput>;
};

export type StringArrayValueInput = {
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type StringFilterExpressionInput = {
  contains?: Maybe<Scalars['String']>;
  eq?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Maybe<Scalars['String']>>>;
  ne?: Maybe<Scalars['String']>;
};

export type SubBuilding = GraphNode & Place & ThingContainer & {
  __typename?: 'SubBuilding';
  address?: Maybe<Address>;
  building?: Maybe<Building>;
  calendarEvents?: Maybe<Array<Maybe<CalendarEvent>>>;
  collections?: Maybe<Array<Maybe<Collection>>>;
  connectedDataSourceId?: Maybe<Scalars['String']>;
  connectors?: Maybe<Array<Maybe<Connector>>>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  exactType?: Maybe<Scalars['String']>;
  floors?: Maybe<Array<Maybe<Floor>>>;
  grossArea?: Maybe<AreaQuantity>;
  grossAreaEdges?: Maybe<Array<Maybe<GrossAreaEdge>>>;
  hasAddress?: Maybe<Address>;
  hasAddressEdges?: Maybe<Array<Maybe<HasAddressEdge>>>;
  hasPart?: Maybe<Array<Maybe<Place>>>;
  hasPartEdges?: Maybe<Array<Maybe<HasPartEdge>>>;
  hasPoint?: Maybe<Array<Maybe<Point>>>;
  hasPointEdges?: Maybe<Array<Maybe<HasPointEdge>>>;
  id: Scalars['String'];
  identities?: Maybe<Array<Maybe<SubBuildingIdentityUnion>>>;
  isAdjacentTo?: Maybe<Array<Maybe<Place>>>;
  isAdjacentToEdges?: Maybe<Array<Maybe<IsAdjacentToEdge>>>;
  isFedBy?: Maybe<Array<Maybe<Thing>>>;
  isFedByEdges?: Maybe<Array<Maybe<IsFedByEdge>>>;
  isLocationOf?: Maybe<Array<Maybe<IsLocationOfUnion>>>;
  isLocationOfEdges?: Maybe<Array<Maybe<IsLocationOfEdge>>>;
  isPartOf?: Maybe<Array<Maybe<Place>>>;
  isPartOfEdges?: Maybe<Array<Maybe<IsPartOfEdge>>>;
  isServedBy?: Maybe<Array<Maybe<Thing>>>;
  isServedByEdges?: Maybe<Array<Maybe<IsServedByEdge>>>;
  mappingKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  points?: Maybe<Array<Maybe<Point>>>;
  rentableArea?: Maybe<AreaQuantity>;
  rentableAreaEdges?: Maybe<Array<Maybe<RentableAreaEdge>>>;
  spaces?: Maybe<Array<Maybe<Space>>>;
  things?: Maybe<Array<Maybe<Thing>>>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
  usableArea?: Maybe<AreaQuantity>;
  usableAreaEdges?: Maybe<Array<Maybe<UsableAreaEdge>>>;
  zones?: Maybe<Array<Maybe<Zone>>>;
};


export type SubBuildingCalendarEventsArgs = {
  filter?: Maybe<CalendarEventFilter>;
};


export type SubBuildingCollectionsArgs = {
  filter?: Maybe<CollectionFilter>;
};


export type SubBuildingConnectorsArgs = {
  filter?: Maybe<ConnectorFilterInput>;
};


export type SubBuildingFloorsArgs = {
  filter?: Maybe<FloorFilter>;
};


export type SubBuildingGrossAreaArgs = {
  filter?: Maybe<AreaQuantityFilter>;
};


export type SubBuildingHasAddressArgs = {
  filter?: Maybe<AddressFilter>;
};


export type SubBuildingHasPartArgs = {
  filter?: Maybe<PlaceFilter>;
};


export type SubBuildingHasPointArgs = {
  filter?: Maybe<PointFilter>;
};


export type SubBuildingIsAdjacentToArgs = {
  filter?: Maybe<PlaceFilter>;
};


export type SubBuildingIsFedByArgs = {
  filter?: Maybe<ThingFilter>;
};


export type SubBuildingIsLocationOfArgs = {
  filter?: Maybe<EntityFilter>;
};


export type SubBuildingIsPartOfArgs = {
  filter?: Maybe<PlaceFilter>;
};


export type SubBuildingIsServedByArgs = {
  filter?: Maybe<ThingFilter>;
};


export type SubBuildingPointsArgs = {
  filter?: Maybe<PointFilter>;
};


export type SubBuildingRentableAreaArgs = {
  filter?: Maybe<AreaQuantityFilter>;
};


export type SubBuildingSpacesArgs = {
  childDepth?: Maybe<Scalars['Int']>;
  filter?: Maybe<SpaceFilter>;
};


export type SubBuildingThingsArgs = {
  filter?: Maybe<ThingFilter>;
};


export type SubBuildingUsableAreaArgs = {
  filter?: Maybe<AreaQuantityFilter>;
};


export type SubBuildingZonesArgs = {
  filter?: Maybe<ZoneFilter>;
};

export type SubBuildingCode = Identity & SubBuildingCodeModel & {
  __typename?: 'SubBuildingCode';
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<ScopeKey>;
  scopeId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type SubBuildingCodeModel = {
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<ScopeKey>;
  scopeId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type SubBuildingCreateRequestInput = {
  subBuilding?: Maybe<SubBuildingMutationInput>;
};

export type SubBuildingCreateResponse = {
  __typename?: 'SubBuildingCreateResponse';
  subBuilding?: Maybe<SubBuildingMutation>;
};

export type SubBuildingDeleteRequestInput = {
  id?: Maybe<Scalars['String']>;
};

export type SubBuildingDeleteResponse = {
  __typename?: 'SubBuildingDeleteResponse';
  _?: Maybe<Scalars['String']>;
};

export type SubBuildingFilter = {
  and?: Maybe<Array<Maybe<SubBuildingFilter>>>;
  connectedDataSourceId?: Maybe<StringFilterExpressionInput>;
  dateCreated?: Maybe<TimestampFilterExpressionInput>;
  dateUpdated?: Maybe<TimestampFilterExpressionInput>;
  exactType?: Maybe<StringFilterExpressionInput>;
  id?: Maybe<IdFilterExpressionInput>;
  mappingKey?: Maybe<StringFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  not?: Maybe<SubBuildingFilter>;
  or?: Maybe<Array<Maybe<SubBuildingFilter>>>;
  type?: Maybe<StringArrayFilterExpressionInput>;
};

export type SubBuildingIdentityUnion = AccessCredentialIdentity | BaCnetObjectId | BaCnetVendorId | EmailAddressIdentity | EmailIdentity | ExternalIdentity | FloorLevelIdentity | GenericIdentity | NameIdentity | PostalAddressIdentity | SpaceCode | SubBuildingCode;

export type SubBuildingMutation = {
  __typename?: 'SubBuildingMutation';
  address?: Maybe<AddressMutation>;
  buildingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
};

export type SubBuildingMutationInput = {
  address?: Maybe<AddressMutationInput>;
  buildingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
};

export type SubBuildingUpdateRequestInput = {
  subBuilding?: Maybe<SubBuildingMutationInput>;
};

export type SubBuildingUpdateResponse = {
  __typename?: 'SubBuildingUpdateResponse';
  subBuilding?: Maybe<SubBuildingMutation>;
};

export type SystemTypeFilterExpressionInput = {
  eq?: Maybe<SystemTypeKeyInput>;
  in?: Maybe<Array<Maybe<SystemTypeKeyInput>>>;
};

export enum SystemTypeKey {
  AirQualityMonitoringSystem = 'AIR_QUALITY_MONITORING_SYSTEM',
  CalendarSystem = 'CALENDAR_SYSTEM',
  ElectricalSystem = 'ELECTRICAL_SYSTEM',
  ElectricitySystem = 'ELECTRICITY_SYSTEM',
  ElevatorSystem = 'ELEVATOR_SYSTEM',
  GasSystem = 'GAS_SYSTEM',
  HvacSystem = 'HVAC_SYSTEM',
  LightingSystem = 'LIGHTING_SYSTEM',
  SafetySystem = 'SAFETY_SYSTEM',
  SecuritySystem = 'SECURITY_SYSTEM',
  SewageSystem = 'SEWAGE_SYSTEM',
  SpatialIntelligenceSystem = 'SPATIAL_INTELLIGENCE_SYSTEM',
  SystemtypeUnknown = 'SYSTEMTYPE_UNKNOWN',
  SystemTypeKeyUnspecified = 'SYSTEM_TYPE_KEY_UNSPECIFIED',
  TeleconferenceSystem = 'TELECONFERENCE_SYSTEM',
  WaterSystem = 'WATER_SYSTEM',
  WeatherSystem = 'WEATHER_SYSTEM'
}

export enum SystemTypeKeyInput {
  AirQualityMonitoringSystem = 'AIR_QUALITY_MONITORING_SYSTEM',
  CalendarSystem = 'CALENDAR_SYSTEM',
  ElectricalSystem = 'ELECTRICAL_SYSTEM',
  ElectricitySystem = 'ELECTRICITY_SYSTEM',
  ElevatorSystem = 'ELEVATOR_SYSTEM',
  GasSystem = 'GAS_SYSTEM',
  HvacSystem = 'HVAC_SYSTEM',
  LightingSystem = 'LIGHTING_SYSTEM',
  SafetySystem = 'SAFETY_SYSTEM',
  SecuritySystem = 'SECURITY_SYSTEM',
  SewageSystem = 'SEWAGE_SYSTEM',
  SpatialIntelligenceSystem = 'SPATIAL_INTELLIGENCE_SYSTEM',
  SystemtypeUnknown = 'SYSTEMTYPE_UNKNOWN',
  SystemTypeKeyUnspecified = 'SYSTEM_TYPE_KEY_UNSPECIFIED',
  TeleconferenceSystem = 'TELECONFERENCE_SYSTEM',
  WaterSystem = 'WATER_SYSTEM',
  WeatherSystem = 'WEATHER_SYSTEM'
}

/** Contains the details about a thing. */
export type Thing = GraphNode & {
  __typename?: 'Thing';
  assetTrackingID?: Maybe<Scalars['String']>;
  connectedDataSourceId?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateInstalled?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The description of a thing, like Rooftop Air Handler. */
  description?: Maybe<Scalars['String']>;
  /** This is the most specific type available for a thing, i.e. where 'type' may return a list like [Device, HVAC, Damper], exactType will return just Damper. */
  exactType?: Maybe<Scalars['String']>;
  feeds?: Maybe<Array<Maybe<FeedsUnion>>>;
  feedsEdges?: Maybe<Array<Maybe<FeedsEdge>>>;
  /** This is primarily a Building Automation System field; when available, it will provide the firmware version for a device. */
  firmwareVersion?: Maybe<Scalars['String']>;
  /** The geographic shape of a thing, represented by latitude/longitude coordinate pairs. */
  geoshape?: Maybe<Scalars['GeoJSON']>;
  hasDeviceModel?: Maybe<DeviceModel>;
  hasDeviceModelEdges?: Maybe<Array<Maybe<HasDeviceModelEdge>>>;
  /** This represents the location of a thing, such as a space name. */
  hasLocation?: Maybe<Place>;
  hasLocationEdges?: Maybe<Array<Maybe<HasLocationEdge>>>;
  /** If a thing has any additional parts, like a VAV with a damper, the damper will be referenced here. */
  hasPart?: Maybe<Array<Maybe<Thing>>>;
  hasPartEdges?: Maybe<Array<Maybe<HasPartEdge>>>;
  /** _ */
  hasPoint?: Maybe<Array<Maybe<Point>>>;
  hasPointEdges?: Maybe<Array<Maybe<HasPointEdge>>>;
  /** The unique ID of a thing. */
  id: Scalars['String'];
  identities?: Maybe<Array<Maybe<ThingIdentityUnion>>>;
  /** _ */
  isFedBy?: Maybe<Array<Maybe<IsFedByUnion>>>;
  isFedByEdges?: Maybe<Array<Maybe<IsFedByEdge>>>;
  /** If a thing is 'a part of' a different device, like a damper that's part of a VAV, the VAV will be referenced here. */
  isPartOf?: Maybe<Array<Maybe<Thing>>>;
  isPartOfEdges?: Maybe<Array<Maybe<IsPartOfEdge>>>;
  isResponsibilityOf?: Maybe<Array<Maybe<PeopleGroup>>>;
  isResponsibilityOfEdges?: Maybe<Array<Maybe<IsResponsibilityOfEdge>>>;
  isVirtual?: Maybe<Scalars['Boolean']>;
  manufacturedBy?: Maybe<Agent>;
  manufacturedByEdges?: Maybe<Array<Maybe<ManufacturedByEdge>>>;
  /** _ */
  mappingKey?: Maybe<Scalars['String']>;
  /**
   * If available, the model - along with manufacturer information - of a thing will be outlined here.
   * @deprecated No longer supported. Scheduled for removal on 02/21/2024. Use hasDeviceModel and manufacturedBy query as an alternative.
   */
  model?: Maybe<DeviceLibraryModel>;
  /** The name of a thing, usually abbreviations of the thing's description along with location details and/or BAS information. */
  name?: Maybe<Scalars['String']>;
  /** The organization a thing belongs to; this field will be restricted by access rights. */
  organization?: Maybe<Org>;
  /** The details of the place(s) where a thing is located, such as a specific building, floor, or space. */
  places?: Maybe<Array<Maybe<Place>>>;
  /** A list of points associated with a thing, such as a temperature setting for a thermostat. Not all things will have points. */
  points?: Maybe<Array<Maybe<Point>>>;
  seeAlso?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  serves?: Maybe<Array<Maybe<ServesUnion>>>;
  servesEdges?: Maybe<Array<Maybe<ServesEdge>>>;
  /** The class or subclass of a thing, like HVAC and AHU. */
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** Contains the details about a thing. */
export type ThingFeedsArgs = {
  filter?: Maybe<EntityFilter>;
};


/** Contains the details about a thing. */
export type ThingHasDeviceModelArgs = {
  filter?: Maybe<DeviceModelFilter>;
};


/** Contains the details about a thing. */
export type ThingHasLocationArgs = {
  filter?: Maybe<PlaceFilter>;
};


/** Contains the details about a thing. */
export type ThingHasPartArgs = {
  filter?: Maybe<ThingFilter>;
};


/** Contains the details about a thing. */
export type ThingHasPointArgs = {
  filter?: Maybe<PointFilter>;
};


/** Contains the details about a thing. */
export type ThingIsFedByArgs = {
  filter?: Maybe<EntityFilter>;
};


/** Contains the details about a thing. */
export type ThingIsPartOfArgs = {
  filter?: Maybe<ThingFilter>;
};


/** Contains the details about a thing. */
export type ThingIsResponsibilityOfArgs = {
  filter?: Maybe<PeopleGroupFilter>;
};


/** Contains the details about a thing. */
export type ThingManufacturedByArgs = {
  filter?: Maybe<AgentFilter>;
};


/** Contains the details about a thing. */
export type ThingPlacesArgs = {
  filter?: Maybe<PlaceFilter>;
};


/** Contains the details about a thing. */
export type ThingPointsArgs = {
  filter?: Maybe<PointFilter>;
};


/** Contains the details about a thing. */
export type ThingServesArgs = {
  filter?: Maybe<EntityFilter>;
};

export type ThingContainer = {
  things?: Maybe<Array<Maybe<Thing>>>;
};


export type ThingContainerThingsArgs = {
  filter?: Maybe<ThingFilter>;
};

/** Contains the input values needed to filter thing queries. */
export type ThingFilter = {
  /** Used to combine multiple filter criteria. */
  and?: Maybe<Array<Maybe<ThingFilter>>>;
  connectedDataSourceId?: Maybe<StringFilterExpressionInput>;
  dateCreated?: Maybe<TimestampFilterExpressionInput>;
  dateUpdated?: Maybe<TimestampFilterExpressionInput>;
  exactType?: Maybe<StringFilterExpressionInput>;
  /** Used to filter for a specific ID or IDs (refer to IDFilterExpressionInput for input options). */
  id?: Maybe<IdFilterExpressionInput>;
  isVirtual?: Maybe<SimpleBoolFilterExpressionInput>;
  mappingKey?: Maybe<StringFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  /** Used to omit a specific result or results from the response. */
  not?: Maybe<ThingFilter>;
  /** Used to return results that match at least one of the defined criteria. */
  or?: Maybe<Array<Maybe<ThingFilter>>>;
  /** Used to filter on a specific class or subclass of a thing, like HVAC and AHU. */
  type?: Maybe<StringArrayFilterExpressionInput>;
};

export type ThingIdentityUnion = AccessCredentialIdentity | BaCnetObjectId | BaCnetVendorId | EmailAddressIdentity | EmailIdentity | ExternalIdentity | FloorLevelIdentity | GenericIdentity | NameIdentity | PostalAddressIdentity | SpaceCode | SubBuildingCode;

export type Tier = {
  __typename?: 'Tier';
  flatAmount?: Maybe<Scalars['Long']>;
  flatAmountDecimal?: Maybe<Scalars['String']>;
  unitAmount?: Maybe<Scalars['Long']>;
  unitAmountDecimal?: Maybe<Scalars['String']>;
  upTo?: Maybe<Scalars['Long']>;
};

export enum TimeseriesAggPeriodInput {
  AggPeriodUnspecified = 'AGG_PERIOD_UNSPECIFIED',
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE'
}

export type TimeseriesAggregateRow = {
  __typename?: 'TimeseriesAggregateRow';
  avg?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['DateTime']>;
};

export enum TimeseriesNumericalException {
  Infinity = 'INFINITY',
  Nan = 'NAN',
  NegativeInfinity = 'NEGATIVE_INFINITY',
  NumericalExceptionUnspecified = 'NUMERICAL_EXCEPTION_UNSPECIFIED'
}

export type TimeseriesRow = {
  __typename?: 'TimeseriesRow';
  ingestionTime?: Maybe<Scalars['DateTime']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  value?: Maybe<TimeseriesRowValue>;
};

export type TimeseriesRowValue = {
  __typename?: 'TimeseriesRowValue';
  boolValue?: Maybe<Scalars['Boolean']>;
  byteArrayValue?: Maybe<Scalars['String']>;
  float32Value?: Maybe<Scalars['Float']>;
  float64Value?: Maybe<Scalars['Float']>;
  geopointValue?: Maybe<GeoPoint>;
  int32Value?: Maybe<Scalars['Int']>;
  int64Value?: Maybe<Scalars['Long']>;
  json?: Maybe<Scalars['JSONLD']>;
  numericalException?: Maybe<TimeseriesNumericalException>;
  stringValue?: Maybe<Scalars['String']>;
  uint32Value?: Maybe<Scalars['Long']>;
  uint64Value?: Maybe<Scalars['Long']>;
};

export type TimestampFilterExpressionInput = {
  eq?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
};

export type TimestampRangeFilterExpressionInput = {
  gte?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
};

/** Contains the details about a unit of measurement for point data. */
export type Unit = {
  __typename?: 'Unit';
  /** The description of a unit, typically a definition of the unit name. */
  description?: Maybe<Scalars['String']>;
  /** The unique ID of the unit. */
  id?: Maybe<Scalars['String']>;
  /** The name of the unit, like "Degree". */
  name?: Maybe<Scalars['String']>;
};

/** Contains the input values needed to filter unit queries. */
export type UnitFilterInput = {
  /** Used to filter for a specific ID or IDs (refer to IDFilterExpressionInput for input options). */
  id?: Maybe<IdFilterExpressionInput>;
};


export type UsableAreaEdge = Edge & {
  __typename?: 'UsableAreaEdge';
  mappingKey?: Maybe<Scalars['String']>;
  node?: Maybe<GraphNode>;
};

/** Contains the details about a user. */
export type User = {
  __typename?: 'User';
  /** The timestamp of the user creation. */
  created?: Maybe<Scalars['DateTime']>;
  /** The user's email. */
  email?: Maybe<Scalars['String']>;
  /** True or False, whether the user has verified their email yet. */
  emailVerified?: Maybe<Scalars['Boolean']>;
  /** The unique ID of the user. */
  id?: Maybe<Scalars['String']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  loginsCount?: Maybe<Scalars['Long']>;
  /** The name of a user - this will be the full name, first and last. */
  name?: Maybe<Scalars['String']>;
  /**
   * The user's nickname (often just the first name of the user).
   * @deprecated Field no longer supported
   */
  nickname?: Maybe<Scalars['String']>;
  orgRoles?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The details for the user's organization. */
  organization?: Maybe<Org>;
  /** Lists the user's roles, such as ADMIN or EXPLORER. */
  roles?: Maybe<Array<Maybe<Role>>>;
  /** Lists the tokens for the user - will not return the actual PAT, but will show name, permissions/scopes, when the token was last used. */
  tokens?: Maybe<Array<Maybe<PersonalAccessToken>>>;
  /** Timestamp when one or more user details were last updated. */
  updated?: Maybe<Scalars['DateTime']>;
};


/** Contains the details about a user. */
export type UserTokensArgs = {
  filter?: Maybe<PersonalAccessTokenFilterInput>;
};

/** Contains the input values needed to update a user's assigned role. */
export type UserAssignRoleRequestInput = {
  /** Provide the role you want to assign to the user here. */
  role?: Maybe<RoleInput>;
  /** Provide the id of the intended user here. */
  userId?: Maybe<Scalars['String']>;
};

export type UserAssignRoleResponse = {
  __typename?: 'UserAssignRoleResponse';
  user?: Maybe<User>;
};

/** Contains the input values needed to create a new user. */
export type UserCreateRequestInput = {
  /** Accepts 'true' or 'false' - when set to true, the user will not receive the invite email, which is best practice if you intend to verify their email programmatically in the 'user' field. */
  skipInviteEmail?: Maybe<Scalars['Boolean']>;
  /** Define a temporary password for the user; once they log in with the temp password, they will be prompted to change it. */
  temporaryPassword?: Maybe<Scalars['String']>;
  /** Contains the input values for the user details, such as name, email and role. */
  user?: Maybe<UserInput>;
};

export type UserCreateResponse = {
  __typename?: 'UserCreateResponse';
  user?: Maybe<User>;
};

/** Contains the input values needed to filter user queries. */
export type UserFilterInput = {
  /** Used to filter on the user's email, either an exact match, in a defined set or by a partial match. */
  email?: Maybe<StringFilterExpressionInput>;
  /** Search by the user's name, either an exact match, in a defined set or by a partial match. */
  name?: Maybe<StringFilterExpressionInput>;
  /** Used to filter for a specific ID or IDs (refer to IDFilterExpressionInput for input options). */
  userId?: Maybe<IdFilterExpressionInput>;
};

/** Contains the details about a user. */
export type UserInput = {
  /** The timestamp of the user creation. */
  created?: Maybe<Scalars['DateTime']>;
  /** The user's email. */
  email?: Maybe<Scalars['String']>;
  /** True or False, whether the user has verified their email yet. */
  emailVerified?: Maybe<Scalars['Boolean']>;
  /** The unique ID of the user. */
  id?: Maybe<Scalars['String']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  loginsCount?: Maybe<Scalars['Long']>;
  /** The name of a user - this will be the full name, first and last. */
  name?: Maybe<Scalars['String']>;
  /** The user's nickname (often just the first name of the user). */
  nickname?: Maybe<Scalars['String']>;
  orgRoles?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Lists the user's roles, such as ADMIN or EXPLORER. */
  roles?: Maybe<Array<Maybe<RoleInput>>>;
  /** Timestamp when one or more user details were last updated. */
  updated?: Maybe<Scalars['DateTime']>;
};

export type UserOrgDetail = {
  __typename?: 'UserOrgDetail';
  orgId?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UserRemoveOrgMembershipRequestInput = {
  id?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['String']>;
};

export type UserRemoveOrgMembershipResponse = {
  __typename?: 'UserRemoveOrgMembershipResponse';
  _?: Maybe<Scalars['String']>;
};

/** Contains the input values needed to remove a role from a user. */
export type UserRemoveRoleRequestInput = {
  /** Provide the role you want to remove from the user here. */
  role?: Maybe<RoleInput>;
  /** Provide the id of the intended user here. */
  userId?: Maybe<Scalars['String']>;
};

export type UserRemoveRoleResponse = {
  __typename?: 'UserRemoveRoleResponse';
  user?: Maybe<User>;
};

/** Contains the input values needed to update a user. */
export type UserUpdateRequestInput = {
  /** Contains the input values for the user details, such as name, email and role. */
  user?: Maybe<UserInput>;
};

export type UserUpdateResponse = {
  __typename?: 'UserUpdateResponse';
  user?: Maybe<User>;
};

export type ValueLocation = {
  __typename?: 'ValueLocation';
  encoding?: Maybe<EncodingType>;
  form?: Maybe<BodyValueLocation>;
  header?: Maybe<Scalars['String']>;
  json?: Maybe<BodyValueLocation>;
  mappedDefault?: Maybe<Scalars['Boolean']>;
  queryParameter?: Maybe<Scalars['String']>;
};

export type ValueLocationInput = {
  encoding?: Maybe<EncodingTypeInput>;
  form?: Maybe<BodyValueLocationInput>;
  header?: Maybe<Scalars['String']>;
  json?: Maybe<BodyValueLocationInput>;
  mappedDefault?: Maybe<Scalars['Boolean']>;
  queryParameter?: Maybe<Scalars['String']>;
};

export type ValueMatch = {
  __typename?: 'ValueMatch';
  location?: Maybe<ValueLocation>;
  value?: Maybe<Scalars['String']>;
};

export type ValueMatchInput = {
  location?: Maybe<ValueLocationInput>;
  value?: Maybe<Scalars['String']>;
};

export type WebhookReceiver = {
  __typename?: 'WebhookReceiver';
  auth?: Maybe<Auth>;
  baseUri?: Maybe<Scalars['String']>;
  corsOptions?: Maybe<WebhookReceiverCorsOptions>;
  created?: Maybe<Scalars['DateTime']>;
  destination?: Maybe<WebhookReceiverDestination>;
  id?: Maybe<Scalars['String']>;
  incomingPayloadContentType?: Maybe<Scalars['String']>;
  metadata?: Maybe<Array<Maybe<MetadataRecord>>>;
  methods?: Maybe<Array<Maybe<HttpMethod>>>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  ownerType?: Maybe<WebhookReceiverOwnerType>;
  responseHeaders?: Maybe<Array<Maybe<WebhookReceiverResponseHeadersEntry>>>;
  responseMessage?: Maybe<Scalars['String']>;
  responseReflectedQueryParameter?: Maybe<Scalars['String']>;
  runId?: Maybe<Scalars['String']>;
  signalName?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  successHttpResponseCode?: Maybe<Scalars['Long']>;
  updated?: Maybe<Scalars['DateTime']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type WebhookReceiverCorsOptions = {
  __typename?: 'WebhookReceiverCORSOptions';
  allowCredentials?: Maybe<Scalars['Boolean']>;
  allowedHeaders?: Maybe<Array<Maybe<Scalars['String']>>>;
  allowedMethods?: Maybe<Array<Maybe<HttpMethod>>>;
  allowedOrigins?: Maybe<Array<Maybe<Scalars['String']>>>;
  exposedHeaders?: Maybe<Array<Maybe<Scalars['String']>>>;
  maxAge?: Maybe<Scalars['Int']>;
};

export type WebhookReceiverCorsOptionsInput = {
  allowCredentials?: Maybe<Scalars['Boolean']>;
  allowedHeaders?: Maybe<Array<Maybe<Scalars['String']>>>;
  allowedMethods?: Maybe<Array<Maybe<HttpMethodInput>>>;
  allowedOrigins?: Maybe<Array<Maybe<Scalars['String']>>>;
  exposedHeaders?: Maybe<Array<Maybe<Scalars['String']>>>;
  maxAge?: Maybe<Scalars['Int']>;
};

export type WebhookReceiverConnectorOwnerType = {
  __typename?: 'WebhookReceiverConnectorOwnerType';
  connectorId?: Maybe<Scalars['String']>;
  connectorTypeId?: Maybe<Scalars['String']>;
};

export type WebhookReceiverConnectorOwnerTypeInput = {
  connectorId?: Maybe<Scalars['String']>;
  connectorTypeId?: Maybe<Scalars['String']>;
};

export type WebhookReceiverDeleteRequestInput = {
  id?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  signalName?: Maybe<Scalars['String']>;
};

export type WebhookReceiverDeleteResponse = {
  __typename?: 'WebhookReceiverDeleteResponse';
  _?: Maybe<Scalars['String']>;
};

export type WebhookReceiverDestination = {
  __typename?: 'WebhookReceiverDestination';
  executeWorkflowDestination?: Maybe<WebhookReceiverTemporalExecuteWorkflowDestination>;
  kafkaDestination?: Maybe<WebhookReceiverKafkaDestination>;
  natsDestination?: Maybe<WebhookReceiverNatsDestination>;
  signalWorkflowDestination?: Maybe<WebhookReceiverTemporalSignalWorkfowDestination>;
};

export type WebhookReceiverDestinationInput = {
  executeWorkflowDestination?: Maybe<WebhookReceiverTemporalExecuteWorkflowDestinationInput>;
  kafkaDestination?: Maybe<WebhookReceiverKafkaDestinationInput>;
  natsDestination?: Maybe<WebhookReceiverNatsDestinationInput>;
  signalWorkflowDestination?: Maybe<WebhookReceiverTemporalSignalWorkfowDestinationInput>;
};

export type WebhookReceiverInput = {
  auth?: Maybe<AuthInput>;
  baseUri?: Maybe<Scalars['String']>;
  corsOptions?: Maybe<WebhookReceiverCorsOptionsInput>;
  created?: Maybe<Scalars['DateTime']>;
  destination?: Maybe<WebhookReceiverDestinationInput>;
  id?: Maybe<Scalars['String']>;
  incomingPayloadContentType?: Maybe<Scalars['String']>;
  metadata?: Maybe<Array<Maybe<MetadataRecordInput>>>;
  methods?: Maybe<Array<Maybe<HttpMethodInput>>>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  ownerType?: Maybe<WebhookReceiverOwnerTypeInput>;
  responseHeaders?: Maybe<Array<Maybe<WebhookReceiverResponseHeadersEntryInput>>>;
  responseMessage?: Maybe<Scalars['String']>;
  responseReflectedQueryParameter?: Maybe<Scalars['String']>;
  runId?: Maybe<Scalars['String']>;
  signalName?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  successHttpResponseCode?: Maybe<Scalars['Long']>;
  updated?: Maybe<Scalars['DateTime']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type WebhookReceiverKafkaDestination = {
  __typename?: 'WebhookReceiverKafkaDestination';
  key?: Maybe<Scalars['String']>;
  topic?: Maybe<Scalars['String']>;
};

export type WebhookReceiverKafkaDestinationInput = {
  key?: Maybe<Scalars['String']>;
  topic?: Maybe<Scalars['String']>;
};

export type WebhookReceiverNatsDestination = {
  __typename?: 'WebhookReceiverNATSDestination';
  subject?: Maybe<Scalars['String']>;
  subjectTemplate?: Maybe<Scalars['String']>;
  unspecified?: Maybe<Scalars['String']>;
};

export type WebhookReceiverNatsDestinationInput = {
  subject?: Maybe<Scalars['String']>;
  subjectTemplate?: Maybe<Scalars['String']>;
  unspecified?: Maybe<Scalars['String']>;
};

export type WebhookReceiverNamedOwnerType = {
  __typename?: 'WebhookReceiverNamedOwnerType';
  name?: Maybe<Scalars['String']>;
};

export type WebhookReceiverNamedOwnerTypeInput = {
  name?: Maybe<Scalars['String']>;
};

export type WebhookReceiverOwnerType = {
  __typename?: 'WebhookReceiverOwnerType';
  connectorOwner?: Maybe<WebhookReceiverConnectorOwnerType>;
  namedOwner?: Maybe<WebhookReceiverNamedOwnerType>;
  unspecified?: Maybe<Scalars['String']>;
};

export type WebhookReceiverOwnerTypeInput = {
  connectorOwner?: Maybe<WebhookReceiverConnectorOwnerTypeInput>;
  namedOwner?: Maybe<WebhookReceiverNamedOwnerTypeInput>;
  unspecified?: Maybe<Scalars['String']>;
};

export type WebhookReceiverResponseHeadersEntry = {
  __typename?: 'WebhookReceiverResponseHeadersEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type WebhookReceiverResponseHeadersEntryInput = {
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type WebhookReceiverTemporalExecuteWorkflowDestination = {
  __typename?: 'WebhookReceiverTemporalExecuteWorkflowDestination';
  taskQueue?: Maybe<Scalars['String']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type WebhookReceiverTemporalExecuteWorkflowDestinationInput = {
  taskQueue?: Maybe<Scalars['String']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type WebhookReceiverTemporalSignalWorkfowDestination = {
  __typename?: 'WebhookReceiverTemporalSignalWorkfowDestination';
  runId?: Maybe<Scalars['String']>;
  signalName?: Maybe<Scalars['String']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type WebhookReceiverTemporalSignalWorkfowDestinationInput = {
  runId?: Maybe<Scalars['String']>;
  signalName?: Maybe<Scalars['String']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type WebhookReceiverUpsertRequestInput = {
  receiver?: Maybe<WebhookReceiverInput>;
};

export type WebhookReceiverUpsertResponse = {
  __typename?: 'WebhookReceiverUpsertResponse';
  receiver?: Maybe<WebhookReceiver>;
};

/** Contains the input values needed to create a webhook target. */
export type WebhookTarget = {
  __typename?: 'WebhookTarget';
  batchedContentModeConfig?: Maybe<WebhookTargetCloudEventBatchedContentModeConfig>;
  contentMode?: Maybe<WebhookTargetCloudEventContentMode>;
  /** True/False Boolean field used to enable or disable a webhook. */
  enabled?: Maybe<Scalars['Boolean']>;
  eventExtensions?: Maybe<Scalars['GraphQLJSON']>;
  /** Fields for eventFilters define what you data you want the webhook to send to your endpoint. */
  eventFilters?: Maybe<WebhookTargetEventFilter>;
  /** Fields for httpTarget define the details of the endpoint where data will be sent. */
  httpTarget?: Maybe<WebhookTargetHttpTarget>;
  /** The unique ID of the webhook. */
  id?: Maybe<Scalars['String']>;
  /** This defines how many times we will attempt to send a webhook payload before giving up if we don't get a 200 OK response. */
  maxRetry?: Maybe<Scalars['Long']>;
  metadata?: Maybe<Array<Maybe<WebhookTargetMetadataEntry>>>;
  /** This is the unique name of the webhook; this should include details about the data being sent, to differentiate it from other webhooks. */
  name?: Maybe<Scalars['String']>;
  /** The organization the webhook belongs to; this is automatically defined by the user creating the webhook. */
  organization?: Maybe<Org>;
  /** The details of the user creating the webhook; this is also automatically defined during the webhook creation. */
  user?: Maybe<User>;
};

export type WebhookTargetAuth = {
  __typename?: 'WebhookTargetAuth';
  apiKey?: Maybe<ApiKey>;
  basicAuth?: Maybe<BasicAuth>;
  noAuth?: Maybe<Scalars['Boolean']>;
  oauth2ClientCredentialsFlow?: Maybe<OAuth2ClientCredentialsFlow>;
};

export type WebhookTargetAuthInput = {
  apiKey?: Maybe<ApiKeyInput>;
  basicAuth?: Maybe<BasicAuthInput>;
  noAuth?: Maybe<Scalars['Boolean']>;
  oauth2ClientCredentialsFlow?: Maybe<OAuth2ClientCredentialsFlowInput>;
};

export type WebhookTargetCloudEventBatchedContentModeConfig = {
  __typename?: 'WebhookTargetCloudEventBatchedContentModeConfig';
  gracePeriod?: Maybe<Duration>;
  maxDelay?: Maybe<Duration>;
  maxSize?: Maybe<Scalars['Long']>;
};

export type WebhookTargetCloudEventBatchedContentModeConfigInput = {
  gracePeriod?: Maybe<DurationInput>;
  maxDelay?: Maybe<DurationInput>;
  maxSize?: Maybe<Scalars['Long']>;
};

export enum WebhookTargetCloudEventContentMode {
  Batched = 'BATCHED',
  Binary = 'BINARY',
  CloudeventcontentmodeUnspecified = 'CLOUDEVENTCONTENTMODE_UNSPECIFIED',
  Structured = 'STRUCTURED'
}

export enum WebhookTargetCloudEventContentModeInput {
  Batched = 'BATCHED',
  Binary = 'BINARY',
  CloudeventcontentmodeUnspecified = 'CLOUDEVENTCONTENTMODE_UNSPECIFIED',
  Structured = 'STRUCTURED'
}

export type WebhookTargetCloudEventContentModeWrapperInput = {
  value?: Maybe<WebhookTargetCloudEventContentModeInput>;
};

export type WebhookTargetCloudEventFilter = {
  __typename?: 'WebhookTargetCloudEventFilter';
  and?: Maybe<Array<Maybe<WebhookTargetCloudEventFilter>>>;
  not?: Maybe<Array<Maybe<WebhookTargetCloudEventFilter>>>;
  or?: Maybe<Array<Maybe<WebhookTargetCloudEventFilter>>>;
  sources?: Maybe<Array<Maybe<Scalars['String']>>>;
  types?: Maybe<Array<Maybe<CloudEventSourceType>>>;
};

export type WebhookTargetCloudEventFilterInput = {
  and?: Maybe<Array<Maybe<WebhookTargetCloudEventFilterInput>>>;
  not?: Maybe<Array<Maybe<WebhookTargetCloudEventFilterInput>>>;
  or?: Maybe<Array<Maybe<WebhookTargetCloudEventFilterInput>>>;
  sources?: Maybe<Array<Maybe<Scalars['String']>>>;
  types?: Maybe<Array<Maybe<CloudEventSourceTypeInput>>>;
};

export type WebhookTargetCreateInput = {
  batchedContentModeConfig?: Maybe<WebhookTargetCloudEventBatchedContentModeConfigInput>;
  contentMode?: Maybe<WebhookTargetCloudEventContentModeInput>;
  enabled?: Maybe<Scalars['Boolean']>;
  eventExtensions?: Maybe<Scalars['GraphQLJSON']>;
  eventFilters?: Maybe<WebhookTargetEventFilterInput>;
  httpTarget?: Maybe<WebhookTargetHttpTargetInput>;
  maxRetry?: Maybe<Scalars['Long']>;
  name?: Maybe<Scalars['String']>;
};

export type WebhookTargetCreateRequestInput = {
  target?: Maybe<WebhookTargetCreateInput>;
};

export type WebhookTargetCreateResponse = {
  __typename?: 'WebhookTargetCreateResponse';
  target?: Maybe<WebhookTarget>;
};

export type WebhookTargetDeleteRequestInput = {
  id?: Maybe<Scalars['String']>;
};

export type WebhookTargetDeleteResponse = {
  __typename?: 'WebhookTargetDeleteResponse';
  _?: Maybe<Scalars['String']>;
};

export type WebhookTargetEnableRequestInput = {
  enable?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
};

export type WebhookTargetEnableResponse = {
  __typename?: 'WebhookTargetEnableResponse';
  currentEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  previousEnabled?: Maybe<Scalars['Boolean']>;
};

export type WebhookTargetEventFilter = {
  __typename?: 'WebhookTargetEventFilter';
  /** Currently in development. */
  cloudEventFilter?: Maybe<WebhookTargetCloudEventFilter>;
  /** Input the JSON Expression for the filter input you want here. */
  jsonExpressionFilter?: Maybe<WebhookTargetJsonExpressionFilter>;
  /** Currently in development. */
  timeseriesFilter?: Maybe<WebhookTargetTimeseriesFilter>;
};

export type WebhookTargetEventFilterInput = {
  /** Currently in development. */
  cloudEventFilter?: Maybe<WebhookTargetCloudEventFilterInput>;
  /** Input the JSON Expression for the filter input you want here. */
  jsonExpressionFilter?: Maybe<WebhookTargetJsonExpressionFilterInput>;
  /** Currently in development. */
  timeseriesFilter?: Maybe<WebhookTargetTimeseriesFilterInput>;
};

export type WebhookTargetEventFilterTypeExpressionInput = {
  eq?: Maybe<WebhookTargetEventFilterTypeInput>;
  in?: Maybe<Array<Maybe<WebhookTargetEventFilterTypeInput>>>;
};

export enum WebhookTargetEventFilterTypeInput {
  Cloudevent = 'CLOUDEVENT',
  EventfiltertypeUnspecified = 'EVENTFILTERTYPE_UNSPECIFIED',
  Jsonexpression = 'JSONEXPRESSION',
  Timeseries = 'TIMESERIES'
}

export type WebhookTargetFilterInput = {
  and?: Maybe<Array<Maybe<WebhookTargetFilterInput>>>;
  contentMode?: Maybe<WebhookTargetCloudEventContentModeInput>;
  enabled?: Maybe<BoolFilterExpressionInput>;
  eventFilterType?: Maybe<WebhookTargetEventFilterTypeExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  not?: Maybe<Array<Maybe<WebhookTargetFilterInput>>>;
  or?: Maybe<Array<Maybe<WebhookTargetFilterInput>>>;
  targetId?: Maybe<IdFilterExpressionInput>;
  targetType?: Maybe<WebhookTargetTargetTypeExpressionInput>;
  userId?: Maybe<IdFilterExpressionInput>;
};

export type WebhookTargetHttpTarget = {
  __typename?: 'WebhookTargetHTTPTarget';
  auth?: Maybe<WebhookTargetAuth>;
  hmac256?: Maybe<Hmac256>;
  method?: Maybe<HttpMethod>;
  targetUri?: Maybe<Scalars['String']>;
};

export type WebhookTargetHttpTargetGranularInput = {
  auth?: Maybe<WebhookTargetAuthInput>;
  hmac256?: Maybe<StringArrayUpdateInput>;
  method?: Maybe<HttpMethodWrapperInput>;
  targetUri?: Maybe<Scalars['String']>;
};

export type WebhookTargetHttpTargetInput = {
  auth?: Maybe<WebhookTargetAuthInput>;
  hmac256?: Maybe<Hmac256Input>;
  method?: Maybe<HttpMethodInput>;
  targetUri?: Maybe<Scalars['String']>;
};

export type WebhookTargetHttpTargetUpdateInput = {
  granular?: Maybe<WebhookTargetHttpTargetGranularInput>;
  replace?: Maybe<WebhookTargetHttpTargetInput>;
};

export type WebhookTargetJsonExpressionFilter = {
  __typename?: 'WebhookTargetJsonExpressionFilter';
  jsonPathExpression?: Maybe<Scalars['String']>;
};

export type WebhookTargetJsonExpressionFilterInput = {
  jsonPathExpression?: Maybe<Scalars['String']>;
};

export type WebhookTargetMetadataEntry = {
  __typename?: 'WebhookTargetMetadataEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type WebhookTargetTargetTypeExpressionInput = {
  eq?: Maybe<WebhookTargetTargetTypeInput>;
  in?: Maybe<Array<Maybe<WebhookTargetTargetTypeInput>>>;
};

export enum WebhookTargetTargetTypeInput {
  Http = 'HTTP',
  TargettypeUnspecified = 'TARGETTYPE_UNSPECIFIED'
}

export type WebhookTargetTimeseriesFilter = {
  __typename?: 'WebhookTargetTimeseriesFilter';
  points?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WebhookTargetTimeseriesFilterInput = {
  points?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WebhookTargetUpdateInput = {
  batchedContentModeConfig?: Maybe<WebhookTargetCloudEventBatchedContentModeConfigInput>;
  contentMode?: Maybe<WebhookTargetCloudEventContentModeWrapperInput>;
  enabled?: Maybe<Scalars['Boolean']>;
  eventExtensions?: Maybe<Scalars['GraphQLJSON']>;
  eventFilters?: Maybe<WebhookTargetEventFilterInput>;
  httpTarget?: Maybe<WebhookTargetHttpTargetUpdateInput>;
  id?: Maybe<Scalars['String']>;
  maxRetry?: Maybe<Scalars['Long']>;
  metadata?: Maybe<MetadataUpdateInput>;
  name?: Maybe<Scalars['String']>;
};

export type WebhookTargetUpdateRequestInput = {
  target?: Maybe<WebhookTargetUpdateInput>;
};

export type WebhookTargetUpdateResponse = {
  __typename?: 'WebhookTargetUpdateResponse';
  target?: Maybe<WebhookTarget>;
};

export type WorkOrder = GraphNode & {
  __typename?: 'WorkOrder';
  connectedDataSourceId?: Maybe<Scalars['String']>;
  dateClosed?: Maybe<Scalars['DateTime']>;
  dateCompleted?: Maybe<Scalars['DateTime']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  exactType?: Maybe<Scalars['String']>;
  externalDateCreated?: Maybe<Scalars['DateTime']>;
  externalDateUpdated?: Maybe<Scalars['DateTime']>;
  hasAssignedGroup?: Maybe<PeopleGroup>;
  hasAssignedGroupEdges?: Maybe<Array<Maybe<HasAssignedGroupEdge>>>;
  hasAssignee?: Maybe<Array<Maybe<Person>>>;
  hasAssigneeEdges?: Maybe<Array<Maybe<HasAssigneeEdge>>>;
  id: Scalars['String'];
  identities?: Maybe<Array<Maybe<WorkOrderIdentityUnion>>>;
  isClosedBy?: Maybe<Person>;
  isClosedByEdges?: Maybe<Array<Maybe<IsClosedByEdge>>>;
  isCreatedBy?: Maybe<Person>;
  isCreatedByEdges?: Maybe<Array<Maybe<IsCreatedByEdge>>>;
  isReportedBy?: Maybe<Person>;
  isReportedByEdges?: Maybe<Array<Maybe<IsReportedByEdge>>>;
  jobPriority?: Maybe<Scalars['String']>;
  jobStatus?: Maybe<Scalars['String']>;
  jobSubStatus?: Maybe<Scalars['String']>;
  jobType?: Maybe<Scalars['String']>;
  mappingKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  problemDescription?: Maybe<Scalars['String']>;
  referenceUrl?: Maybe<Scalars['String']>;
  relatesTo?: Maybe<Array<Maybe<RelatesToUnion>>>;
  relatesToEdges?: Maybe<Array<Maybe<RelatesToEdge>>>;
  resolutionDescription?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type WorkOrderHasAssignedGroupArgs = {
  filter?: Maybe<PeopleGroupFilter>;
};


export type WorkOrderHasAssigneeArgs = {
  filter?: Maybe<PersonFilter>;
};


export type WorkOrderIsClosedByArgs = {
  filter?: Maybe<PersonFilter>;
};


export type WorkOrderIsCreatedByArgs = {
  filter?: Maybe<PersonFilter>;
};


export type WorkOrderIsReportedByArgs = {
  filter?: Maybe<PersonFilter>;
};


export type WorkOrderRelatesToArgs = {
  filter?: Maybe<EntityFilter>;
};

export type WorkOrderFilter = {
  and?: Maybe<Array<Maybe<WorkOrderFilter>>>;
  connectedDataSourceId?: Maybe<StringFilterExpressionInput>;
  dateCreated?: Maybe<TimestampFilterExpressionInput>;
  dateUpdated?: Maybe<TimestampFilterExpressionInput>;
  exactType?: Maybe<StringFilterExpressionInput>;
  id?: Maybe<IdFilterExpressionInput>;
  mappingKey?: Maybe<StringFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  not?: Maybe<WorkOrderFilter>;
  or?: Maybe<Array<Maybe<WorkOrderFilter>>>;
  type?: Maybe<StringArrayFilterExpressionInput>;
};

export type WorkOrderIdentityUnion = AccessCredentialIdentity | BaCnetObjectId | BaCnetVendorId | EmailAddressIdentity | EmailIdentity | ExternalIdentity | FloorLevelIdentity | GenericIdentity | NameIdentity | PostalAddressIdentity | SpaceCode | SubBuildingCode;

export type Zone = GraphNode & Place & ThingContainer & {
  __typename?: 'Zone';
  calendarEvents?: Maybe<Array<Maybe<CalendarEvent>>>;
  collections?: Maybe<Array<Maybe<Collection>>>;
  connectedDataSourceId?: Maybe<Scalars['String']>;
  connectors?: Maybe<Array<Maybe<Connector>>>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  exactType?: Maybe<Scalars['String']>;
  geoshape?: Maybe<Scalars['GeoJSON']>;
  grossArea?: Maybe<AreaQuantity>;
  grossAreaEdges?: Maybe<Array<Maybe<GrossAreaEdge>>>;
  hasPart?: Maybe<Array<Maybe<Place>>>;
  hasPartEdges?: Maybe<Array<Maybe<HasPartEdge>>>;
  hasPoint?: Maybe<Array<Maybe<Point>>>;
  hasPointEdges?: Maybe<Array<Maybe<HasPointEdge>>>;
  id: Scalars['String'];
  identities?: Maybe<Array<Maybe<ZoneIdentityUnion>>>;
  isAdjacentTo?: Maybe<Array<Maybe<Place>>>;
  isAdjacentToEdges?: Maybe<Array<Maybe<IsAdjacentToEdge>>>;
  isFedBy?: Maybe<Array<Maybe<Thing>>>;
  isFedByEdges?: Maybe<Array<Maybe<IsFedByEdge>>>;
  isLocationOf?: Maybe<Array<Maybe<IsLocationOfUnion>>>;
  isLocationOfEdges?: Maybe<Array<Maybe<IsLocationOfEdge>>>;
  isPartOf?: Maybe<Array<Maybe<Place>>>;
  isPartOfEdges?: Maybe<Array<Maybe<IsPartOfEdge>>>;
  isServedBy?: Maybe<Array<Maybe<Thing>>>;
  isServedByEdges?: Maybe<Array<Maybe<IsServedByEdge>>>;
  mappingKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  points?: Maybe<Array<Maybe<Point>>>;
  rentableArea?: Maybe<AreaQuantity>;
  rentableAreaEdges?: Maybe<Array<Maybe<RentableAreaEdge>>>;
  things?: Maybe<Array<Maybe<Thing>>>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
  usableArea?: Maybe<AreaQuantity>;
  usableAreaEdges?: Maybe<Array<Maybe<UsableAreaEdge>>>;
};


export type ZoneCalendarEventsArgs = {
  filter?: Maybe<CalendarEventFilter>;
};


export type ZoneCollectionsArgs = {
  filter?: Maybe<CollectionFilter>;
};


export type ZoneConnectorsArgs = {
  filter?: Maybe<ConnectorFilterInput>;
};


export type ZoneGrossAreaArgs = {
  filter?: Maybe<AreaQuantityFilter>;
};


export type ZoneHasPartArgs = {
  filter?: Maybe<PlaceFilter>;
};


export type ZoneHasPointArgs = {
  filter?: Maybe<PointFilter>;
};


export type ZoneIsAdjacentToArgs = {
  filter?: Maybe<PlaceFilter>;
};


export type ZoneIsFedByArgs = {
  filter?: Maybe<ThingFilter>;
};


export type ZoneIsLocationOfArgs = {
  filter?: Maybe<EntityFilter>;
};


export type ZoneIsPartOfArgs = {
  filter?: Maybe<PlaceFilter>;
};


export type ZoneIsServedByArgs = {
  filter?: Maybe<ThingFilter>;
};


export type ZonePointsArgs = {
  filter?: Maybe<PointFilter>;
};


export type ZoneRentableAreaArgs = {
  filter?: Maybe<AreaQuantityFilter>;
};


export type ZoneThingsArgs = {
  filter?: Maybe<ThingFilter>;
};


export type ZoneUsableAreaArgs = {
  filter?: Maybe<AreaQuantityFilter>;
};

export type ZoneFilter = {
  and?: Maybe<Array<Maybe<ZoneFilter>>>;
  connectedDataSourceId?: Maybe<StringFilterExpressionInput>;
  dateCreated?: Maybe<TimestampFilterExpressionInput>;
  dateUpdated?: Maybe<TimestampFilterExpressionInput>;
  exactType?: Maybe<StringFilterExpressionInput>;
  id?: Maybe<IdFilterExpressionInput>;
  mappingKey?: Maybe<StringFilterExpressionInput>;
  name?: Maybe<StringFilterExpressionInput>;
  not?: Maybe<ZoneFilter>;
  or?: Maybe<Array<Maybe<ZoneFilter>>>;
  type?: Maybe<StringArrayFilterExpressionInput>;
};

export type ZoneIdentityUnion = AccessCredentialIdentity | BaCnetObjectId | BaCnetVendorId | EmailAddressIdentity | EmailIdentity | ExternalIdentity | FloorLevelIdentity | GenericIdentity | NameIdentity | PostalAddressIdentity | SpaceCode | SubBuildingCode;
